import React, { useContext, useEffect, useRef, useState } from 'react'
import './Bill.css'
import { ToastContainer, toast } from 'react-toastify';
import back from "../../imgs/backexam.png";
import axios from 'axios';
import { useFetcher, useNavigate } from 'react-router-dom';
import { UilEditAlt, UilTrash, UilSetting, UilRefresh } from '@iconscout/react-unicons'
import Globalcontext from '../../Context/Globalcontext';
import Status from "../../imgs/statusmob.jpeg";
import { useTranslation } from "react-i18next";

const Bill = (props) => {
  const { t } = useTranslation();

  const [input, setInput] = useState({ date1: "", date2: new Date().toISOString().substr(0, 10), knofrom: "", knoto: "", knofromprint: "", knotoprint: "", ikapatnote: "कपात नोट", mobileuser: "", search: "1", name: "", billamt: "", tliter: "", thevkapat: "", madv: "", cadv: "", advkapat: "", newadv: "", mkhadya: "", ckhadya: "", khadyakapat: "", newkhadya: "", ikapatbill: "", vahtuk: "", ada: "" });
  const [totalvalue, setTotalvalue] = useState({
    1: "", 2: "", 3: "", 4: "", 5: "", 6: "", 7: "", 8: "", 9: "", 10: "",
    11: "", 12: "", 13: "", 14: "", 15: "", 16: "", 17: "", 18: "", 19: "", 20: "",
    21: "", 22: "", 23: "", 24: "", 25: "", 26: "", 27: "", 28: "", 29: "", 30: "",
    31: "", 32: "", 33: "", 34: "", 35: "", 36: "", 37: "", 38: "", 39: "", 40: "",
    41: "", 42: "", 43: "", 44: "", 45: "", 46: "", 47: "", 48: "", 49: "", 50: "",
  });
  const afterSaveRef = useRef(false);
  const inputRefs = useRef([]);
  const [DataSource, setDataSource] = useState([]);
  const [kapat, setKapat] = useState({});
  const [tableFilter, setTableFilter] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [print, setprint] = useState(false);
  const [showUpdate, setShowupdate] = useState(false);
  const [first, setfirst] = useState("false");
  const [refresh, setRefresh] = useState("false");
  const cellRefs = useRef([]);
  const [value, setValue] = useState('');
  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);
  //const [customerData, setCustomerData] = useState([]);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  let updatedDataSource = [];
  const [updatedDataSource2, setUpdatedDataSource2] = useState([]);
  const refdelete = useRef(null);
  const refdeleteclose = useRef(null);
  const refdeletesingle = useRef(null);
  const refdeletesingleclose = useRef(null);
  const reftrailprint = useRef(null);
  const reftrailprintclose = useRef(null);
  const refsearch = useRef(null);
  const refsearchclose = useRef(null);
  const [showthevcol, setShowthevcol] = useState("No");
  const [showother, setShowother] = useState("Yes");
  const [showthev, setShowthev] = useState("Yes");
  const [wait, setWait] = useState(false);
  const [wait2, setWait2] = useState(false);
  const [waittran, setWaittran] = useState(false);
  const [waitsave, setWaitsave] = useState(false);
  const [waitprint, setWaitprint] = useState(false);
  const [waitprinttest, setWaitprinttest] = useState(false);
  const [waitsearch, setWaitsearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const { customerData, setCustomerData } = useContext(Globalcontext);
  const refprint = useRef(null);
  const refprintclose = useRef(null);
  const [rtype, setRtype] = useState("2");
  const [design, setDesign] = useState("1");
  const [count, setCount] = useState(10);
  const [isCounting, setIsCounting] = useState(false);
  const [kno1, setKno1] = useState(1);
  const [kno2, setKno2] = useState(2);
  const [isFetching, setIsFetching] = useState(false);
  const [mobileusers, setMobileusers] = useState([]);
  const [lastdate1, setLastdate1] = useState("");
  const [lastdate2, setLastdate2] = useState("");
  const today = new Date().toISOString().split('T')[0];
  const cancelRef = useRef(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  let index2 = 0;

  const handleIsfetching = () => {
    setDataSource([]);
    if (isFetching === "true") {
      setIsFetching("false");
    }
    else {
      setIsFetching("true");
    }
  }

  useEffect(() => {

    if (isFetching === "true") {
      getbill();
    }

  }, [isFetching])


  function addTotalRow(tableId) {
    const table = document.getElementById(tableId);
    if (!table) return;

    const tbody = table.tBodies[0];
    const rows = Array.from(tbody.rows);
    if (rows.length === 0) return;

    // 1) Determine total number of columns from your React state
    //    (assumes totalvalue is in scope)
    const colCount = Object.keys(totalvalue).length;

    // 2) Grab whatever header <th> classNames exist, pad to colCount
    const headerCells = table.tHead?.rows[0]?.cells || [];
    const headerClasses = Array.from(headerCells).map(th => th.className);
    while (headerClasses.length < colCount) {
      headerClasses.push("");
    }

    // 3) Calculate sums, iterating up to colCount and treating missing cells as zero
    const sums = Array(colCount).fill(0);
    rows.forEach(row => {
      for (let i = 0; i < colCount; i++) {
        const cell = row.cells[i];
        let raw = "";
        if (cell) {
          const input = cell.querySelector("input");
          raw = input ? input.value : cell.textContent;
        }
        const num = parseFloat(raw.replace(/,/g, "")) || 0;
        sums[i] += num;
      }
    });

    // 4) Push into React state
    const newTotals = sums.reduce((acc, sum, idx) => {
      acc[idx + 1] = sum.toFixed(2);
      return acc;
    }, {});
    setTotalvalue(newTotals);

    // 5) Render the total row in <tfoot>, mirroring headerClasses
    const tfoot = table.tFoot || table.createTFoot();
    tfoot.innerHTML = "";
    const tr = tfoot.insertRow();
    tr.style.fontWeight = "bold";
    tr.style.backgroundColor = "#eee";

    for (let i = 0; i < colCount; i++) {
      const th = document.createElement("th");
      th.className = headerClasses[i];
      th.textContent = i === 0 ? "Total" : sums[i].toFixed(2);
      tr.appendChild(th);
    }
  }

  function addZeroTotalRow(tableId) {
    const table = document.getElementById(tableId);
    if (!table) return;

    // Grab header classes for styling
    const headerCells = table.tHead?.rows[0]?.cells;
    if (!headerCells) return;
    const colCount = headerCells.length;
    const headerClasses = Array.from(headerCells).map(th => th.className);

    // Build zero array for each column
    const zeros = Array(colCount).fill(0);

    // 1) Push into React state
    // Build an object { 1: "0.00", 2: "0.00", … }
    const newTotals = zeros.reduce((acc, _, idx) => {
      acc[idx + 1] = '0.00';
      return acc;
    }, {});
    setTotalvalue(newTotals);

    // 2) Render the zero-row in <tfoot>
    const tfoot = table.tFoot || table.createTFoot();
    tfoot.innerHTML = '';
    const tr = tfoot.insertRow();
    tr.style.fontWeight = 'bold';
    tr.style.backgroundColor = '#eee';

    for (let i = 0; i < colCount; i++) {
      const th = document.createElement('th');
      th.className = headerClasses[i] || '';
      th.textContent = i === 0 ? 'Total' : '0.00';
      tr.appendChild(th);
    }
  }



  const handlertype = (event, value) => {

    if (value === 1) {
      setRtype("1");
      setDesign("1");
    }
    else if (value === 2) {
      setRtype("2");
      setDesign("1");
    }
    else if (value === 3) {
      setRtype("3");
      setDesign("2");
    }
    else if (value === 4) {
      setRtype("4");
      setDesign("1");
    }
    else if (value === 5) {
      setRtype("5");
      setDesign("1");
    }
    else if (value === 6) {
      setRtype("6");
      setDesign("2");
    }
  }

  async function getmobileusers() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    axios.post('https://excellentdairy.com/dairy/php/cust/getmobileusers.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
      if (response.data) {
        setMobileusers(response.data);
      }
    }).catch(err => {
      console.log(err);
    });
  }


  useEffect(() => {
    if (input.knofrom !== "1") {
      setInput((prevInputSettings) => ({
        ...prevInputSettings,
        knoto: input.knofrom,
      }));
    }
    else {
      getmaxno();
    }
  }, [input.knofrom])

  // useEffect(()=>{
  //   if(input.knofrom === input.knoto)
  //   {
  //     setRefresh("true");
  //   }
  //   else {
  //     setRefresh("false");
  //   }
  // },[input.knoto])

  const handleDelete = () => {
    refdelete.current.click();
  }

  const handledeleteclose = () => {
    refdeleteclose.current.click();
  }

  const handleDeletesingle = () => {
    refdeletesingle.current.click();
  }

  const handledeletesingleclose = () => {
    refdeletesingleclose.current.click();
  }

  const handlePrint = () => {
    refprint.current.click();
  }
  const handleprintclose = () => {
    refprintclose.current.click();
  }

  const handleprinttrial = () => {
    reftrailprint.current.click();
  }

  const handleprinttrialclose = () => {
    reftrailprintclose.current.click();
  }

  const handlesearch = () => {
    refsearch.current.click();
  }

  const handlesearchclose = () => {
    setWaitsearch(false);
    refsearchclose.current.click();
  }

  const fetchtabledata = () => {
    try {
      const table = document.getElementById('myTablebill');
      const rows = table.getElementsByTagName('tr');

      const data = [];

      for (let i = 1; i < rows.length - 1; i++) { // Start from 1 to skip header row
        const row = rows[i];
        const cells = row.getElementsByTagName('td');

        const rowData = {
          // Assuming the order of cells matches your column order
          date1: input.date1,
          date2: input.date2,
          kno: cells[0].textContent,
          bill: cells[2].textContent,
          tliter: cells[3].textContent,
          magilthev: cells[4].textContent,
          cthev: cells[5].textContent,
          newthev: cells[6].textContent,

          magilthevitr1: cells[7].textContent,
          cthevitr1: cells[8].textContent,
          newthevitr1: cells[9].textContent,

          magilthevitr2: cells[10].textContent,
          cthevitr2: cells[11].textContent,
          newthevitr2: cells[12].textContent,

          magilthevitr3: cells[13].textContent,
          cthevitr3: cells[14].textContent,
          newthevitr3: cells[15].textContent,

          madv: cells[16].textContent,
          cadv: cells[17].textContent,
          tadv: cells[18].textContent,
          advcut: cells[19].textContent,
          newadv: cells[20].textContent,
          mkhadya: cells[21].textContent,
          ckhadya: cells[22].textContent,
          tkhadya: cells[23].textContent,
          khadyacut: cells[24].textContent,
          newkhadya: cells[25].textContent,
          mratib: cells[26].textContent,
          cratib: cells[27].textContent,
          tratib: cells[28].textContent,
          ratibkapat: cells[29].textContent,
          newratib: cells[30].textContent,
          mkarj: cells[31].textContent,
          ckarj: cells[32].textContent,
          tkarj: cells[33].textContent,
          karjhpta: cells[34].textContent,
          karjintr: cells[35].textContent,
          newkarj: cells[36].textContent,
          magilsangh: cells[37].textContent,
          csangh: cells[38].textContent,
          tsangh: cells[39].textContent,
          sanghkapat: cells[40].textContent,
          newsangh: cells[41].textContent,
          magilbhishi: cells[42].textContent,
          cbhishi: cells[43].textContent,
          newbhishi: cells[44].textContent,
          ikapatliter: cells[45].textContent,
          ikapatbill: cells[46].textContent,
          magilretanmedi: cells[47].textContent,
          cretanmedi: cells[48].textContent,
          tretanmedi: cells[49].textContent,
          retan: cells[50].textContent,
          medi: cells[51].textContent,
          newretanmedi: cells[52].textContent,
          itrkapat1: cells[53].textContent,
          itrkapat2: cells[54].textContent,
          itrkapat3: cells[55].textContent,

          vah: cells[56].textContent,
          comm: cells[57].textContent,
          ada: cells[58].textContent
        };
        data.push(rowData);
      }


      const insertQuery = `INSERT INTO bill (date1, date2, kno, billamt,magilthev,cthev,newthev,magilthevitr1,cthevitr1,newthevitr1,magilthevitr2,cthevitr2,newthevitr2,magilthevitr3,cthevitr3,newthevitr3,madv,cadv,tadv,advkapat,newadv,mkhadya,ckhadya,tkhadya,khadyakapat,newkhadya,mratib,cratib,tratib,ratibkapat,newratib,mkarj,ckarj,tkarj,karjhpta,karjintr,newkarj,magilsangh,csangh,tsangh,sanghkapat,newsangh,magilbhishi,cbhishi,newbhishi,ikapatliter,ikapatbill,magilretanmedi,cretanmedi,tretanmedi,retan,medi,newretanmedi,itrkapat1,itrkapat2,itrkapat3,vah,comm,ada,mainuser) VALUES
      ${data.map(row => `('${row.date1}', '${row.date2}', '${row.kno}', '${row.bill}','${row.magilthev}','${row.cthev}','${row.newthev}','${row.magilthevitr1}','${row.cthevitr1}','${row.newthevitr1}','${row.magilthevitr2}','${row.cthevitr2}','${row.newthevitr2}','${row.magilthevitr3}','${row.cthevitr3}','${row.newthevitr3}','${row.madv}', '${row.cadv}', '${row.tadv}', '${row.advcut}','${row.newadv}','${row.mkhadya}', '${row.ckhadya}', '${row.tkhadya}', '${row.khadyacut}','${row.newkhadya}','${row.mratib}', '${row.cratib}', '${row.tratib}', '${row.ratibkapat}','${row.newratib}','${row.mkarj}','${row.ckarj}','${row.tkarj}','${row.karjhpta}','${row.karjintr}','${row.newkarj}','${row.magilsangh}','${row.csangh}','${row.tsangh}','${row.sanghkapat}','${row.newsangh}','${row.magilbhishi}','${row.cbhishi}','${row.newbhishi}','${row.ikapatliter}','${row.ikapatbill}','${row.magilretanmedi}','${row.cretanmedi}','${row.tretanmedi}','${row.retan}','${row.medi}','${row.newretanmedi}','${row.itrkapat1}','${row.itrkapat2}','${row.itrkapat3}','${row.vah}','${row.comm}','${row.ada}','${localStorage.getItem("contact")}')`).join(', ')}`;
      const updateQuery = '123';


      if (input.knofrom === input.knoto) {
        savebillsingle(insertQuery, updateQuery, data);
      }
      else {
        savebill(insertQuery, updateQuery, data);
      }
    }
    catch {
    }
  }

  const transferaudit = () => {
    setWaittran(true);
    try {
      const data = [];

      // 1) Define metadata for each field
      const fieldMeta = [
        { key: "thevregular", au: "thevregularau", label: "Credit" },
        { key: "thev1", au: "thev1au", label: "Credit" },
        { key: "thev2", au: "thev2au", label: "Credit" },
        { key: "thev3", au: "thev3au", label: "Credit" },
        { key: "advchalu", au: "advchaluau", label: "Debit" },
        { key: "advkapat", au: "advkapatau", label: "Credit" },
        { key: "khchalu", au: "khchaluau", label: "Debit" },
        { key: "khkapat", au: "khkapatau", label: "Credit" },
        { key: "ratibchalu", au: "ratibchaluau", label: "Debit" },
        { key: "ratibkapat", au: "ratibkapatau", label: "Credit" },
        { key: "karjchalu", au: "karjchaluau", label: "Debit" },
        { key: "hptachalu", au: "hptachaluau", label: "Credit" },
        { key: "intrchalu", au: "intrchaluau", label: "Credit" },
        { key: "sanghkchalu", au: "sanghkchaluau", label: "Debit" },
        { key: "sanghkkapat", au: "sanghkkapatau", label: "Credit" },
        { key: "ikapat", au: "ikapatau", label: "Credit" },
        { key: "retanchalu", au: "retanchaluau", label: "Debit" },
        { key: "retankapat", au: "retankapatau", label: "Credit" },
        { key: "kapat1", au: "kapat1au", label: "Credit" },
        { key: "kapat2", au: "kapat2au", label: "Credit" },
        { key: "kapat3", au: "kapat3au", label: "Credit" },
        { key: "vahtuk", au: "vahtukau", label: "Debit" },
        { key: "comm", au: "commau", label: "Debit" },
        { key: "ada", au: "adau", label: "Debit" },
        { key: "billamt", au: "billamtau", label: "Debit" },
      ];

      // 2) Assume rowData and input are already defined:
      const rowData = {
        mainuser: localStorage.getItem("contact"),
        thevregular: totalvalue["6"], thevregularau: localStorage.getItem("thevregular"),
        thev1: totalvalue["9"], thev1au: localStorage.getItem("thev1"),
        thev2: totalvalue["12"], thev2au: localStorage.getItem("thev2"),
        thev3: totalvalue["15"], thev3au: localStorage.getItem("thev3"),
        advchalu: totalvalue["18"], advchaluau: localStorage.getItem("advchalu"),
        advkapat: totalvalue["20"], advkapatau: localStorage.getItem("advkapat"),
        khchalu: totalvalue["23"], khchaluau: localStorage.getItem("khchalu"),
        khkapat: totalvalue["25"], khkapatau: localStorage.getItem("khkapat"),
        ratibchalu: totalvalue["28"], ratibchaluau: localStorage.getItem("ratibchalu"),
        ratibkapat: totalvalue["30"], ratibkapatau: localStorage.getItem("ratibkapat"),
        karjchalu: totalvalue["33"], karjchaluau: localStorage.getItem("karjchalu"),
        hptachalu: totalvalue["35"], hptachaluau: localStorage.getItem("hptachalu"),
        intrchalu: totalvalue["36"], intrchaluau: localStorage.getItem("intrchalu"),
        sanghkchalu: totalvalue["39"], sanghkchaluau: localStorage.getItem("sanghkchalu"),
        sanghkkapat: totalvalue["41"], sanghkkapatau: localStorage.getItem("sanghkkapat"),
        ikapat: totalvalue["47"], ikapatau: localStorage.getItem("ikapat"),
        retanchalu: totalvalue["49"], retanchaluau: localStorage.getItem("retanchalu"),
        retankapat: (
          parseFloat(totalvalue["51"] || 0) +
          parseFloat(totalvalue["52"] || 0)
        ).toFixed(2),
        retankapatau: localStorage.getItem("retankapat"),
        kapat1: totalvalue["54"], kapat1au: localStorage.getItem("kapat1"),
        kapat2: totalvalue["55"], kapat2au: localStorage.getItem("kapat2"),
        kapat3: totalvalue["56"], kapat3au: localStorage.getItem("kapat3"),
        vahtuk: totalvalue["57"], vahtukau: localStorage.getItem("vahtuk"),
        comm: totalvalue["58"], commau: localStorage.getItem("comm"),
        ada: totalvalue["59"], adau: localStorage.getItem("ada"),
        billamt: totalvalue["3"], billamtau: localStorage.getItem("billamt"),
      };

      const remarkText = `${input.date1} ते ${input.date2}`;

      // 3) Build the VALUES tuples
      const esc = str => String(str).replace(/'/g, "''");

      const tuples = fieldMeta
        .map(({ key, au, label }) => {
          const kno = rowData[au];
          const amt = rowData[key];
          if (!kno || kno === "0") return null;

          return `(
      '${esc(input.date2)}',      -- date
      '${esc(kno)}',              -- kno
      'कॅश',                      -- etype
      '${esc(label)}',            -- type
      '${esc(amt)}',              -- amt
      '${esc(remarkText)}',       -- remark
      '${esc(remarkText)}',       -- status
      '${esc(rowData.mainuser)}'  -- mainuser
    )`;
        })
        .filter(t => t);

      // 4) Final INSERT
      if (tuples.length === 0) {
        console.warn("No records to insert – all AU fields were empty or zero.");
      } else {
        const insertQuery = `
    INSERT INTO Auditentry
      (date, kno, etype, type, amt, remark, status, mainuser)
    VALUES
      ${tuples.join(",\n      ")}
  `;
        // console.log("Built INSERT query:\n", insertQuery);
        // … now execute insertQuery against your database …

        data.push(rowData);

        saveaudit(insertQuery, data);
      }



      // if (input.knofrom === input.knoto) {
      //   savebillsingle(insertQuery, updateQuery, data);
      // }
      // else {
      //   savebill(insertQuery, updateQuery, data);
      // }

    } catch (error) {
      console.error("Failed to build rowData:", error);
    }
  }


  const saveaudit = (insertQuery, data) => {
    setWaittran(true);
    var mainuser2 = jsEncode.encode("mamapr", 125);
    if (data.length === 0 || insertQuery === "" || input.date1 === "" || input.date2 === "" || input.knofrom === "" || input.knoto === "") {
      notifyerror("अपूर्ण एंट्री माहिती!");
      setWaittran(false);
      return;
    }
    let rawData = {
      insertQuery: insertQuery,
      mainuser: localStorage.getItem("contact"),
      date1: input.date1,
      date2: input.date2,
      mainuser2: mainuser2,
    }

    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post('https://excellentdairy.com/dairy/php/cust/transfteraudit.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      if (response.data.trim() === "Saved.") {
       notify(t("bill.auditTransferSuccess"));
        setWaittran(false);
      }
    }).catch(err => {
      console.log(err);
      setWaittran(false);
    });
  }

  const deleteaudit = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    if (input.date1 === "" || input.date2 === "" || input.knofrom === "" || input.knoto === "") {
      notifyerror("अपूर्ण एंट्री माहिती!");
      setWaittran(false);
      return;
    }
    let rawData = {
      mainuser: localStorage.getItem("contact"),
      date1: input.date1,
      date2: input.date2,
      mainuser2: mainuser2,
    }

    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post('https://excellentdairy.com/dairy/php/cust/deleteaudit.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      if (response.data.trim() === "Deleted.") {
        setWaittran(false);
      }
    }).catch(err => {
      console.log(err);
      setWaittran(false);
    });
  }




  const savebill = (insertQuery, updateQuery, data) => {

    setWaitsave(true);
    var mainuser2 = jsEncode.encode("mamapr", 125);
    if (data.length === 0 || insertQuery === "" || input.date1 === "" || input.date2 === "" || input.knofrom === "" || input.knoto === "") {
      notifyerror("अपूर्ण एंट्री माहिती!");
      setWaitsave(false);
      return;
    }
    let rawData = {
      insertQuery: insertQuery,
      updateQuery: updateQuery,
      mainuser: localStorage.getItem("contact"),
      date1: input.date1,
      date2: input.date2,
      mainuser2: mainuser2,
    }

    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post('https://excellentdairy.com/dairy/php/cust/savebill5.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      if (response.data.trim() === "Saved.") {
        notify(t("bill.memberBillSaved"));
        setDataSource([]);           // <- will trigger the effect
        afterSaveRef.current = true; // <- mark that this clear came from "Saved."
      }
    }).catch(err => {
      console.log(err);
    });
  }

  const savebillsingle = (insertQuery, updateQuery, data) => {

    setWaitsave(true);

    var mainuser2 = jsEncode.encode("mamapr", 125);
    if (data.length === 0 || insertQuery === "" || input.date1 === "" || input.date2 === "" || input.knofrom === "" || input.knoto === "") {
       notifyerror(t("khpurjma.toast.incompleteEntry"));
      setWaitsave(false);
      return;
    }
    let rawData = {
      insertQuery: insertQuery,
      updateQuery: updateQuery,
      mainuser: localStorage.getItem("contact"),
      date1: input.date1,
      date2: input.date2,
      knofrom: input.knofrom,
      knoto: input.knoto,
      mainuser2: mainuser2,

    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post('https://excellentdairy.com/dairy/php/cust/savebillsingle2.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      if (response.data.trim() === "Saved.") {
        notify(t("bill.memberBillRefreshed", { kno: input.knofrom }));
        setDataSource([]);
        setWaitsave(false);
        getmaxno();
        setWait(false);
        setShowupdate(false);
        getbill();
      }
      else {
        setWait(false);
      }
    }).catch(err => {
      console.log(err);
    });
  }


  // effect: fires only when cleared *after* a Save
  useEffect(() => {
    if (!afterSaveRef.current) return; // ignore initial empty state, or any non-save clears
    if (Array.isArray(DataSource) && DataSource.length === 0) {
      setShowupdate(false);
      updatedDataSource = [];
      getbill();
      setWaitsave(false);
      getmaxno();
      afterSaveRef.current = false; // reset the flag
    }
  }, [DataSource]);


  function handleEnterKey(event, currentIndex) {

    if (event.keyCode === 8) {
      if (event.target.name === "time") {
        setInput((prevInputSettings) => ({
          ...prevInputSettings,
          time: '',
        }));
      }
      else if (event.target.name === "type") {
        setInput((prevInputSettings) => ({
          ...prevInputSettings,
          type: '',
        }));
      }
    }

    if (event.key === 'Enter' || event.key === "Tab") {
      event.preventDefault();
      let nextIndex = null;
      if (currentIndex === 2) {
        if (input.name !== "") {
          nextIndex = currentIndex + 1;
        }
        else {
          nextIndex = currentIndex;
        }
      }
      else {
        nextIndex = currentIndex + 1;
      }
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
  }

  useEffect(() => {
    const currentDate1 = new Date(input.date1);
    const dayOfMonth1 = currentDate1.getDate();
    const currentMonth1 = currentDate1.getMonth();
    const currentYear1 = currentDate1.getFullYear();

    let lastDayOfMonth1;

    if (localStorage.getItem("dur") === "10") {
      if (dayOfMonth1 >= 1 && dayOfMonth1 <= 10) {
        lastDayOfMonth1 = 10;
      } else if (dayOfMonth1 >= 11 && dayOfMonth1 <= 20) {
        lastDayOfMonth1 = 20;
      } else if (dayOfMonth1 >= 21 && dayOfMonth1 <= 30) {
        lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate(); // Last day of selected month
      }
    }
    else if (localStorage.getItem("dur") === "15") {
      if (dayOfMonth1 >= 1 && dayOfMonth1 <= 15) {
        lastDayOfMonth1 = 15;
      } else if (dayOfMonth1 >= 16 && dayOfMonth1 <= 30) {
        lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate(); // Last day of selected month
      }
    }
    else if (localStorage.getItem("dur") === "30") {
      if (dayOfMonth1 == 1) {
        lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate(); // Last day of selected month
      }
    }

    if (lastDayOfMonth1 !== undefined) {
      const formattedDate2 = new Date(currentYear1, currentMonth1, lastDayOfMonth1).toLocaleDateString('en-CA');
      setInput(prevInput => ({
        ...prevInput,
        date2: formattedDate2
      }));
    }
    setDataSource([]);
    setTableFilter([]);

    addZeroTotalRow('myTablebill');

  }, [input.date1]);


  useEffect(() => {
    const currentDate = new Date();
    const dayOfMonth = currentDate.getDate();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    let firstDayOfMonth;
    let lastDayOfMonth;

    // console.log(localStorage.getItem("lastbilldate"))
    if (localStorage.getItem("lastbilldate") !== null) {
      firstDayOfMonth = localStorage.getItem("lastbilldate");
    }


    if (localStorage.getItem("dur") === '10') {
      if (dayOfMonth >= 1 && dayOfMonth <= 10) {
        firstDayOfMonth = 1;
        lastDayOfMonth = 10;
      } else if (dayOfMonth >= 11 && dayOfMonth <= 20) {
        firstDayOfMonth = 11;
        lastDayOfMonth = 20;
      } else if (dayOfMonth >= 21 && dayOfMonth <= 30) {
        firstDayOfMonth = 21;
        lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); // Last day of current month
      }
    }
    else if (localStorage.getItem("dur") === '15') {
      if (dayOfMonth >= 1 && dayOfMonth <= 15) {
        firstDayOfMonth = 1;
        lastDayOfMonth = 15;
      } else if (dayOfMonth >= 16 && dayOfMonth <= 30) {
        firstDayOfMonth = 16;
        lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); // Last day of current month
      }
    }


    if (firstDayOfMonth !== undefined && lastDayOfMonth !== undefined) {
      const formattedDate1 = new Date(currentYear, currentMonth, firstDayOfMonth).toLocaleDateString('en-CA');
      const formattedDate2 = new Date(currentYear, currentMonth, lastDayOfMonth).toLocaleDateString('en-CA');
      setInput(prevInput => ({
        ...prevInput,
        date1: formattedDate1,
        date2: formattedDate2
      }));
    }
    getmobileusers();
    getmaxno();
  }, []);


  const handleCellKeyPress = (e, rowIndex) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      if (rowIndex + 1 < cellRefs.current.length) {
        const nextRow = cellRefs.current[rowIndex + 1];
        if (nextRow[0]) {
          nextRow[0].focus();
        }
      }
      e.target.blur(); // Remove focus from the cell
    } else if (e.key !== 'Backspace' && e.key !== '-' && !/Arrow(Left|Right)/.test(e.key)) {
      // Prevent non-numeric input
      if (isNaN(e.key) && e.key !== '.') {
        e.preventDefault();
      }
    }
  };

  const handleCellKeyPress12 = (e, rowIndex, colIndex) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      if (rowIndex + 1 < cellRefs.current.length) {
        const nextRow = cellRefs.current[rowIndex + 1]; // Get next row

        if (nextRow && nextRow[colIndex]) { // Use the same column index
          nextRow[colIndex].focus();
        }
      }

      e.target.blur(); // Remove focus from the current cell
    } else if (
      e.key !== 'Backspace' &&
      e.key !== '-' && !/Arrow(Left|Right)/.test(e.key)
    ) {
      // Prevent non-numeric input
      if (isNaN(e.key) && e.key !== '.') {
        e.preventDefault();
      }
    }
  };


  const handleChangeactive = (event) => {
    var checked = event.target.checked;

    if (event.target.checked) {
      setShowthevcol("Yes");
    }
    else {
      setShowthevcol("No");
    }
  }

  useEffect(() => {
    addTotalRow('myTablebill');
  }, [showthevcol])



  const handleOtheractive = (event) => {
    var checked = event.target.checked;

    if (event.target.checked) {
      setShowother("Yes");
    }
    else {
      setShowother("No");
    }
  }

  const handlethev = (event) => {
    var checked = event.target.checked;

    if (event.target.checked) {
      setShowthev("Yes");
    }
    else {
      setShowthev("No");
    }
  }

  const showprint = async () => {
    if (DataSource[0].flag !== "newbill") {
      // refprintclose.current.click();
      setWaitprint(true);
      var mainuser2 = jsEncode.encode("mamapr", 125);

      const url = (rtype !== '5' && rtype !== '6')
        ? 'https://excellentdairy.com/dairy/php/cust/getbillprint4.php'
        : 'https://excellentdairy.com/dairy/php/cust/getbillprinttapshil.php';
      try {
        const response = await axios.post(url, {
          mainuser: localStorage.getItem('contact'),
          date1: input.date1,
          date2: input.date2,
          mainuser2: mainuser2,
          knofrom: input.knofromprint,
          knoto: input.knotoprint,
          mobileuser: input.mobileuser,
          billtype: DataSource[0].flag,
          bcount: DataSource[0].bcount
        });

        if (DataSource && DataSource.length > 0) {

          localStorage.setItem("date1print", input.date1);
          localStorage.setItem("date2print", input.date2);
          localStorage.setItem("billtype", DataSource[0].flag);
          localStorage.setItem("bcount", DataSource[0].bcount);
          localStorage.setItem("customerData", JSON.stringify(response.data));
          localStorage.setItem("kapat", JSON.stringify(kapat));
          localStorage.setItem("showother", showother);
          localStorage.setItem("showthev", showthev);
          localStorage.setItem("design", design);
          if (input.ikapatnote !== "कपात नोट" && input.ikapatnote.trim() !== "") {
            localStorage.setItem("ikapatnote", "(" + input.ikapatnote + ")");
          }
          else {
            localStorage.setItem("ikapatnote", "");
          }
          localStorage.setItem("mobileuser", input.mobileuser);
          let url = "";
          console.log(rtype);

          if (rtype === "1") {
            url = "/billkolhapur"
          }
          else if (rtype === "2") {
            url = "/billprint2change"
            //url = "/billprint2fast"
          }
          else if (rtype === "3") {
            url = "/billprint2change"
            // url = "/billprint2fast"
          }
          else if (rtype === "4") {
            url = "/billprinta4"
          }
          else if (rtype === "5") {
            url = "/billtapshil"
          }
          else if (rtype === "6") {
            url = "/billtapshil"
          }
          window.open(url, '_blank');  //'_self'  _blank
          setWaitprint(false);
        } else {
          notifyerror("या कालावधीमध्ये संकलन उपलब्ध नाही!");
          setWaitprint(false);
        }
      } catch (error) {
        notifyerror(error);
        setWaitprint(false);
        // Handle errors here
      } finally {
        setWaitprint(false);
      }
    }
    else {
      notifyerror("कृपया प्रथम बिल सेव्ह करा!")
      refprintclose.current.click();
    }
  };


  const showtrialprint = async () => {

    //
    setWaitprinttest(true);
    var mainuser2 = jsEncode.encode("mamapr", 125);

    try {
      const response = await axios.post('https://excellentdairy.com/dairy/php/cust/gettrailprints.php', {
        mainuser: localStorage.getItem('contact'),
        date1: input.date1,
        date2: input.date2,
        mainuser2: mainuser2,
        knofrom: input.knofromprint,
        knoto: input.knotoprint,
        mobileuser: input.mobileuser,
      });

      //  console.log(response.data);

      localStorage.setItem("date1print", input.date1);
      localStorage.setItem("date2print", input.date2);
      localStorage.setItem("billtype", "newbill");
      localStorage.setItem("bcount", "0");
      localStorage.setItem("customerData", JSON.stringify(response.data));
      localStorage.setItem("kapat", "--");
      localStorage.setItem("showother", showother);
      localStorage.setItem("showthev", showthev);
      localStorage.setItem("design", rtype);
      if (input.ikapatnote !== "कपात नोट" && input.ikapatnote.trim() !== "") {
        localStorage.setItem("ikapatnote", "(" + input.ikapatnote + ")");
      }
      else {
        localStorage.setItem("ikapatnote", "");
      }
      localStorage.setItem("mobileuser", input.mobileuser);
      const url = "/billprinttest";
      setWaitprinttest(false);
      reftrailprintclose.current.click();
      window.open(url, '_blank');  //'_self'  _blank

    } catch (error) {
      notifyerror(error);
      // Handle errors here
    } finally {
      setWaitprinttest(false);
    }

  };

  const addOrUpdateCuchal = (kno, cuchal) => {
    setKapat((prevKapat) => {
      const updatedKapat = { ...prevKapat };

      if (updatedKapat[kno]) {
        updatedKapat[kno].cuchal = cuchal;
      } else {
        updatedKapat[kno] = { cuchal, ckhadya: '', ckhadya: '', cratib: '', ckarj: '', csangh: '', ckarjintr: '', cbhishi: '', ikapatedit: '' };
      }

      return updatedKapat;
    });
  };

  const addOrUpdateCkhadya = (kno, ckhadya) => {
    setKapat((prevKapat) => {
      const updatedKapat = { ...prevKapat };

      if (updatedKapat[kno]) {
        updatedKapat[kno].ckhadya = ckhadya;
      } else {
        updatedKapat[kno] = { cuchal: '', ckhadya, cratib: '', ckarj: '', ckarjintr: '', csangh: '', cbhishi: '', ikapatedit: '' };
      }

      return updatedKapat;
    });
  };

  const addOrUpdateCratib = (kno, cratib) => {
    setKapat((prevKapat) => {
      const updatedKapat = { ...prevKapat };

      if (updatedKapat[kno]) {
        updatedKapat[kno].cratib = cratib;
      } else {
        updatedKapat[kno] = { cuchal: '', ckhadya: '', cratib, ckarj: '', ckarjintr: '', csangh: '', cbhishi: '', ikapatedit: '' };
      }

      return updatedKapat;
    });
  };


  const addOrUpdateCkarj = (kno, ckarj) => {
    setKapat((prevKapat) => {
      const updatedKapat = { ...prevKapat };

      if (updatedKapat[kno]) {
        updatedKapat[kno].ckarj = ckarj;
      } else {
        updatedKapat[kno] = { cuchal: '', ckhadya: '', cratib: '', ckarj, ckarjintr: '', csangh: '', cbhishi: '', ikapatedit: '' };
      }

      return updatedKapat;
    });
  };

  const addOrUpdateCkarjintr = (kno, ckarjintr) => {
    setKapat((prevKapat) => {
      const updatedKapat = { ...prevKapat };

      if (updatedKapat[kno]) {
        updatedKapat[kno].ckarjintr = ckarjintr;
      } else {
        updatedKapat[kno] = { cuchal: '', ckhadya: '', cratib: '', ckarj: '', ckarjintr, csangh: '', cbhishi: '', ikapatedit: '' };
      }

      return updatedKapat;
    });
  };

  const addOrUpdatesangh = (kno, csangh) => {
    setKapat((prevKapat) => {
      const updatedKapat = { ...prevKapat };

      if (updatedKapat[kno]) {
        updatedKapat[kno].csangh = csangh;
      } else {
        updatedKapat[kno] = { cuchal: '', ckhadya: '', cratib: '', ckarj: '', csangh, ckarjintr: '', cbhishi: '', ikapatedit: '' };
      }

      return updatedKapat;
    });
  };


  const addOrUpdatebhishi = (kno, cbhishi) => {
    setKapat((prevKapat) => {
      const updatedKapat = { ...prevKapat };

      if (updatedKapat[kno]) {
        updatedKapat[kno].cbhishi = cbhishi;
      } else {
        updatedKapat[kno] = { cuchal: '', ckhadya: '', cratib: '', ckarj: '', csangh: '', ckarjintr: '', cbhishi, ikapatedit: '' };
      }

      return updatedKapat;
    });
  };

  const addOrUpdateikapat = (kno, ikapatedit) => {
    setKapat((prevKapat) => {
      const updatedKapat = { ...prevKapat };

      if (updatedKapat[kno]) {
        updatedKapat[kno].ikapatedit = ikapatedit;
      } else {
        updatedKapat[kno] = { cuchal: '', ckhadya: '', ikapatedit };
      }
      return updatedKapat;
    });
  };



  const handleCellBlurkh = (e, rowIndex) => {
    let newValue = e.target.textContent.trim();
    if (!newValue) {
      e.target.textContent = '0'; // Set to '0' if empty
      newValue = 0;
    }
  };


  const filteData = (e) => {
    const searchValue = e.target.value.trim();

    if (searchValue !== "") {
      setValue(searchValue);
      const filtertable = DataSource.filter(o =>
        String(o.kno) === searchValue // Check for exact match with kno
      );

      setTableFilter([...filtertable]);
    } else {
      setValue(searchValue);
      setTableFilter([...DataSource]);
    }
  };


  const handleCellBlurikapat = (e, rowIndex) => {
    let newValue = e.target.textContent.trim();
    if (!newValue) {
      e.target.textContent = '0'; // Set to '0' if empty
      newValue = 0;
    }
  };

  const handleCellBlurikapat1 = (e, rowIndex) => {
    let newValue = e.target.textContent.trim();
    if (!newValue) {
      e.target.textContent = '0'; // Set to '0' if empty
      newValue = 0;
    }
  };

  const handleCellfocus = (e, rowIndex) => {
    if (e.target.textContent === "0") {
      e.target.textContent = '';
    }
  }

  const handleCellBlur = (e, rowIndex) => {
    let newValue = e.target.textContent.trim();

    if (!newValue) {
      e.target.textContent = '0'; // Set to '0' if empty
    }
  };

  const handleCellChange = (e, rowIndex, kno) => {
    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    //addOrUpdateCuchal(user.kno,advedit);

    if (updatedDataSource[rowIndex]) {
      //  updatedDataSource[rowIndex].khedit = updatedDataSource[rowIndex].action;
      updatedDataSource[rowIndex].action = newValue;
      // Calculate the result (column 6 - column 7) and store in column 8
      let column6Value = "";

      if (DataSource[0].flag === "oldbill") {
        column6Value = parseFloat(updatedDataSource[rowIndex].newadv) + parseFloat(updatedDataSource[rowIndex].cuchal);
      }
      else {
        column6Value = (parseFloat(updatedDataSource[rowIndex].bcount) > 0 ? parseFloat(updatedDataSource[rowIndex].newadv) : parseFloat(updatedDataSource[rowIndex].obal)) + parseFloat(updatedDataSource[rowIndex].cuchal);
      }

      const column7Value = newValue && !isNaN(newValue) && newValue !== null ? parseFloat(newValue) : 0;

      // console.log("column7Value-", column7Value);
      updatedDataSource[rowIndex].result = column6Value - column7Value;

      //if (newValue) {
      addOrUpdateCuchal(kno, newValue);
      if (DataSource[0].flag === "oldbill") {
        //notify("already before");

        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }


        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0) +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit)
                : parseFloat(updatedDataSource[rowIndex].khadyakapat)
            ) +
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit)
                : parseFloat(updatedDataSource[rowIndex].karjhpta)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                : parseFloat(updatedDataSource[rowIndex].cbhishi)
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )


      }
      else {

        // console.log("Edit- ", updatedDataSource[rowIndex].ikapatedit);
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }


        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null)
                ? parseFloat(kapat[kno].ckhadya)
                :
                (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0

            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }

      if (!newValue) {
        newValue = 0;
      }

    }
    updatedDataSource[rowIndex].advedit = newValue;
    setDataSource(updatedDataSource);

    e.target.contentEditable = 'true'; // Re-enable editing
    setShowupdate(true);
  };


  const handleCellChangekh = (e, rowIndex, kno) => {
    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      // Calculate the result (column 6 - column 7) and store in column 8
      let column6Value = 0;
      if (DataSource[0].flag === "oldbill") {
        column6Value = parseFloat(updatedDataSource[rowIndex].mkhadya) + parseFloat(updatedDataSource[rowIndex].ckhadya);
      }
      else {
        column6Value = parseFloat(updatedDataSource[rowIndex].newkhadya) + parseFloat(updatedDataSource[rowIndex].ckhadya);
      }

      const column7Value = newValue && !isNaN(newValue) && newValue !== null ? parseFloat(newValue) : 0;
      updatedDataSource[rowIndex].result2 = column6Value - column7Value;

      // if (newValue) {
      addOrUpdateCkhadya(kno, newValue);
      if (DataSource[0].flag === "oldbill") {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0)
            +
            (
              (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].advedit)
                : parseFloat(updatedDataSource[rowIndex].advkapat)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit)
                : parseFloat(updatedDataSource[rowIndex].karjhpta)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                : parseFloat(updatedDataSource[rowIndex].cbhishi)
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0

            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      if (!newValue) {
        newValue = 0;
      }
      updatedDataSource[rowIndex].khedit = newValue; //1
      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        khedit: newValue
      }))
      setDataSource(updatedDataSource);
    }
    e.target.contentEditable = 'true'; // Re-enable editing
    setShowupdate(true);
  };

  const handleCellChangeratib = (e, rowIndex, kno) => {
    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      // Calculate the result (column 6 - column 7) and store in column 8
      let column6Value = 0;
      if (DataSource[0].flag === "oldbill") {
        column6Value = parseFloat(updatedDataSource[rowIndex].mratib) + parseFloat(updatedDataSource[rowIndex].cratib);
      }
      else {
        column6Value = parseFloat(updatedDataSource[rowIndex].newratib) + parseFloat(updatedDataSource[rowIndex].cratib);
      }

      const column7Value = newValue && !isNaN(newValue) && newValue !== null ? parseFloat(newValue) : 0;
      updatedDataSource[rowIndex].result3 = column6Value - column7Value;

      // if (newValue) {
      addOrUpdateCratib(kno, newValue);
      if (DataSource[0].flag === "oldbill") {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0) +
            (
              (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].advedit)
                : parseFloat(updatedDataSource[rowIndex].advkapat)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit)
                : parseFloat(updatedDataSource[rowIndex].khadyakapat)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit)
                : parseFloat(updatedDataSource[rowIndex].karjhpta)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                : parseFloat(updatedDataSource[rowIndex].cbhishi)
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null)
                ? parseFloat(kapat[kno].ckhadya)
                :
                (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      if (!newValue) {
        newValue = 0;
      }
      updatedDataSource[rowIndex].ratibedit = newValue; //1
      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        ratibedit: newValue
      }))
      setDataSource(updatedDataSource);
    }

    e.target.contentEditable = 'true'; // Re-enable editing
    setShowupdate(true);
  };

  const handleCellChangekarj = (e, rowIndex, kno, karjintr) => {
    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      // Calculate the result (column 6 - column 7) and store in column 8
      let column6Value = 0;
      if (DataSource[0].flag === "oldbill") {
        column6Value = parseFloat(updatedDataSource[rowIndex].mkarj) + parseFloat(updatedDataSource[rowIndex].ckarj);
      }
      else {
        column6Value = parseFloat(updatedDataSource[rowIndex].newkarj) + parseFloat(updatedDataSource[rowIndex].ckarj);
      }

      const column7Value = newValue && !isNaN(newValue) && newValue !== null ? parseFloat(newValue) : 0;
      updatedDataSource[rowIndex].result4 = column6Value - (parseFloat(column7Value));

      // if (newValue) {
      addOrUpdateCkarj(kno, newValue);
      if (DataSource[0].flag === "oldbill") {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0) +
            (
              (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].advedit)
                : parseFloat(updatedDataSource[rowIndex].advkapat)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit)
                : parseFloat(updatedDataSource[rowIndex].khadyakapat)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                : parseFloat(updatedDataSource[rowIndex].cbhishi)
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null)
                ? parseFloat(kapat[kno].ckhadya)
                :
                (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      if (!newValue) {
        newValue = 0;
      }
      updatedDataSource[rowIndex].karjedit = newValue; //1
      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        karjedit: newValue
      }))
      setDataSource(updatedDataSource);
    }

    e.target.contentEditable = 'true'; // Re-enable editing
    setShowupdate(true);
  };


  const handleCellChangesangh = (e, rowIndex, kno) => {
    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      // Calculate the result (column 6 - column 7) and store in column 8
      let column6Value = 0;
      if (DataSource[0].flag === "oldbill") {
        column6Value = parseFloat(updatedDataSource[rowIndex].newsangh) + parseFloat(updatedDataSource[rowIndex].sanghkapat);
      }
      else {
        column6Value = parseFloat(updatedDataSource[rowIndex].newsangh) + parseFloat(updatedDataSource[rowIndex].csangh);
      }

      const column7Value = newValue && !isNaN(newValue) && newValue !== null ? parseFloat(newValue) : 0;
      updatedDataSource[rowIndex].resultsangh = column6Value - column7Value;

      // if (newValue) {
      addOrUpdatesangh(kno, newValue);
      if (DataSource[0].flag === "oldbill") {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0) +
            (
              (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].advedit)
                : parseFloat(updatedDataSource[rowIndex].advkapat)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit)
                : parseFloat(updatedDataSource[rowIndex].khadyakapat)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit)
                : parseFloat(updatedDataSource[rowIndex].karjhpta)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                : parseFloat(updatedDataSource[rowIndex].cbhishi)
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit) :
                !isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null
                  ? parseFloat(kapat[kno].ckhadya)
                  :
                  (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                    ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                    : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      if (!newValue) {
        newValue = 0;
      }
      updatedDataSource[rowIndex].sanghedit = newValue; //1
      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        sanghedit: newValue
      }))
      setDataSource(updatedDataSource);
    }
    e.target.contentEditable = 'true'; // Re-enable editing
    setShowupdate(true);
  };


  const handleCellChangebhishi = (e, rowIndex, kno) => {
    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      // Calculate the result (column 6 - column 7) and store in column 8
      let column6Value = 0;
      if (DataSource[0].flag === "oldbill") {
        column6Value = parseFloat(updatedDataSource[rowIndex].magilbhishi) + parseFloat(updatedDataSource[rowIndex].cbhishi);
      }
      else {
        column6Value = parseFloat(updatedDataSource[rowIndex].newbhishi) + parseFloat(updatedDataSource[rowIndex].cbhishi);
      }

      const column7Value = newValue && !isNaN(newValue) && newValue !== null ? parseFloat(newValue) : 0;
      updatedDataSource[rowIndex].resultbhishi = column6Value + column7Value;

      // if (newValue) {
      addOrUpdatebhishi(kno, newValue);

      if (DataSource[0].flag === "oldbill") {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0) +
            (
              (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].advedit)
                : parseFloat(updatedDataSource[rowIndex].advkapat)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit)
                : parseFloat(updatedDataSource[rowIndex].khadyakapat)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit)
                : parseFloat(updatedDataSource[rowIndex].karjhpta)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit) :
                !isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null
                  ? parseFloat(kapat[kno].ckhadya)
                  :
                  (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                    ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                    : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      if (!newValue) {
        newValue = 0;
      }
      updatedDataSource[rowIndex].bhishiedit = newValue; //1
      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        bhishiedit: newValue
      }))
      setDataSource(updatedDataSource);
    }
    e.target.contentEditable = 'true'; // Re-enable editing
    setShowupdate(true);
  };


  const handleCellChangeikapat = (e, rowIndex, kno) => {

    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      if (DataSource[0].flag === "oldbill") {

        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0) +
            (
              (
                (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].advedit)
                  : parseFloat(updatedDataSource[rowIndex].advkapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].khedit)
                  : parseFloat(updatedDataSource[rowIndex].khadyakapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                  !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                    ? parseFloat(kapat[kno].cratib)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjedit)
                  : parseFloat(updatedDataSource[rowIndex].karjhpta)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjintr)
                  : 0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                  !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                    ? parseFloat(kapat[kno].csangh)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                  : parseFloat(updatedDataSource[rowIndex].cbhishi)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].retanedit)
                  : parseFloat(updatedDataSource[rowIndex].retan)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].mediedit)
                  : parseFloat(updatedDataSource[rowIndex].medi)
              )
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))


        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit) :
                !isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null
                  ? parseFloat(kapat[kno].ckhadya)
                  :
                  (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                    ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                    : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0

            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0))
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }

      if (!newValue) {
        newValue = 0;
      }

      updatedDataSource[rowIndex].ikapatedit = newValue; //1

      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        ikapatedit: newValue
      }))
      setDataSource(updatedDataSource);
    }
    e.target.contentEditable = 'true'; // Re-enable editing

    setShowupdate(true);
  };


  const handleCellChangeretan = (e, rowIndex, kno) => {
    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      let column6Value = 0;
      if (DataSource[0].flag === "oldbill") {
        column6Value = parseFloat(updatedDataSource[rowIndex].magilretanmedi) + (parseFloat(updatedDataSource[rowIndex].cretanmedi)) - (parseFloat(updatedDataSource[rowIndex].mediedit ? parseFloat(updatedDataSource[rowIndex].mediedit) : parseFloat(updatedDataSource[rowIndex].medi)))

      }
      else {
        column6Value = (parseFloat(updatedDataSource[rowIndex].newretanmedi) + parseFloat(updatedDataSource[rowIndex].cretanmedi)) - (parseFloat(updatedDataSource[rowIndex].mediedit ? parseFloat(updatedDataSource[rowIndex].mediedit) : 0));
      }

      const column7Value = newValue && !isNaN(newValue) && newValue !== null ? parseFloat(newValue) : 0;
      updatedDataSource[rowIndex].resultretanmedi = column6Value - column7Value;

      if (DataSource[0].flag === "oldbill") {

        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (
                (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].advedit)
                  : parseFloat(updatedDataSource[rowIndex].advkapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].khedit)
                  : parseFloat(updatedDataSource[rowIndex].khadyakapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                  !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                    ? parseFloat(kapat[kno].cratib)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjedit)
                  : parseFloat(updatedDataSource[rowIndex].karjhpta)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjintr)
                  : 0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                  !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                    ? parseFloat(kapat[kno].csangh)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                  : parseFloat(updatedDataSource[rowIndex].cbhishi)
              )
              +
              (
                parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                  parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                  ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                  : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].mediedit)
                  : parseFloat(updatedDataSource[rowIndex].medi)
              )
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))


        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit) :
                !isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null
                  ? parseFloat(kapat[kno].ckhadya)
                  :
                  (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                    ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                    : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          ;
      }

      if (!newValue) {
        newValue = 0;
      }
      updatedDataSource[rowIndex].retanedit = newValue; //1

      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        retanedit: newValue
      }))
      setDataSource(updatedDataSource);
    }
    e.target.contentEditable = 'true'; // Re-enable editing

    setShowupdate(true);
  };

  const handleCellChangemedi = (e, rowIndex, kno) => {

    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      let column6Value = 0;
      if (DataSource[0].flag === "oldbill") {
        column6Value = parseFloat(updatedDataSource[rowIndex].magilretanmedi) + (parseFloat(updatedDataSource[rowIndex].cretanmedi)) - (parseFloat(updatedDataSource[rowIndex].retanedit ? parseFloat(updatedDataSource[rowIndex].retanedit) : parseFloat(updatedDataSource[rowIndex].retan)))
      }
      else {
        column6Value = (parseFloat(updatedDataSource[rowIndex].newretanmedi) + parseFloat(updatedDataSource[rowIndex].cretanmedi)) - (parseFloat(updatedDataSource[rowIndex].retanedit ? parseFloat(updatedDataSource[rowIndex].retanedit) : 0));
      }

      const column7Value = newValue && !isNaN(newValue) && newValue !== null ? parseFloat(newValue) : 0;
      updatedDataSource[rowIndex].resultretanmedi = column6Value - column7Value;

      if (DataSource[0].flag === "oldbill") {

        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);


        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (
                (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].advedit)
                  : parseFloat(updatedDataSource[rowIndex].advkapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].khedit)
                  : parseFloat(updatedDataSource[rowIndex].khadyakapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                  !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                    ? parseFloat(kapat[kno].cratib)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjedit)
                  : parseFloat(updatedDataSource[rowIndex].karjhpta)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjintr)
                  : 0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                  !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                    ? parseFloat(kapat[kno].csangh)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                  : parseFloat(updatedDataSource[rowIndex].cbhishi)
              )
              +
              (
                parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                  parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                  ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                  : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].retanedit)
                  : parseFloat(updatedDataSource[rowIndex].retan)
              )
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )

      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))


        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit) :
                !isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null
                  ? parseFloat(kapat[kno].ckhadya)
                  :
                  (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                    ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                    : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0

            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }

      if (!newValue) {
        newValue = 0;
      }
      updatedDataSource[rowIndex].mediedit = newValue; //1

      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        mediedit: newValue
      }))
      setDataSource(updatedDataSource);
    }
    e.target.contentEditable = 'true'; // Re-enable editing

    setShowupdate(true);
  };


  const handleCellChangeikapat1 = (e, rowIndex, kno) => {

    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    console.log(kapat);
    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      if (DataSource[0].flag === "oldbill") {

        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        // 4 deelted
        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0) +
            (
              (
                (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].advedit)
                  : parseFloat(updatedDataSource[rowIndex].advkapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].khedit)
                  : parseFloat(updatedDataSource[rowIndex].khadyakapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                  !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                    ? parseFloat(kapat[kno].cratib)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjedit)
                  : parseFloat(updatedDataSource[rowIndex].karjhpta)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjintr)
                  : 0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                  !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                    ? parseFloat(kapat[kno].csangh)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                  : parseFloat(updatedDataSource[rowIndex].cbhishi)
              )
              +
              (
                parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                  parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                  ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                  : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].retanedit)
                  : parseFloat(updatedDataSource[rowIndex].retan)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].mediedit)
                  : parseFloat(updatedDataSource[rowIndex].medi)
              )
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }
        // 4 delete

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))


        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit) :
                !isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null
                  ? parseFloat(kapat[kno].ckhadya)
                  :
                  (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                    ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                    : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0))
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }

      if (!newValue) {
        newValue = 0;
      }

      updatedDataSource[rowIndex].ikapatedit4 = newValue; //1

      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        ikapatedit4: newValue
      }))
      setDataSource(updatedDataSource);
    }
    e.target.contentEditable = 'true'; // Re-enable editing

    setShowupdate(true);
  };

  const handleCellChangeikapat2 = (e, rowIndex, kno) => {

    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      if (DataSource[0].flag === "oldbill") {

        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        // 5 deleted

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0) +
            (
              (
                (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].advedit)
                  : parseFloat(updatedDataSource[rowIndex].advkapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].khedit)
                  : parseFloat(updatedDataSource[rowIndex].khadyakapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                  !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                    ? parseFloat(kapat[kno].cratib)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjedit)
                  : parseFloat(updatedDataSource[rowIndex].karjhpta)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjintr)
                  : 0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                  !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                    ? parseFloat(kapat[kno].csangh)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                  : parseFloat(updatedDataSource[rowIndex].cbhishi)
              )
              +
              (
                parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                  parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                  ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                  : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].retanedit)
                  : parseFloat(updatedDataSource[rowIndex].retan)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].mediedit)
                  : parseFloat(updatedDataSource[rowIndex].medi)
              )
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }


        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit6);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr6name") !== "-") {
          const type = localStorage.getItem("itr6type");
          const val = num(localStorage.getItem("itr6value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }


        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))


        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit) :
                !isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null
                  ? parseFloat(kapat[kno].ckhadya)
                  :
                  (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                    ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                    : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0))
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }

      if (!newValue) {
        newValue = 0;
      }

      updatedDataSource[rowIndex].ikapatedit5 = newValue; //1

      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        ikapatedit5: newValue
      }))
      setDataSource(updatedDataSource);
    }
    e.target.contentEditable = 'true'; // Re-enable editing

    setShowupdate(true);
  };

  const handleCellChangeikapat3 = (e, rowIndex, kno) => {

    let newValue = e.target.textContent;
    updatedDataSource = [...DataSource];

    if (updatedDataSource[rowIndex]) {
      updatedDataSource[rowIndex].action = newValue;

      if (DataSource[0].flag === "oldbill") {

        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        console.log(updatedDataSource);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        // 6 deleted

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
          parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter) ? parseFloat(updatedDataSource[rowIndex].mhliter) : 0) * parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0)) +
              parseFloat(parseFloat(parseFloat(updatedDataSource[rowIndex].gayliter) ? parseFloat(updatedDataSource[rowIndex].gayliter) : 0) * parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))

        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (newValue ? parseFloat(newValue) : 0) +
            (
              (
                (!isNaN(updatedDataSource[rowIndex].advedit) && updatedDataSource[rowIndex].advedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].advedit)
                  : parseFloat(updatedDataSource[rowIndex].advkapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].khedit)
                  : parseFloat(updatedDataSource[rowIndex].khadyakapat)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                  !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                    ? parseFloat(kapat[kno].cratib)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjedit)
                  : parseFloat(updatedDataSource[rowIndex].karjhpta)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].karjintr) && updatedDataSource[rowIndex].karjintr !== null)
                  ? parseFloat(updatedDataSource[rowIndex].karjintr)
                  : 0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                  !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                    ? parseFloat(kapat[kno].csangh)
                    :
                    0
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].bhishiedit)
                  : parseFloat(updatedDataSource[rowIndex].cbhishi)
              )
              +
              (
                parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                  parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                  ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                  : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].retanedit)
                  : parseFloat(updatedDataSource[rowIndex].retan)
              )
              +
              (
                (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                  ? parseFloat(updatedDataSource[rowIndex].mediedit)
                  : parseFloat(updatedDataSource[rowIndex].medi)
              )
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }
      else {
        let extrakaapt = 0;
        let allthevtofixed = 0;

        if (localStorage.getItem("itr1name") != "-") {
          localStorage.getItem("itr1type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
            : localStorage.getItem("itr1type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr1value")))
        }

        if (localStorage.getItem("itr2name") != "-") {
          localStorage.getItem("itr2type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
            : localStorage.getItem("itr2type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr2value")))
        }

        if (localStorage.getItem("itr3name") != "-") {
          localStorage.getItem("itr3type") === "liter" ?
            extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
            : localStorage.getItem("itr3type") === "per" ?
              extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(updatedDataSource[rowIndex].bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
              :
              extrakaapt = parseFloat(extrakaapt) + parseFloat(updatedDataSource[rowIndex].tliter * parseFloat(localStorage.getItem("itr3value")))
        }

        let row = updatedDataSource[rowIndex] ?? {};
        let num = v => Number(v) || 0;
        let edit = Number(row.ikapatedit4);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr4name") !== "-") {
          const type = localStorage.getItem("itr4type");
          const val = num(localStorage.getItem("itr4value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }

        row = updatedDataSource[rowIndex] ?? {};
        num = v => Number(v) || 0;
        edit = Number(row.ikapatedit5);

        if (!Number.isNaN(edit)) {
          extrakaapt = num(extrakaapt) + edit;
        } else if (localStorage.getItem("itr5name") !== "-") {
          const type = localStorage.getItem("itr5type");
          const val = num(localStorage.getItem("itr5value"));
          const tltr = num(row.tliter);
          const bill = num(row.bill);

          switch (type) {
            case "per": extrakaapt = num(extrakaapt) + (bill * val) / 100; break;
            case "bill": extrakaapt = num(extrakaapt) + val; break;
            case "liter":
            default: extrakaapt = num(extrakaapt) + (tltr * val);
          }
        }


        // 6 deleted

        localStorage.getItem("thevper") === "No" ?
          allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))
          : localStorage.getItem("thevper") === "Yes" ?
            allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].bill * 10) / 100)
            : localStorage.getItem("thevper") === "Bill" ?
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhthev ? parseFloat(updatedDataSource[rowIndex].mhthev) : 0) + parseFloat(updatedDataSource[rowIndex].gaythev ? parseFloat(updatedDataSource[rowIndex].gaythev) : 0))
              :
              allthevtofixed = parseFloat(parseFloat(updatedDataSource[rowIndex].mhliter * updatedDataSource[rowIndex].mhthev) + parseFloat(updatedDataSource[rowIndex].gayliter * updatedDataSource[rowIndex].gaythev))


        let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

        updatedDataSource[rowIndex].adacalculated =
          parseFloat(updatedDataSource[rowIndex].bill) -
          (
            allthevtofixedall +
            (parseFloat(newValue) ? parseFloat(newValue) : 0) +
            (
              (!isNaN(kapat[kno].cuchal) && kapat[kno].cuchal !== null)
                ? parseFloat(kapat[kno].cuchal)
                :
                (!isNaN(updatedDataSource[rowIndex].advhpta) && updatedDataSource[rowIndex].advhpta !== null && updatedDataSource[rowIndex].advhpta !== '0')
                  ? parseFloat(updatedDataSource[rowIndex].advhpta)
                  : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].khedit) && updatedDataSource[rowIndex].khedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].khedit) :
                !isNaN(kapat[kno].ckhadya) && kapat[kno].ckhadya !== null
                  ? parseFloat(kapat[kno].ckhadya)
                  :
                  (!isNaN(updatedDataSource[rowIndex].khadyahpta) && updatedDataSource[rowIndex].khadyahpta !== null && updatedDataSource[rowIndex].khadyahpta !== '0')
                    ? parseFloat(updatedDataSource[rowIndex].khadyahpta)
                    : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].ratibedit) && updatedDataSource[rowIndex].ratibedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].ratibedit) :
                !isNaN(kapat[kno].cratib) && kapat[kno].cratib !== null
                  ? parseFloat(kapat[kno].cratib)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].karjedit) && updatedDataSource[rowIndex].karjedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].karjedit) :
                !isNaN(kapat[kno].ckarj) && kapat[kno].ckarj !== null
                  ? parseFloat(kapat[kno].ckarj)
                  :
                  0
            )
            +
            (
              !isNaN(kapat[kno].ckarjintr) && kapat[kno].ckarjintr !== null
                ? parseFloat(kapat[kno].ckarjintr)
                : 0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].sanghedit) && updatedDataSource[rowIndex].sanghedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].sanghedit) :
                !isNaN(kapat[kno].csangh) && kapat[kno].csangh !== null
                  ? parseFloat(kapat[kno].csangh)
                  :
                  0
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].bhishiedit) && updatedDataSource[rowIndex].bhishiedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].bhishiedit) :
                !isNaN(kapat[kno].cbhishi) && kapat[kno].cbhishi !== null
                  ? parseFloat(kapat[kno].cbhishi)
                  :
                  0
            )
            +
            parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0))
            +
            (
              parseFloat((updatedDataSource[rowIndex].ikapatliter2 && updatedDataSource[rowIndex].tliter ? parseFloat(updatedDataSource[rowIndex].ikapatliter2 * updatedDataSource[rowIndex].tliter) : 0)) +
                parseFloat(updatedDataSource[rowIndex].ikapatedit) !== null && updatedDataSource[rowIndex].ikapatedit !== undefined && updatedDataSource[rowIndex].ikapatedit !== ''
                ? parseFloat(updatedDataSource[rowIndex].ikapatedit)
                : parseFloat(updatedDataSource[rowIndex].ikapatbill || 0)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].retanedit) && updatedDataSource[rowIndex].retanedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].retanedit)
                : parseFloat(updatedDataSource[rowIndex].retan)
            )
            +
            (
              (!isNaN(updatedDataSource[rowIndex].mediedit) && updatedDataSource[rowIndex].mediedit !== null)
                ? parseFloat(updatedDataSource[rowIndex].mediedit)
                : parseFloat(updatedDataSource[rowIndex].medi)
            )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].vah2 && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].vah2 * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gayvah && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gayvah * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].mhliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].mhcomm && updatedDataSource[rowIndex].mhliter
                  ? parseFloat(updatedDataSource[rowIndex].mhcomm * updatedDataSource[rowIndex].mhliter)
                  : 0
              )
          )
          +
          (
            isNaN(updatedDataSource[rowIndex].gayliter)
              ? parseFloat(0)
              : parseFloat(
                updatedDataSource[rowIndex].gaycomm && updatedDataSource[rowIndex].gayliter
                  ? parseFloat(updatedDataSource[rowIndex].gaycomm * updatedDataSource[rowIndex].gayliter)
                  : 0
              )
          )
      }

      if (!newValue) {
        newValue = 0;
      }

      updatedDataSource[rowIndex].ikapatedit6 = newValue; //1

      setUpdatedDataSource2(prevInput => ({
        ...prevInput,
        ikapatedit6: newValue
      }))
      setDataSource(updatedDataSource);
    }
    e.target.contentEditable = 'true'; // Re-enable editing

    setShowupdate(true);
  };

  async function getmaxno() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => {
      props.setProgress(50);
    }, 200);
    axios.post('https://excellentdairy.com/dairy/php/cust/getmaxno2.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {

      if (response.data) {

        setInput(prevInput => ({
          ...prevInput,
          knofrom: "1",
          knoto: response.data[0].maxkno,
          knofromprint: "1",
          knotoprint: response.data[0].maxkno,
        }))

        setLastdate1(response.data[0].maxdate1);
        setLastdate2(response.data[0].maxdate2);

      }
      else {
        setInput(prevInput => ({
          ...prevInput,
          knofrom: "0",
          knoto: "0"
        }))
      }
    }).catch(err => {
      console.log(err);
    });
  }

  useEffect(() => {
    let interval;
    if (isCounting && count > 1) {
      interval = setInterval(() => {
        setCount(prevCount => prevCount - 1);
      }, 1000);
    }

    if (count === 1) {
      clearInterval(interval);
      setIsCounting(false);
    }

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [isCounting, count]);


  const readyBill = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    if (input.knofrom === "" || input.knoto === "") {
      notifyerror("सभासद क्रमांक भरा");
      return;
    }
    let rawData = {
      date1: input.date1,
      date2: input.date2,
      knofrom: input.knofrom,
      knoto: input.knoto,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post('https://excellentdairy.com/dairy/php/cust/readybill2.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      console.log(response.data);
    }).catch(err => {
      console.log(err);
    });
  }



  const getbill = async () => {

    setCount(parseFloat(input.knoto * 2).toFixed(0));
    setWait(true);
    setIsFetching(true);
    setIsCounting(true);

    const mainuser2 = jsEncode.encode("mamapr", 125);

    if (input.knofrom === "" || input.knoto === "") {
      notifyerror("सभासद क्रमांक भरा");
      setWait(false);
      setIsFetching(false);
      setIsCounting(false);
      return;
    }

    const fetchBills = async (i) => {
      setDataSource([])
      if (cancelRef.current) {
        setWait(false);
        setIsFetching(false);
        return;
      }

      if (i >= input.knoto) {
        setWait(false);
        setIsFetching(false);
        return;
      }
      // knofrom: i + 1,
      //  knoto: i + 2,

      const rawData = {
        date1: input.date1,
        date2: input.date2,
        knofrom: input.knofrom,
        knoto: input.knoto,
        kno2from: input.knofrom,
        kno2to: input.knoto,
        mainuser: localStorage.getItem("contact"),
        mainuser2: mainuser2,
      };

      const formData = new FormData();
      formData.append('data', JSON.stringify(rawData));

      try {
        const response = await axios.post(
          'https://excellentdairy.com/dairy/php/cust/readybill11.php',  //getbillfast5
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        let updatedDataSource;
        if (response.data && response.data.length > 0) {

          updatedDataSource = Array.isArray(DataSource) ? DataSource.map(r => ({ ...r })) : [];

          if (response.data[0].flag === "oldbill") {
            setDataSource(response.data)

            setIsDataLoaded(true);
          }
          else {
            if (refresh === "true") {
              setDataSource(response.data)
            }
            else {
              setDataSource(prevDataSource => [...prevDataSource, ...response.data]);
            }
            // setIsDataLoaded(true);
          }

          {
            response.data && response.data.map((user, index) => {
              if (!updatedDataSource[index]) updatedDataSource[index] = { ...user };

              let extrakaapt = 0;
              let allthevtofixed = 0;

              if (localStorage.getItem("itr1name") != "-") {
                localStorage.getItem("itr1type") === "liter" ?
                  extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value")))
                  : localStorage.getItem("itr1type") === "per" ?
                    extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
                    :
                    extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value")))
              }

              if (localStorage.getItem("itr2name") != "-") {
                localStorage.getItem("itr2type") === "liter" ?
                  extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value")))
                  : localStorage.getItem("itr2type") === "per" ?
                    extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
                    :
                    extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value")))
              }

              if (localStorage.getItem("itr3name") != "-") {
                localStorage.getItem("itr3type") === "liter" ?
                  extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value")))
                  : localStorage.getItem("itr3type") === "per" ?
                    extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
                    :
                    extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value")))
              }

              if (localStorage.getItem("itr4name") != "-") {
                localStorage.getItem("itr4type") === "liter" ?
                  extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value")))
                  : localStorage.getItem("itr4type") === "per" ?
                    extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr4value"))) / 100)
                    : localStorage.getItem("itr4type") === "bill" ?
                      extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr4value"))
                      :
                      extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value")))
              }

              if (localStorage.getItem("itr5name") != "-") {
                localStorage.getItem("itr5type") === "liter" ?
                  extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value")))
                  : localStorage.getItem("itr5type") === "per" ?
                    extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr5value"))) / 100)
                    : localStorage.getItem("itr5type") === "bill" ?
                      extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr5value"))
                      :
                      extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value")))
              }

              if (localStorage.getItem("itr6name") != "-") {
                localStorage.getItem("itr6type") === "liter" ?
                  extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value")))
                  : localStorage.getItem("itr6type") === "per" ?
                    extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr6value"))) / 100)
                    : localStorage.getItem("itr6type") === "bill" ?
                      extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr6value"))
                      :
                      extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value")))
              }

              localStorage.getItem("thevper") === "No" ?
                allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)
                : localStorage.getItem("thevper") === "Yes" ?
                  allthevtofixed = parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2)
                  : localStorage.getItem("thevper") === "Bill" ?
                    allthevtofixed = parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0))
                    :
                    allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)

              let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

              let billminusallthev = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall)).toFixed(2);
              let billminusthev = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed)).toFixed(2);
              let tadvance = parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2);
              let advancehfta = user.advhpta && user.advhpta !== null && user.advhpta !== '0' && parseFloat(user.advhpta);

              let tvahtuk = parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) +
                parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0) +
                parseFloat(user.mhcomm && user.mhliter ? parseFloat(user.mhcomm * user.mhliter) : 0) +
                parseFloat(user.gaycomm && user.gayliter ? parseFloat(user.gaycomm * user.gayliter) : 0)


              let totalkhadya = parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0)
              let billminusthevplusvahtuk = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall) + parseFloat(tvahtuk)).toFixed(2);
              let totalratib = parseFloat(parseFloat(user.cratib) + parseFloat(user.newratib) ? (parseFloat(user.cratib) + parseFloat(user.newratib)).toFixed(2) : 0)

              let totalkarj = parseFloat(parseFloat(user.ckarj) + parseFloat(user.newkarj) ? (parseFloat(user.ckarj) + parseFloat(user.newkarj)).toFixed(2) : 0)
              let billminusthevplusvahtukminusikapat = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall) + parseFloat(tvahtuk) - parseFloat(user.ikapatbill2)).toFixed(2);
              let billminusthevplusvahtukminusikapatminusbhishi = parseFloat(parseFloat(billminusthevplusvahtukminusikapat).toFixed(2) - parseFloat(localStorage.getItem("itrvalue"))).toFixed(2);
              let totalsangh = parseFloat(parseFloat(user.csangh) + parseFloat(user.newsangh) ? (parseFloat(user.csangh) + parseFloat(user.newsangh)).toFixed(2) : 0)

              let bhishiedit = user.flag === "oldbill" ?
                (user.sanghkapat && user.sanghkapat !== '0' ? user.sanghkapat : 0) :
                parseFloat(localStorage.getItem("itrvalue"));

              let sanghedit = user.flag === "oldbill" ?
                (user.sanghkapat && user.sanghkapat !== '0' ? user.sanghkapat : 0) :
                parseFloat(
                  totalsangh <= billminusthevplusvahtukminusikapatminusbhishi ?
                    totalsangh > 0 ?
                      parseFloat(totalsangh)
                      : 0
                    :
                    parseFloat(billminusthevplusvahtukminusikapatminusbhishi)
                ).toFixed(2);

              let currentintr = parseFloat(parseFloat(parseFloat(parseFloat(parseFloat(totalkarj) * parseFloat(user.karjintr)) / 100) / 365) * 10).toFixed(2);
              let karjintrtemp = user.flag === "oldbill" ?
                (user.ratibkapat && user.ratibkapat !== '0' ? user.ratibkapat : 0) :
                parseFloat(
                  parseFloat(parseFloat(parseFloat(parseFloat(parseFloat(totalkarj) * parseFloat(user.karjintr)) / 100) / 365) * 10).toFixed(2)
                ).toFixed(2);

              let kapattillsangh = parseFloat(parseFloat(parseFloat(user.bill) + parseFloat(tvahtuk)) - parseFloat(parseFloat(allthevtofixedall) + parseFloat(user.ikapatbill2) + parseFloat(sanghedit) + parseFloat(bhishiedit))).toFixed(2);
              parseFloat(karjintrtemp) <= parseFloat(kapattillsangh) ?
                karjintrtemp = karjintrtemp
                :
                karjintrtemp = parseFloat(kapattillsangh)


              let kapattillkarjintr = parseFloat(parseFloat(parseFloat(user.bill) + parseFloat(tvahtuk)) - parseFloat(parseFloat(allthevtofixedall) + parseFloat(user.ikapatbill2) + parseFloat(sanghedit) + parseFloat(bhishiedit) + parseFloat(karjintrtemp))).toFixed(2);


              let karjedit = user.flag === "oldbill" ?
                (user.karjhpta && user.karjhpta !== '0' ? user.karjhpta : 0) :
                parseFloat(
                  totalkarj <= kapattillkarjintr ?
                    parseFloat(totalkarj)
                    :
                    parseFloat(user.karjhpta) <= kapattillkarjintr
                      ?
                      parseFloat(user.karjhpta)
                      :
                      parseFloat(kapattillkarjintr)
                ).toFixed(2);

              let karjintr = user.flag === "oldbill" ?
                (user.karjintr && user.karjintr !== '0' ? user.karjintr : 0) :
                parseFloat(
                  karjedit > 0 ?
                    currentintr
                    :
                    totalkarj <= kapattillsangh
                      ?
                      totalkarj
                      :
                      kapattillsangh
                ).toFixed(2);

              parseFloat(karjintr) <= parseFloat(kapattillsangh) ?
                karjintr = karjintr
                :
                karjintr = parseFloat(kapattillsangh)

              let tillkarj = (parseFloat(billminusthevplusvahtuk) - (parseFloat(user.ikapatbill2) + parseFloat(karjedit) + parseFloat(karjintr) + parseFloat(sanghedit) + parseFloat(bhishiedit)));


              let ratibedit = user.flag === "oldbill" ?
                (user.ratibkapat && user.ratibkapat !== '0' ? user.ratibkapat : 0) :
                parseFloat(
                  totalratib <= tillkarj ?
                    totalratib
                    :
                    tillkarj
                ).toFixed(2);



              let khedit = user.flag === "oldbill" ?
                (user.khadyakapat && user.khadyakapat !== '0' ? user.khadyakapat : 0) :
                parseFloat(
                  totalkhadya < billminusthev ?
                    user.khadyahpta && user.khadyahpta !== null && user.khadyahpta !== '0'
                      ?
                      parseFloat(user.khadyahpta).toFixed(2)
                      :
                      user.advhpta && user.advhpta !== null && user.advhpta !== '0' ?
                        parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0 > 0 ?
                          parseFloat(billminusthev < totalkhadya ?
                            billminusthev :
                            totalkhadya)
                          - parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)
                          : 0
                        :
                        billminusthev < totalkhadya ?
                          billminusthev :
                          totalkhadya

                    :
                    //parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)) -       

                    parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))) -
                      parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                    ) > 0 && parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                    ) -
                      parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                    ) < totalkhadya ?

                      parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                      ) -
                      parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                      + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)

                      :
                      parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                      ) -
                        parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))))
                      + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                ).toFixed(2);

              let tillratib = parseFloat(tillkarj) - parseFloat(ratibedit);

              khedit = user.flag === "oldbill" ?
                (user.khadyakapat && user.khadyakapat !== '0' ? user.khadyakapat : 0) :
                parseFloat(
                  totalkhadya <= tillratib ?
                    totalkhadya > 0 ?
                      totalkhadya
                      : 0
                    :
                    tillratib
                ).toFixed(2);

              let advedit = user.flag === "oldbill" ?
                (user.advkapat ? user.advkapat : 0) :
                parseFloat(tadvance > 0 ?
                  parseFloat(advancehfta != 0 && advancehfta <= (billminusallthev - khedit) ?
                    advancehfta <= tadvance
                      ?
                      user.advhpta <= parseFloat(billminusallthev - totalkhadya)
                        ?
                        parseFloat(user.advhpta)
                        :
                        parseFloat(billminusallthev - totalkhadya) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                      :
                      tadvance
                    :
                    billminusallthev
                      >
                      parseFloat(
                        billminusallthev < parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0) ?
                          billminusallthev :
                          parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0))

                      ?
                      parseFloat(
                        billminusallthev
                        -
                        parseFloat(
                          billminusallthev < parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0) ?
                            billminusallthev :
                            parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0)))
                        <=
                        parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)

                        ?
                        parseFloat(parseFloat(
                          billminusallthev -
                          parseFloat(
                            billminusallthev < parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0) ?
                              billminusallthev :
                              parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0))
                        )
                          -
                          parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                          +
                          parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0)
                          +
                          parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                        ).toFixed(2)
                        :

                        parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)
                      :
                      0)
                  :
                  0);

              let tillkhadya = parseFloat(tillratib) - parseFloat(khedit);

              advedit = user.flag === "oldbill" ?
                (user.advkapat && user.advkapat !== '0' ? user.advkapat : 0) :
                parseFloat(
                  tadvance <= tillkhadya ?
                    tadvance > 0 ?
                      parseFloat(advancehfta) > 0
                        ?
                        parseFloat(advancehfta) < parseFloat(tadvance)
                          ?
                          parseFloat(advancehfta)
                          :
                          tadvance
                        :
                        tadvance
                      : 0
                    :
                    parseFloat(advancehfta) > 0
                      ?
                      (parseFloat(advancehfta) <= parseFloat(tillkhadya))
                        ?
                        parseFloat(user.advhpta)
                        :
                        parseFloat(tillkhadya)
                      :
                      parseFloat(tillkhadya)
                ).toFixed(2);

              addOrUpdateCuchal(user.kno, localStorage.getItem("autocutting") === "on" ? advedit : user.flag === "oldbill" ? advedit : 0);
              addOrUpdateCkhadya(user.kno, localStorage.getItem("autocutting") === "on" ? khedit : user.flag === "oldbill" ? khedit : 0);
              addOrUpdateCratib(user.kno, localStorage.getItem("autocutting") === "on" ? ratibedit : user.flag === "oldbill" ? ratibedit : 0);
              addOrUpdatesangh(user.kno, localStorage.getItem("autocutting") === "on" ? sanghedit : user.flag === "oldbill" ? sanghedit : 0);
              addOrUpdatebhishi(user.kno, bhishiedit);

              addOrUpdateCkarj(user.kno, karjedit);
              addOrUpdateCkarjintr(user.kno, karjintr);

              if (response.data[0].flag === "oldbill") {
                updatedDataSource[index] = {
                  ...updatedDataSource[index],
                  ikapatedit4: user?.itrkapat1 ?? "0",
                  ikapatedit5: user?.itrkapat2 ?? "0",
                  ikapatedit6: user?.itrkapat3 ?? "0",
                };
              }
            })
          }

          if (response.data[0].flag === "oldbill") {
            setWait(false);
            setIsFetching(false);
            setIsCounting(false);
            //return;
          }
        }
        // Proceed to the next batch regardless of success or empty response

        // if (flag === "a") {
        setDataSource(updatedDataSource);
        // console.log("UPD 2", updatedDataSource);
        // }

        //updatedDataSource = [...DataSource];

        await delay(200);

        // await fetchBills(i + 2);
        i = 2000;
        setWait(false);

      } catch (error) {
        console.log(error);
        setWait(false);
        setIsFetching(false);
      }
    };
    await fetchBills(0);

    addTotalRow('myTablebill');
  };


  const getbillsingle = async () => {
    setWait(true);
    const mainuser2 = jsEncode.encode("mamapr", 125);

    if (input.knofrom === "" || input.knoto === "") {
      notifyerror("सभासद क्रमांक भरा");
      setWait(false);
      setIsFetching(false);
      setIsCounting(false);
      return;
    }

    if (cancelRef.current) {
      setWait(false);
      setIsFetching(false);
      return;
    }


    const rawData = {
      date1: input.date1,
      date2: input.date2,
      knofrom: input.knofrom,
      knoto: input.knoto,
      kno2from: input.knofrom,
      kno2to: input.knoto,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(rawData));

    try {
      const response = await axios.post(
        'https://excellentdairy.com/dairy/php/cust/getbillfastsingle5.php',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data && response.data.length > 0) {
        setDataSource([]);

        if (response.data[0].flag === "oldbill") {
          setDataSource(response.data)
        }
        else {
          if (refresh === "true") {
            setDataSource(response.data)
          }
          else {
            setDataSource(prevDataSource => [...prevDataSource, ...response.data]);
          }
        }

        setWait(false);
        {
          response.data && response.data.map((user, index) => {

            // let allthevtofixed = 0;
            // localStorage.getItem("thevper") === "No" ?
            //   allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)
            //   :
            //   allthevtofixed = parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2);

            let allthevtofixed = 0;
            localStorage.getItem("thevper") === "No" ?
              allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)
              : localStorage.getItem("thevper") === "Yes" ?
                allthevtofixed = parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2)
                : localStorage.getItem("thevper") === "Bill" ?
                  allthevtofixed = parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0))
                  :
                  allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)


            let billminusthev = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed)).toFixed(2);
            let tadvance = parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2);
            let advancehfta = user.advhpta && user.advhpta !== null && user.advhpta !== '0' && parseFloat(user.advhpta);
            let totalkhadya = parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0)

            let khedit = user.flag === "oldbill" ?
              (user.khadyakapat && user.khadyakapat !== '0' ? user.khadyakapat : 0) :

              parseFloat(
                totalkhadya < billminusthev ?
                  user.khadyahpta && user.khadyahpta !== null && user.khadyahpta !== '0'
                    ?
                    parseFloat(user.khadyahpta).toFixed(2)
                    :
                    user.advhpta && user.advhpta !== null && user.advhpta !== '0' ?
                      parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0 > 0 ?
                        parseFloat(billminusthev < totalkhadya ?
                          billminusthev :
                          totalkhadya)
                        - parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)
                        : 0
                      :
                      billminusthev < totalkhadya ?
                        billminusthev :
                        totalkhadya

                  :
                  //parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)) -       

                  parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))) -
                    parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                  ) > 0 && parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                  ) -
                    parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                  ) < totalkhadya ?

                    parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                    ) -
                    parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                    + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)

                    :
                    parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                    ) -
                      parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))))
                    + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
              ).toFixed(2);

            let advedit = user.flag === "oldbill" ?
              (user.advkapat ? user.advkapat : 0) :
              parseFloat(tadvance > 0 ?
                parseFloat(advancehfta != 0 && advancehfta <= (billminusthev - khedit) ?
                  advancehfta <= tadvance
                    ?
                    user.advhpta <= parseFloat(billminusthev - totalkhadya)
                      ?
                      parseFloat(user.advhpta)
                      :
                      parseFloat(billminusthev - totalkhadya) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                    :
                    tadvance
                  :
                  billminusthev
                    >
                    parseFloat(
                      billminusthev < parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0) ?
                        billminusthev :
                        parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0))

                    ?
                    parseFloat(
                      billminusthev
                      -
                      parseFloat(
                        billminusthev < parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0) ?
                          billminusthev :
                          parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0)))
                      <=
                      parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)

                      ?
                      parseFloat(parseFloat(
                        billminusthev -
                        parseFloat(
                          billminusthev < parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0) ?
                            billminusthev :
                            parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0))
                      )
                        -
                        parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                        +
                        parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0)
                        +
                        parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                      ).toFixed(2)
                      :

                      parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)
                    :
                    0)
                :
                0);

            addOrUpdateCuchal(user.kno, advedit);
            addOrUpdateCkhadya(user.kno, khedit);
          })
        }
      }
      else {
        notifyerror("माहिती उपलब्ध नाही!");
        setWait(false);
      }

      // Proceed to the next batch regardless of success or empty response
      updatedDataSource = [...DataSource];


    } catch (error) {
      console.log(error);
      setWait(false);
      setIsFetching(false);
    }


  };

  const getbillsingleauto = async () => {

    setWait(true);
    const mainuser2 = jsEncode.encode("mamapr", 125);

    if (input.knofrom === "" || input.knoto === "") {
      notifyerror("सभासद क्रमांक भरा");
      setWait(false);
      setIsFetching(false);
      setIsCounting(false);
      return;
    }

    if (cancelRef.current) {
      setWait(false);
      setIsFetching(false);
      return;
    }

    const rawData = {
      date1: input.date1,
      date2: input.date2,
      knofrom: input.knofrom,
      knoto: input.knoto,
      kno2from: input.knofrom,
      kno2to: input.knoto,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(rawData));

    try {
      const response = await axios.post(
        'https://excellentdairy.com/dairy/php/cust/getbillfastsingle5.php',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data && response.data.length > 0) {
        setDataSource([]);

        if (response.data[0].flag === "oldbill") {
          setDataSource(response.data)
        }
        else {
          if (refresh === "true") {
            setDataSource(response.data)
          }
          else {
            setDataSource(prevDataSource => [...prevDataSource, ...response.data]);
          }
        }

        setWait(false);
        {
          response.data && response.data.map((user, index) => {

            // let allthevtofixed = 0;
            // localStorage.getItem("thevper") === "No" ?
            //   allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)
            //   :
            //   allthevtofixed = parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2);

            let allthevtofixed = 0;
            localStorage.getItem("thevper") === "No" ?
              allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)
              : localStorage.getItem("thevper") === "Yes" ?
                allthevtofixed = parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2)
                : localStorage.getItem("thevper") === "Bill" ?
                  allthevtofixed = parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0))
                  :
                  allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)


            let billminusthev = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed)).toFixed(2);
            let tadvance = parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2);
            let advancehfta = user.advhpta && user.advhpta !== null && user.advhpta !== '0' && parseFloat(user.advhpta);
            let totalkhadya = parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0)

            let khedit = user.flag === "oldbill" ?
              (user.khadyakapat && user.khadyakapat !== '0' ? user.khadyakapat : 0) :

              parseFloat(
                totalkhadya < billminusthev ?
                  user.khadyahpta && user.khadyahpta !== null && user.khadyahpta !== '0'
                    ?
                    parseFloat(user.khadyahpta).toFixed(2)
                    :
                    user.advhpta && user.advhpta !== null && user.advhpta !== '0' ?
                      parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0 > 0 ?
                        parseFloat(billminusthev < totalkhadya ?
                          billminusthev :
                          totalkhadya)
                        - parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)
                        : 0
                      :
                      billminusthev < totalkhadya ?
                        billminusthev :
                        totalkhadya

                  :
                  //parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)) -       

                  parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))) -
                    parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                  ) > 0 && parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                  ) -
                    parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                  ) < totalkhadya ?

                    parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                    ) -
                    parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                    + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)

                    :
                    parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                    ) -
                      parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))))
                    + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
              ).toFixed(2);

            let advedit = user.flag === "oldbill" ?
              (user.advkapat ? user.advkapat : 0) :
              parseFloat(tadvance > 0 ?
                parseFloat(advancehfta != 0 && advancehfta <= (billminusthev - khedit) ?
                  advancehfta <= tadvance
                    ?
                    user.advhpta <= parseFloat(billminusthev - totalkhadya)
                      ?
                      parseFloat(user.advhpta)
                      :
                      parseFloat(billminusthev - totalkhadya) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                    :
                    tadvance
                  :
                  billminusthev
                    >
                    parseFloat(
                      billminusthev < parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0) ?
                        billminusthev :
                        parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0))

                    ?
                    parseFloat(
                      billminusthev
                      -
                      parseFloat(
                        billminusthev < parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0) ?
                          billminusthev :
                          parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0)))
                      <=
                      parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)

                      ?
                      parseFloat(parseFloat(
                        billminusthev -
                        parseFloat(
                          billminusthev < parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0) ?
                            billminusthev :
                            parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0))
                      )
                        -
                        parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                        +
                        parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0)
                        +
                        parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                      ).toFixed(2)
                      :

                      parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)
                    :
                    0)
                :
                0);

            addOrUpdateCuchal(user.kno, advedit);
            addOrUpdateCkhadya(user.kno, khedit);
          })
        }

      }
      else {
        notifyerror("माहिती उपलब्ध नाही!");
        setWait(false);
      }

      // Proceed to the next batch regardless of success or empty response
      updatedDataSource = [...DataSource];


      if (input.knofrom === input.knoto) {
        await delay(1000);
        fetchtabledata();
      }

    } catch (error) {
      console.log(error);
      setWait(false);
      setIsFetching(false);
    }
  };


  function formatDate(inputDate) {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(inputDate).toLocaleDateString('en-IN', options);
  }

  const deletebill = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);

    if (input.knofrom === "" || input.knoto === "") {
      notifyerror("सभासद क्रमांक भरा");
      return;
    }
    let rawData = {
      date1: input.date1,
      date2: input.date2,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post('https://excellentdairy.com/dairy/php/cust/deletebill2.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      if (response.data.trim() === "Deleted") {
        notify(t("bill.memberBillDeleted"));
        refdeleteclose.current.click();
        setDataSource([]);
        getmaxno();
        deleteaudit();
      }
    }).catch(err => {
      console.log(err);
    });
  }


  const deletebillesingle = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    if (input.knofrom === "" || input.knoto === "") {
      notifyerror("सभासद क्रमांक भरा");
      return;
    }
    let rawData = {
      date1: input.date1,
      date2: input.date2,
      kno: input.knofrom,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post('https://excellentdairy.com/dairy/php/cust/deletebillsingle.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      if (response.data.trim() === "Deleted") {
        // notify("खाते क्रमांक " + input.knofrom + "चे सभासद बील डिलीट झाले!");
        refdeletesingleclose.current.click();
        setDataSource([]);
        // getmaxno();
        getbillsingleauto();
      }
    }).catch(err => {
      console.log(err);
    });
  }

  const handleedit = (sr, date, time, kno, name, type, liter, fat, snf, rate, amt) => {
    // setInput({ date: date, time: time, kno: kno, name: name, type: type, liter: liter, fat: fat, snf: snf, rate: rate, amt: amt })
    // setNewedit("edit");
    // setSredit(sr);
  }
  const handleChange = async (event) => {
    const name = event.target.name;
    let valuecurrent = "";
    valuecurrent = event.target.value;


    if (name === 'date1') {

      const currentDate1 = new Date(valuecurrent);
      const dayOfMonth1 = currentDate1.getDate();
      const currentMonth1 = currentDate1.getMonth();
      const currentYear1 = currentDate1.getFullYear();

      if (localStorage.getItem("dur") === "10") {
        if (dayOfMonth1 == '1' || dayOfMonth1 == '11' || dayOfMonth1 == '21') {
          // If the value is blank or invalid, reset to the last valid date or today
          if (value === "" || value === "dd/mm/yyyy" || value > today) {
            setInput(prevInput => ({
              ...prevInput,
              date1: prevInput.date1 && prevInput.date1 <= today ? prevInput.date1 : today
            }));

            setInput(value => ({ ...value, [name]: valuecurrent }));
            return;
          }
        }
        else {
          notifyerror("कृपया १, ११ किंवा २१ यामधील दिनांक निवडा!")
        }
      }
      else if (localStorage.getItem("dur") === "15") {
        if (dayOfMonth1 == '1' || dayOfMonth1 == '16') {
          // If the value is blank or invalid, reset to the last valid date or today
          if (value === "" || value === "dd/mm/yyyy" || value > today) {
            setInput(prevInput => ({
              ...prevInput,
              date1: prevInput.date1 && prevInput.date1 <= today ? prevInput.date1 : today
            }));

            setInput(value => ({ ...value, [name]: valuecurrent }));
            return;
          }
        }
        else {
          notifyerror("कृपया १, १६ यामधील दिनांक निवडा!")
        }
      }
      else if (localStorage.getItem("dur") === "30") {
        if (dayOfMonth1 == '1') {
          // If the value is blank or invalid, reset to the last valid date or today
          if (value === "" || value === "dd/mm/yyyy" || value > today) {
            setInput(prevInput => ({
              ...prevInput,
              date1: prevInput.date1 && prevInput.date1 <= today ? prevInput.date1 : today
            }));

            setInput(value => ({ ...value, [name]: valuecurrent }));
            return;
          }
        }
        else {
          notifyerror("फक्त १ दिनांक निवडू शकता (बिल प्रकार- १ महिना)!")
        }
      }
    }
    else {
      setInput(value => ({ ...value, [name]: valuecurrent }));
    }
  }

  const handleBack = () => {
    cancelRef.current = true; // Set cancel flag in the ref
    setTimeout(() => {
      props.visibility();
    }, 500); // 500 ms delay (you can adjust this time as needed)
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      // Make sure that the input is a string
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        // Create block
        var a = str.charCodeAt(i);
        // Bitwise XOR
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={reftrailprint}
        data-bs-target="#trialprintbox"
      >
      </button>

      <div className="modal fade" id="trialprintbox" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={reftrailprintclose} aria-label="Close">
              </button>
            </div>
            <div className="modal-body">
              <h5 className="modal-title" id="exampleModalLabel">{t("bill.modal.trialPrint.title")}</h5>
              <div className='helpmain'>
                <img className='smallimg' src={Status} alt="" />
                <input onChange={handleChange} type="number" className="form-control" id="knofromprint" name="knofromprint" value={input.knofromprint} autoComplete='off' />
                <span>{t("bill.ui.to")}</span>
                <input onChange={handleChange} type="number" className="form-control" id="knotoprint" name="knotoprint" value={input.knotoprint} autoComplete='off' />
              </div>

              <span className="greenlbl" htmlFor="activeother">
                {t("bill.modal.trialPrint.note")}
              </span>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleprinttrialclose}>
                {t("bill.btn.close")}
              </button>
              {waitprinttest ? (
                <button type="button" className="btn btn-success">{t("bill.btn.loading")}</button>
              ) : (
                <button type="button" className="btn btn-success" onClick={showtrialprint}>{t("bill.btn.ok")}</button>
              )}
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refdeletesingle}
        data-bs-target="#deletebillsingle"
      >
      </button>

      <div className="modal fade" id="deletebillsingle" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refdeletesingleclose} aria-label="Close">
              </button>
            </div>
            <div className="modal-body">
              <h4 className="modal-title" id="exampleModalLabel">
                {t("bill.modal.refreshSingle.title", { acc: input.knofrom })}
              </h4>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handledeletesingleclose}>
                {t("bill.btn.no")}
              </button>
              <button type="button" className="btn btn-danger" onClick={deletebillesingle}>
                {t("bill.btn.yes")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refprint}
        data-bs-target="#printinput"
      >
      </button>

      <div className="modal fade" id="printinput" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refprintclose} aria-label="Close">
              </button>
            </div>
            <div className="modal-body">
              <h5 className="modal-title" id="exampleModalLabel">{t("bill.modal.print.title")}</h5>
              <div className='helpmain'>
                <img className='smallimg' src={Status} alt="" />
                <input onChange={handleChange} type="number" className="form-control" id="knofromprint" name="knofromprint" value={input.knofromprint} autoComplete='off' />
                <span>{t("bill.ui.to")}</span>
                <input onChange={handleChange} type="number" className="form-control" id="knotoprint" name="knotoprint" value={input.knotoprint} autoComplete='off' />
              </div>

              <div className="radiotheme">
                <div className="form-check">
                  <input onClick={e => handlertype(e, 2)} defaultChecked className="form-check-input" type="radio" name="exampleRadios" id="radio1" value="option1" />
                  <label className="form-check-label radiolabel" htmlFor="radio1">
                    {t("bill.modal.print.design1")}
                  </label>
                </div>

                <div className="form-check">
                  <input onClick={e => handlertype(e, 3)} className="form-check-input" type="radio" name="exampleRadios" id="radio3" value="option3" />
                  <label className="form-check-label radiolabel" htmlFor="radio3">
                    {t("bill.modal.print.design2")}
                  </label>
                </div>

                <div className="form-check">
                  <input onClick={e => handlertype(e, 1)} className="form-check-input" type="radio" name="exampleRadios" id="radio2" value="option2" />
                  <label className="form-check-label radiolabel" htmlFor="radio2">
                    {t("bill.modal.print.design3")}
                  </label>
                </div>

                <div className="form-check">
                  <input onClick={e => handlertype(e, 4)} className="form-check-input" type="radio" name="exampleRadios" id="radio4" value="option4" />
                  <label className="form-check-label radiolabel" htmlFor="radio4">
                    {t("bill.modal.print.design4")}
                  </label>
                </div>

                <div className="form-check">
                  <input onClick={e => handlertype(e, 5)} className="form-check-input" type="radio" name="exampleRadios" id="radio5" value="option5" />
                  <label className="form-check-label radiolabel" htmlFor="radio5">
                    {t("bill.modal.print.design5")}
                  </label>
                </div>

                <div className="form-check">
                  <input onClick={e => handlertype(e, 6)} className="form-check-input" type="radio" name="exampleRadios" id="radio6" value="option6" />
                  <label className="form-check-label radiolabel" htmlFor="radio6">
                    {t("bill.modal.print.design6")}
                  </label>
                </div>
              </div>

              <div className="form-check check">
                <input className="form-check-input" type="checkbox" defaultChecked value="" onChange={handleOtheractive} id="activeother" />
                <input onChange={handleChange} type="text" className="form-control" id="ikapatnote" name="ikapatnote" value={input.ikapatnote} autoComplete='off' />
              </div>

              <div className="mb-2">
                <span className='subheadsank'>{t("bill.modal.print.mobileUserLabel")}</span>
                <select
                  onKeyDown={e => handleEnterKey(e, 6)}
                  ref={ref => (inputRefs.current[6] = ref)}
                  className={"form-control"}
                  autoComplete='off'
                  id="mobileuser"
                  name="mobileuser"
                  value={input.mobileuser}
                  onChange={handleChange}
                >
                  <option key={0} value={t("bill.modal.print.mobileUserPlaceholder")}>
                    {t("bill.modal.print.mobileUserPlaceholder")}
                  </option>
                  {mobileusers ? mobileusers.map((opt2, index) =>
                    <option key={index + 1} value={opt2.name}>{opt2.name}</option>
                  ) : ""}
                </select>
              </div>

              <span className='note'>{t("bill.modal.print.settingsTitle")}</span>

              <div className="form-check check">
                <input className="form-check-input" type="checkbox" defaultChecked value="" onChange={handleOtheractive} id="activeother" />
                <span className="checklbl" htmlFor="activeother">
                  {t("bill.modal.print.otherDeduction")}
                </span>
              </div>

              <div className="form-check check">
                <input className="form-check-input" type="checkbox" defaultChecked value="" onChange={handlethev} id="activethev" />
                <span className="checklbl" htmlFor="activethev">
                  {t("bill.modal.print.prevAndRemainingDeposit")}
                </span>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleprintclose}>
                {t("bill.btn.close")}
              </button>
              {waitprint ? (
                <button type="button" className="btn btn-danger">{t("bill.btn.loading")}</button>
              ) : (
                <button type="button" className="btn btn-danger" onClick={showprint}>{t("bill.btn.ok")}</button>
              )}
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refdelete}
        data-bs-target="#deletebill"
      >
      </button>

      <div className="modal fade" id="deletebill" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refdeleteclose} aria-label="Close">
              </button>
            </div>
            <div className="modal-body">
              <h4 className="modal-title" id="exampleModalLabel">{t("bill.modal.deleteAll.title")}</h4>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handledeleteclose}>
                {t("bill.btn.no")}
              </button>
              <button type="button" className="btn btn-danger" onClick={deletebill}>
                {t("bill.btn.yes")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="sanklanmain">
        <span className="redbill" htmlFor="activestatus">
          {t("bill.lastSavedBill", { d1: formatDate(lastdate1), d2: formatDate(lastdate2) })}
        </span>
        <div className="linebill"></div>
        <div className="firstrowsank">

          <img onClick={handleBack} className='back' src={back} alt="" />
          <div className="colmainbill">


            <div className="firstrowbill">
              <div className="rowbill">
                <div className="mb-2">
                  <span className='subheadsank'>{t("bill.ui.date")}</span>
                  <input
                    max={today}
                    onKeyDown={e => handleEnterKey(e, 0)}
                    ref={ref => (inputRefs.current[0] = ref)}
                    type="date"
                    className="form-control"
                    autoComplete='off'
                    id="date1"
                    name="date1"
                    value={input.date1}
                    onChange={handleChange}
                  />
                </div>

                <span className='subheadbill'>{t("bill.ui.to")}</span>

                <div className="mb-2">
                  <span className='subheadsank'>{t("bill.ui.date")}</span>
                  <input
                    disabled
                    onKeyDown={e => handleEnterKey(e, 1)}
                    ref={ref => (inputRefs.current[1] = ref)}
                    type="date"
                    className="form-control"
                    autoComplete='off'
                    id="date2"
                    name="date2"
                    value={input.date2}
                    onChange={handleChange}
                  />
                </div>

                <span className='subheadbill se'> || </span>

                <div className="mb-2 se">
                  <span className='subheadsank'>{t("bill.ui.accShort")}</span>

                  {DataSource && DataSource.length === 0 ? (
                    <input
                      onKeyDown={e => handleEnterKey(e, 2)}
                      ref={ref => (inputRefs.current[2] = ref)}
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      id="knofrom"
                      name="knofrom"
                      value={input.knofrom}
                      onChange={handleChange}
                    />
                  ) : DataSource[0].flag === "oldbill" ? (
                    (DataSource[0]?.lastbill === "Yes" ||
                      DataSource[1]?.lastbill === "Yes" ||
                      DataSource[2]?.lastbill === "Yes" ||
                      DataSource[3]?.lastbill === "Yes" ||
                      DataSource[4]?.lastbill === "Yes") ? (
                      <input
                        onKeyDown={e => handleEnterKey(e, 2)}
                        ref={ref => (inputRefs.current[2] = ref)}
                        type="text"
                        className="form-control"
                        autoComplete='off'
                        id="knofrom"
                        name="knofrom"
                        value={input.knofrom}
                        onChange={handleChange}
                      />
                    ) : (
                      <input
                        disabled
                        onKeyDown={e => handleEnterKey(e, 2)}
                        ref={ref => (inputRefs.current[2] = ref)}
                        type="text"
                        className="form-control"
                        autoComplete='off'
                        id="knofrom"
                        name="knofrom"
                        value={input.knofrom}
                        onChange={handleChange}
                      />
                    )
                  ) : (
                    <input
                      disabled
                      onKeyDown={e => handleEnterKey(e, 2)}
                      ref={ref => (inputRefs.current[2] = ref)}
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      id="knofrom"
                      name="knofrom"
                      value={input.knofrom}
                      onChange={handleChange}
                    />
                  )}
                </div>

                <span className='subheadbill'>{t("bill.ui.to")}</span>

                <div className="mb-2 se">
                  <span className='subheadsank'>{t("bill.ui.accShort2")}</span>

                  {DataSource && DataSource.length === 0 ? (
                    <input
                      disabled
                      onKeyDown={e => handleEnterKey(e, 3)}
                      ref={ref => (inputRefs.current[3] = ref)}
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      id="knoto"
                      name="knoto"
                      value={input.knoto}
                      onChange={handleChange}
                    />
                  ) : DataSource[0].flag === "oldbill" ? (
                    (DataSource[0]?.lastbill === "Yes" ||
                      DataSource[1]?.lastbill === "Yes" ||
                      DataSource[2]?.lastbill === "Yes" ||
                      DataSource[3]?.lastbill === "Yes" ||
                      DataSource[4]?.lastbill === "Yes") ? (
                      <input
                        onKeyDown={e => handleEnterKey(e, 3)}
                        ref={ref => (inputRefs.current[3] = ref)}
                        type="text"
                        className="form-control"
                        autoComplete='off'
                        id="knoto"
                        name="knoto"
                        value={input.knoto}
                        onChange={handleChange}
                      />
                    ) : (
                      <input
                        disabled
                        onKeyDown={e => handleEnterKey(e, 3)}
                        ref={ref => (inputRefs.current[3] = ref)}
                        type="text"
                        className="form-control"
                        autoComplete='off'
                        id="knoto"
                        name="knoto"
                        value={input.knoto}
                        onChange={handleChange}
                      />
                    )
                  ) : (
                    <input
                      disabled
                      onKeyDown={e => handleEnterKey(e, 3)}
                      ref={ref => (inputRefs.current[3] = ref)}
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      id="knoto"
                      name="knoto"
                      value={input.knoto}
                      onChange={handleChange}
                    />
                  )}
                </div>

                <div className="mb-2">
                  {wait ? (
                    <button
                      ref={ref => (inputRefs.current[4] = ref)}
                      type="submit"
                      id='show'
                      className="btn btn-primary mx-1 sanksmall"
                    >
                      {t("bill.btn.loadingWithCount", { count })}
                    </button>
                  ) : input.knofrom === input.knoto ? (
                    <button
                      onClick={getbillsingle}
                      ref={ref => (inputRefs.current[4] = ref)}
                      type="submit"
                      id='show'
                      className="btn btn-primary mx-1 sanksmall"
                    >
                      {t("bill.btn.viewSingleBillOfAcc", { acc: input.knofrom })}
                    </button>
                  ) : (
                    <button
                      onClick={handleIsfetching}
                      ref={ref => (inputRefs.current[4] = ref)}
                      type="submit"
                      id='show'
                      className="btn btn-primary mx-1 sanksmall"
                    >
                      {t("bill.btn.viewBill")}
                    </button>
                  )}

                  {input.knofrom !== input.knoto
                    ? wait
                      ? ''
                      : DataSource && DataSource.length === 0
                        ? null
                        : (DataSource && DataSource.length > 1
                          ? (waitsave
                            ? (
                              <button
                                ref={ref => (inputRefs.current[4] = ref)}
                                type="submit"
                                id='save'
                                className="btn btn-primary mx-1 sanksmall"
                              >
                                {t("bill.btn.loadingDots")}
                              </button>
                            )
                            : (DataSource[0].flag === "newbill"
                              ? (
                                <button
                                  onClick={fetchtabledata}
                                  ref={ref => (inputRefs.current[4] = ref)}
                                  type="submit"
                                  id='save'
                                  className="btn btn-primary mx-1 sanksmall"
                                >
                                  {DataSource[0].flag === "oldbill" ? t("bill.btn.updateBill") : t("bill.btn.saveBill")}
                                </button>
                              )
                              : (DataSource[0].flag === "oldbill" && showUpdate
                                ? (
                                  <button
                                    onClick={fetchtabledata}
                                    ref={ref => (inputRefs.current[4] = ref)}
                                    type="submit"
                                    id='save'
                                    className="btn btn-primary mx-1 sanksmall"
                                  >
                                    {DataSource[0].flag === "oldbill" ? t("bill.btn.updateBill") : t("bill.btn.saveBill")}
                                  </button>
                                )
                                : ''
                              )
                            )
                          )
                          : ''
                        )
                    : ''
                  }

                  {DataSource && DataSource.length !== 0 ? '' : (
                    <button
                      onClick={handleprinttrial}
                      ref={ref => (inputRefs.current[4] = ref)}
                      type="submit"
                      id='print'
                      className="btn btn-success mx-1 sanksmall"
                    >
                      {t("bill.btn.trialPrints")}
                    </button>
                  )}

                  {input.knofrom !== input.knoto
                    ? wait
                      ? ''
                      : DataSource && DataSource.length === 0
                        ? ''
                        : (DataSource && DataSource.length > 1
                          ? (wait2
                            ? (
                              <button
                                ref={ref => (inputRefs.current[4] = ref)}
                                type="submit"
                                id='print'
                                className="btn btn-primary mx-1 sanksmall"
                              >
                                {t("bill.btn.loadingDots")}
                              </button>
                            )
                            : (
                              <button
                                onClick={handlePrint}
                                ref={ref => (inputRefs.current[4] = ref)}
                                type="submit"
                                id='print'
                                className="btn btn-primary mx-1 sanksmall"
                              >
                                {t("bill.btn.billPrint")}
                              </button>
                            )
                          )
                          : ''
                        )
                    : ''
                  }

                  {DataSource && DataSource.length !== 0
                    ? DataSource[0].flag === "oldbill"
                      ? (DataSource[0]?.lastbill === "Yes" ||
                        DataSource[1]?.lastbill === "Yes" ||
                        DataSource[2]?.lastbill === "Yes" ||
                        DataSource[3]?.lastbill === "Yes" ||
                        DataSource[4]?.lastbill === "Yes" ||
                        DataSource[5]?.lastbill === "Yes" ||
                        DataSource[6]?.lastbill === "Yes" ||
                        DataSource[7]?.lastbill === "Yes" ||
                        DataSource[8]?.lastbill === "Yes")
                        ? localStorage.getItem("audit", "") === "on"
                          ? (waittran
                            ? (
                              <button
                                ref={ref => (inputRefs.current[4] = ref)}
                                type="submit"
                                id='print'
                                className="btn btn-success mx-1 sanksmall"
                              >
                                {t("bill.btn.loadingShort")}
                              </button>
                            )
                            : (
                              <button
                                onClick={transferaudit}
                                ref={ref => (inputRefs.current[4] = ref)}
                                type="submit"
                                id='print'
                                className="btn btn-success mx-1 sanksmall"
                              >
                                {t("bill.btn.transferAudit")}
                              </button>
                            )
                          )
                          : ''
                        : ''
                      : ''
                    : ''
                  }
                </div>
              </div>

              <div className="optionbill">
                <div className='newbill'>
                  <span>
                    {DataSource && DataSource.length === 0
                      ? t("bill.badge.newBill")
                      : DataSource[0].flag === "oldbill"
                        ? t("bill.badge.oldBill")
                        : t("bill.badge.newBill")}
                  </span>

                  {DataSource && DataSource.length === 0 ? '' : (
                    DataSource[0].flag === "oldbill"
                      ? (DataSource[0]?.lastbill === "Yes" ||
                        DataSource[1]?.lastbill === "Yes" ||
                        DataSource[2]?.lastbill === "Yes" ||
                        DataSource[3]?.lastbill === "Yes" ||
                        DataSource[4]?.lastbill === "Yes" ||
                        DataSource[5]?.lastbill === "Yes" ||
                        DataSource[6]?.lastbill === "Yes" ||
                        DataSource[7]?.lastbill === "Yes" ||
                        DataSource[8]?.lastbill === "Yes")
                        ? <UilTrash onClick={handleDelete} className="icdelete" />
                        : ''
                      : ''
                  )}
                </div>

                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" onChange={handleChangeactive} id="activestatus" />
                  <span className="checklbl" htmlFor="activestatus">
                    {t("bill.ui.allColumns")}
                  </span>
                </div>

                <div hidden className="form-check">
                  <input className="form-check-input" type="checkbox" value="" onChange={handleChangeactive} id="activestatus" />
                  <span className="checklbl" htmlFor="activestatus">
                    {t("bill.ui.moreDepositColumns")}
                  </span>
                </div>
              </div>
            </div>

          </div>
          <div className="line"></div>

        </div>
        {/* {
          DataSource && DataSource.length === 0 ?
            '' :
            DataSource[0].flag === "oldbill" ?
              <input type="text" className="form-control search mx-2" id="searchbill" name="searchbill" placeholder='खाते क्रमांक शोधा' value={value} onChange={filteData} autoComplete='off' />
              :
              ''
        } */}
        <div className="firstrow2">
          <div class="table-containerbill">
            <table id="myTablebill" className="table table-bordered">
              <thead>
                <tr>
                  <th className='thsmall' scope="col">{t("bill.th.accNo")}</th>
                  <th className='thlarge' scope="col">{t("bill.th.name")}</th>
                  <th className='thsmall' scope="col">{t("bill.th.billAmt")}</th>

                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">
                    {t("bill.th.extraLiter")}
                  </th>

                  <th className={'thsmallhide'} scope="col">{t("bill.th.prevThev")}</th>

                  <th className='thsmall' scope="col">
                    {t("bill.th.thevDeduction")}<span><br />{t("bill.sign.minus")}</span>
                  </th>

                  <th className={'thsmallhide'} scope="col">{t("bill.th.newThev")}</th>

                  {localStorage.getItem("itr1name") !== "-" ? (
                    <>
                      <th className={'thsmallhide'} scope="col">{t("bill.th.prevX", { x: localStorage.getItem("itr1name") })}</th>
                      <th className='thsmall' scope="col">{localStorage.getItem("itr1name")}</th>
                      <th className={'thsmallhide'} scope="col">{t("bill.th.newX", { x: localStorage.getItem("itr1name") })}</th>
                    </>
                  ) : (
                    <>
                      <th className={'thsmallhide'} scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className={'thsmallhide'} scope="col"></th>
                    </>
                  )}

                  {localStorage.getItem("itr2name") !== "-" ? (
                    <>
                      <th className={'thsmallhide'} scope="col">{t("bill.th.prevX", { x: localStorage.getItem("itr2name") })}</th>
                      <th className='thsmall' scope="col">{localStorage.getItem("itr2name")}</th>
                      <th className={'thsmallhide'} scope="col">{t("bill.th.newX", { x: localStorage.getItem("itr2name") })}</th>
                    </>
                  ) : (
                    <>
                      <th className={'thsmallhide'} scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className={'thsmallhide'} scope="col"></th>
                    </>
                  )}

                  {localStorage.getItem("itr3name") !== "-" ? (
                    <>
                      <th className={'thsmallhide'} scope="col">{t("bill.th.prevX", { x: localStorage.getItem("itr3name") })}</th>
                      <th className='thsmall' scope="col">{localStorage.getItem("itr3name")}</th>
                      <th className={'thsmallhide'} scope="col">{t("bill.th.newX", { x: localStorage.getItem("itr3name") })}</th>
                    </>
                  ) : (
                    <>
                      <th className={'thsmallhide'} scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className={'thsmallhide'} scope="col"></th>
                    </>
                  )}

                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.prevAdvanceBal")}</th>
                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.onAdvance")}</th>
                  <th className='thsmall' scope="col">{t("bill.th.totalAdvance")}</th>

                  <th className='thsmall' scope="col">
                    <UilEditAlt className="editlogo" />
                    {t("bill.th.advanceDeduction")}<br /><span>{t("bill.sign.minus")}</span>
                  </th>

                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmall'} scope="col">{t("bill.th.advanceBal")}</th>

                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.prevKhBal")}</th>
                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.onKh")}</th>
                  <th className='thsmall' scope="col">{t("bill.th.totalKh")}</th>

                  <th className='thsmall' scope="col">
                    <UilEditAlt className="editlogo" />
                    {t("bill.th.khDeduction")}<br /><span>{t("bill.sign.minus")}</span>
                  </th>

                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmall'} scope="col">{t("bill.th.khBal")}</th>

                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.prevRatibBal")}</th>
                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.onRatib")}</th>
                  <th className='thsmall' scope="col">{t("bill.th.totalRatib")}</th>

                  <th className='thsmall' scope="col">
                    <UilEditAlt className="editlogo" />
                    {t("bill.th.ratibDeduction")}<br /><span>{t("bill.sign.minus")}</span>
                  </th>

                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmall'} scope="col">{t("bill.th.ratibBal")}</th>

                  {localStorage.getItem("karj") === "On" ? (
                    <>
                      <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.prevLoan")}</th>
                      <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.onLoan")}</th>
                      <th className='thsmall' scope="col">{t("bill.th.totalLoan")}</th>

                      <th className='thsmall' scope="col">
                        <UilEditAlt className="editlogo" />
                        {t("bill.th.loanInstallment")}<br /><span>{t("bill.sign.minus")}</span>
                      </th>

                      <th className='thsmall' scope="col">
                        <UilEditAlt className="editlogo" />
                        {t("bill.th.interest")}<br /><span>{t("bill.sign.minus")}</span>
                      </th>

                      <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmall'} scope="col">{t("bill.th.loanBal")}</th>
                    </>
                  ) : (
                    <>
                      <th className={'thsmallhide'} scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className={'thsmallhide'} scope="col"></th>
                      <th className={'thsmallhide'} scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className={'thsmallhide'} scope="col"></th>
                    </>
                  )}

                  {localStorage.getItem("sanghk") === "On" ? (
                    <>
                      <th
                        className={
                          localStorage.getItem("sanghkname") === "संघ खरेदी"
                            ? (showthevcol === "Yes" ? 'thsmall' : 'thsmallhide')
                            : 'thsmallhide'
                        }
                        scope="col"
                      >
                        {t("bill.th.prevXshort", { x: localStorage.getItem("sanghkname") })}
                      </th>

                      <th
                        className={
                          localStorage.getItem("sanghkname") === "संघ खरेदी"
                            ? (showthevcol === "Yes" ? 'thsmall' : 'thsmallhide')
                            : 'thsmallhide'
                        }
                        scope="col"
                      >
                        {t("bill.th.onX", { x: localStorage.getItem("sanghkname") })}
                      </th>

                      <th className={localStorage.getItem("sanghkname") === "संघ खरेदी" ? 'thsmall' : 'thsmallhide'} scope="col">
                        {localStorage.getItem("sanghkname")}
                      </th>

                      <th className={'thsmall'} scope="col">
                        <UilEditAlt className="editlogo" />
                        {t("bill.th.xDeduction", { x: localStorage.getItem("sanghkname") })}<br />
                        <span>{t("bill.sign.minus")}</span>
                      </th>

                      <th
                        className={
                          localStorage.getItem("sanghkname") === "संघ खरेदी"
                            ? (showthevcol === "Yes" ? 'thsmall' : 'thsmall')
                            : 'thsmallhide'
                        }
                        scope="col"
                      >
                        {t("bill.th.xBalance", { x: localStorage.getItem("sanghkname") })}
                      </th>
                    </>
                  ) : (
                    <>
                      <th className={'thsmallhide'} scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className={'thsmallhide'} scope="col"></th>
                      <th className={'thsmallhide'} scope="col"></th>
                      <th className={'thsmallhide'} scope="col"></th>
                    </>
                  )}

                  {localStorage.getItem("itrname") !== "-" ? (
                    <>
                      <th className={'thsmall'} scope="col">{t("bill.th.prevX", { x: localStorage.getItem("itrname") })}</th>
                      <th className='thsmall' scope="col">
                        {t("bill.th.xDeductionOnly", { x: localStorage.getItem("itrname") })}<span><br />{t("bill.sign.minus")}</span>
                      </th>
                      <th className={'thsmall'} scope="col">{t("bill.th.newX", { x: localStorage.getItem("itrname") })}</th>
                    </>
                  ) : (
                    <>
                      <th className='thsmallhide' scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                    </>
                  )}

                  <th className={'thsmallhide'} scope="col">{t("bill.th.otherDeductionPerLiter")}<br /><span>{t("bill.sign.minus")}</span></th>

                  <th className={'thsmall'} scope="col">
                    {localStorage.getItem("itrmainname")}<br /><span>{t("bill.sign.minus")}</span>
                  </th>

                  {localStorage.getItem("retan") === "On" ? (
                    <>
                      <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.prevRetanBal")}</th>
                      <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">{t("bill.th.onRetan")}</th>
                      <th className='thsmall' scope="col">{t("bill.th.totalRetan")}</th>
                      <th className={'thsmall'} scope="col">{t("bill.th.cowRetan")}<br /><span>{t("bill.sign.minus")}</span></th>
                      <th className={'thsmall'} scope="col">{t("bill.th.vet")}<br /><span>{t("bill.sign.minus")}</span></th>
                      <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmall'} scope="col">{t("bill.th.retanBal")}</th>
                    </>
                  ) : (
                    <>
                      <th className='thsmallhide' scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                      <th className='thsmallhide' scope="col"></th>
                    </>
                  )}

                  {localStorage.getItem("itr4name") !== "-" ? (
                    <th className='thsmall' scope="col">{localStorage.getItem("itr4name")}</th>
                  ) : (
                    <th className='thsmallhide' scope="col"></th>
                  )}

                  {localStorage.getItem("itr5name") !== "-" ? (
                    <th className='thsmall' scope="col">{localStorage.getItem("itr5name")}</th>
                  ) : (
                    <th className='thsmallhide' scope="col"></th>
                  )}

                  {localStorage.getItem("itr6name") !== "-" ? (
                    <th className='thsmall' scope="col">{localStorage.getItem("itr6name")}</th>
                  ) : (
                    <th className='thsmallhide' scope="col"></th>
                  )}

                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">
                    {t("bill.th.transport")}<br /><span>{t("bill.sign.plus")}</span>
                  </th>

                  <th className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'} scope="col">
                    {t("bill.th.commission")}<br /><span>{t("bill.sign.plus")}</span>
                  </th>

                  <th className='thsmall' scope="col">
                    {t("bill.th.payable")}<br /><span>{t("bill.sign.equal")}</span>
                  </th>

                  {DataSource && DataSource.length === 0 ? '' :
                    DataSource[0].flag === "oldbill" ?
                      input.knofrom === input.knoto ?
                        DataSource && DataSource.length === 1 ?
                          <th className='thsmall' scope="col">{t("bill.th.action")}</th>
                          : ''
                        : ''
                      : ''
                  }
                </tr>
              </thead>

              <tbody>
                {

                  value.length > 0 ? tableFilter.map((user, index) => {

                    let extrakaapt = 0;
                    if (localStorage.getItem("itr1name") != "-") {
                      localStorage.getItem("itr1type") === "liter" ?
                        extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value")))
                        : localStorage.getItem("itr1type") === "per" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
                          :
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value")))
                    }

                    if (localStorage.getItem("itr2name") != "-") {
                      localStorage.getItem("itr2type") === "liter" ?
                        extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value")))
                        : localStorage.getItem("itr2type") === "per" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
                          :
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value")))
                    }

                    if (localStorage.getItem("itr3name") != "-") {
                      localStorage.getItem("itr3type") === "liter" ?
                        extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value")))
                        : localStorage.getItem("itr3type") === "per" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
                          :
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value")))
                    }

                    if (localStorage.getItem("itr4name") != "-") {
                      localStorage.getItem("itr4type") === "liter" ?
                        extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value")))
                        : localStorage.getItem("itr4type") === "per" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr4value"))) / 100)
                          : localStorage.getItem("itr4type") === "bill" ?
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr4value"))
                            :
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value")))
                    }

                    if (localStorage.getItem("itr5name") != "-") {
                      localStorage.getItem("itr5type") === "liter" ?
                        extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value")))
                        : localStorage.getItem("itr5type") === "per" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr5value"))) / 100)
                          : localStorage.getItem("itr5type") === "bill" ?
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr5value"))
                            :
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value")))
                    }

                    if (localStorage.getItem("itr6name") != "-") {
                      localStorage.getItem("itr6type") === "liter" ?
                        extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value")))
                        : localStorage.getItem("itr6type") === "per" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr6value"))) / 100)
                          : localStorage.getItem("itr6type") === "bill" ?
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr6value"))
                            :
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value")))
                    }

                    let allthevtofixed = 0;

                    localStorage.getItem("thevper") === "No" ?
                      allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)
                      : localStorage.getItem("thevper") === "Yes" ?
                        allthevtofixed = parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2)
                        : localStorage.getItem("thevper") === "Bill" ?
                          allthevtofixed = parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0))
                          :
                          allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)


                    let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);
                    localStorage.getItem("thevper") === "No" ?
                      allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)
                      : localStorage.getItem("thevper") === "Yes" ?
                        allthevtofixed = parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2)
                        : localStorage.getItem("thevper") === "Bill" ?
                          allthevtofixed = parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0))
                          :
                          allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)

                    let allthev = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev));
                    let billminusthev = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed)).toFixed(2);
                    let totalkhadya = parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0)

                    let khedit = user.flag === "oldbill" ?
                      (user.khadyakapat && user.khadyakapat !== '0' ? user.khadyakapat : 0) :

                      parseFloat(
                        // billminusthev
                        totalkhadya <= billminusthev ?
                          user.khadyahpta && user.khadyahpta !== null && user.khadyahpta !== '0' ? parseFloat(user.khadyahpta).toFixed(2)
                            :
                            user.advhpta && user.advhpta !== null && user.advhpta !== '0' ?
                              parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0 > 0 ?
                                parseFloat(billminusthev < totalkhadya ?
                                  billminusthev :
                                  totalkhadya)
                                - parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)
                                : 0
                              :

                              billminusthev < totalkhadya ?
                                billminusthev :
                                totalkhadya

                          :
                          // parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)
                          parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                          ) -
                            parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                          ) > 0 && parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                          ) -
                            parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                          ) < totalkhadya ?

                            parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                            ) -
                            parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                            + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)

                            :
                            parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixed))
                            ) -
                              billminusthev > 0 ?
                              parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)))
                              : 0

                            )
                            + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                      ).toFixed(2);

                    //-------------------------------

                    let tadvance = parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2);
                    let advancehfta = user.advhpta && user.advhpta !== null && user.advhpta !== '0' && parseFloat(user.advhpta);

                    let advedit = user.flag === "oldbill" ?
                      (user.advkapat ? user.advkapat : 0) :
                      parseFloat(tadvance > 0 ?
                        parseFloat(advancehfta != 0 && advancehfta <= (billminusthev - khedit) ?
                          advancehfta <= tadvance ?
                            user.advhpta <= parseFloat(billminusthev - totalkhadya) ?
                              parseFloat(user.advhpta)
                              :
                              parseFloat(billminusthev - totalkhadya) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                            :
                            tadvance
                          :
                          billminusthev
                            >
                            parseFloat(
                              billminusthev < totalkhadya ?
                                billminusthev :
                                totalkhadya)
                            ?
                            parseFloat(
                              billminusthev
                              -
                              parseFloat(
                                billminusthev < totalkhadya ?
                                  billminusthev :
                                  totalkhadya))
                              <=
                              parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)

                              ?
                              parseFloat(parseFloat(
                                billminusthev -
                                parseFloat(
                                  billminusthev < totalkhadya ?
                                    billminusthev :
                                    totalkhadya)
                              )
                                -
                                parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                                +
                                parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0)
                                +
                                parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                              ).toFixed(2)
                              :

                              parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)
                            :
                            0)
                        :
                        0);

                    // updatedDataSource = [...DataSource];

                    const cuchalValue = parseFloat(user.cuchal);
                    const newadvValue = parseFloat(user.newadv);
                    const obalValue = parseFloat(user.obal);
                    const bcountValue = parseFloat(user.bcount);
                    const advhptaValue = parseFloat(user.advhpta);
                    const billValue = parseFloat(user.bill).toFixed(2);
                    const mhliterValue = parseFloat(user.mhliter);
                    const mhthevValue = parseFloat(user.mhthev);
                    const gayliterValue = parseFloat(user.gayliter);
                    const gaythevValue = parseFloat(user.gaythev);
                    const ckhadyaValue = parseFloat(user.ckhadya);
                    const newkhadyaValue = parseFloat(user.newkhadya);
                    const ikapatliter2Value = parseFloat(user.ikapatliter2);
                    const tliterValue = parseFloat(user.tliter);
                    const ikapatbill2Value = parseFloat(user.ikapatbill2);
                    const vah2Value = parseFloat(user.vah2);
                    const gayvahValue = parseFloat(user.gayvah);

                    const calculatedValue = parseFloat(
                      cuchalValue + (bcountValue > 0 ? newadvValue : obalValue)
                    ).toFixed(2);

                    const mhthevCalculation = (mhliterValue * mhthevValue).toFixed(2);
                    const gaythevCalculation = (gayliterValue * gaythevValue).toFixed(2);
                    const totalBillMinusThev = (billValue - parseFloat(mhthevCalculation) - parseFloat(gaythevCalculation)).toFixed(2);

                    const advhptaCheck = advhptaValue <= totalBillMinusThev ? advhptaValue : totalBillMinusThev;

                    const ckhadyaPlusNewKhadya = (ckhadyaValue + newkhadyaValue).toFixed(2);
                    const khadyaCheck = parseFloat(totalBillMinusThev) < parseFloat(ckhadyaPlusNewKhadya) ? totalBillMinusThev : ckhadyaPlusNewKhadya;

                    const finalCalculation = (
                      parseFloat(
                        totalBillMinusThev -
                        parseFloat(ikapatliter2Value * tliterValue || 0) -
                        parseFloat(ikapatbill2Value || 0) +
                        parseFloat(vah2Value * mhliterValue || 0) +
                        parseFloat(gayvahValue * gayliterValue || 0)
                      ).toFixed(2)
                    );

                    const resultValue = user.result && !isNaN(user.result)
                      ? parseFloat(user.result).toFixed(2)
                      : finalCalculation <= calculatedValue ? finalCalculation : calculatedValue;



                    if (updatedDataSource[index]) {
                      addOrUpdateCkhadya(user.kno, khedit);
                      addOrUpdateCuchal(user.kno, advedit);
                      // console.log("in 1");
                      updatedDataSource[index].action = khedit;

                      if (!khedit) {
                        khedit = 0;
                      }
                      updatedDataSource[index].khedit = khedit;
                      updatedDataSource[index].advedit = advedit;
                      if (first === "false") {
                        // console.log("in first time");
                        updatedDataSource[index].khedit = khedit;
                        updatedDataSource[index].advedit = advedit;
                        setfirst("true")
                      }
                    }

                    return (

                      <tr key={index}>
                        <td className='thsmall'>{user.kno}</td>
                        <td className='thsmall'>{user.name}</td>
                        <td className='thsmall2'>{parseFloat(user.bill).toFixed(2)}</td>
                        <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.tliter ? parseFloat(user.tliter).toFixed(2) : 0}</td>
                        <td className={'thsmallhide'}>
                          {
                            user.flag === "oldbill" ?
                              (user.magilthev ? parseFloat(user.magilthev).toFixed(2) : 0) :
                              parseFloat(user.bcount) > 0 ? parseFloat(user.newthev).toFixed(2) : parseFloat(user.othev).toFixed(2)
                          }</td>
                        <td className='thsmall2'>{
                          user.flag === "oldbill" ?
                            (user.cthev ? parseFloat(user.cthev).toFixed(2) : 0) :
                            localStorage.getItem("thevper") === "No" ?
                              allthevtofixed
                              : localStorage.getItem("thevper") === "Bill" ?
                                allthevtofixed = parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0))
                                :
                                parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2)
                        }</td>
                        <td className={'thsmallhide '}>
                          {
                            user.flag === "oldbill" ?
                              parseFloat(user.newthev) ? parseFloat(user.newthev).toFixed(2) : 0
                              :
                              localStorage.getItem("thevper") === "No" ?
                                parseFloat(parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newthev) : parseFloat(user.othev))).toFixed(2)
                                : localStorage.getItem("thevper") === "Bill" ?
                                  allthevtofixed = parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0))
                                  :
                                  (parseFloat(parseFloat(user.bill * 10) / 100) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newthev) : parseFloat(user.othev))).toFixed(2)
                          }</td>
                        {

                          localStorage.getItem("itr1name") != "-" ?
                            <>
                              <td className={'thsmallhide'}>
                                {
                                  user.flag === "oldbill" ?
                                    (user.magilthevitr1 ? parseFloat(user.magilthevitr1).toFixed(2) : 0) :
                                    (user.newthevitr1 ? parseFloat(user.newthevitr1).toFixed(2) : 0)
                                }</td>
                              <td className='thsmall2'>{
                                user.flag === "oldbill" ?
                                  (user.cthevitr1 ? parseFloat(user.cthevitr1).toFixed(2) : 0) :
                                  localStorage.getItem("itr1type") === "liter" ?
                                    parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value"))).toFixed(2)
                                    : localStorage.getItem("itr1type") === "per" ?
                                      parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr1value"))) / 100).toFixed(2)
                                      :
                                      parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value"))).toFixed(2)
                              }</td>
                              <td className={'thsmallhide'}>
                                {
                                  user.flag === "oldbill" ?
                                    parseFloat(user.newthevitr1) ? parseFloat(user.newthevitr1).toFixed(2) : 0
                                    :
                                    localStorage.getItem("itr1type") === "liter" ?
                                      parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value"))) + parseFloat(user.newthevitr1)).toFixed(2)
                                      : localStorage.getItem("itr1type") === "per" ?
                                        parseFloat(parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr1value"))) / 100) + parseFloat(user.newthevitr1)).toFixed(2)
                                        :
                                        parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value"))) + parseFloat(user.newthevitr1)).toFixed(2)
                                }</td>
                            </>
                            :
                            <>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                            </>

                        }

                        {
                          localStorage.getItem("itr2name") != "-" ?
                            <>
                              <td className={'thsmallhide'}>
                                {
                                  user.flag === "oldbill" ?
                                    (user.magilthevitr2 ? parseFloat(user.magilthevitr2).toFixed(2) : 0) :
                                    (user.newthevitr2 ? parseFloat(user.newthevitr2).toFixed(2) : 0)
                                }</td>
                              <td className='thsmall2'>{
                                user.flag === "oldbill" ?
                                  (user.cthevitr2 ? parseFloat(user.cthevitr2).toFixed(2) : 0) :
                                  localStorage.getItem("itr2type") === "liter" ?
                                    parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value"))).toFixed(2)
                                    : localStorage.getItem("itr2type") === "per" ?
                                      parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr2value"))) / 100).toFixed(2)
                                      :
                                      parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value"))).toFixed(2)
                              }</td>
                              <td className={'thsmallhide'}>
                                {
                                  user.flag === "oldbill" ?
                                    parseFloat(user.newthevitr2) ? parseFloat(user.newthevitr2).toFixed(2) : 0
                                    :
                                    localStorage.getItem("itr2type") === "liter" ?
                                      parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value"))) + parseFloat(user.newthevitr2)).toFixed(2)
                                      : localStorage.getItem("itr2type") === "per" ?
                                        parseFloat(parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr2value"))) / 100) + parseFloat(user.newthevitr2)).toFixed(2)
                                        :
                                        parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value"))) + parseFloat(user.newthevitr2)).toFixed(2)
                                }</td>
                            </>
                            :
                            <>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                            </>
                        }

                        {
                          localStorage.getItem("itr3name") != "-" ?
                            <>
                              <td className={'thsmallhide'}>
                                {
                                  user.flag === "oldbill" ?
                                    (user.magilthevitr3 ? parseFloat(user.magilthevitr3).toFixed(2) : 0) :
                                    (user.newthevitr3 ? parseFloat(user.newthevitr3).toFixed(2) : 0)
                                }</td>
                              <td className='thsmall2'>{
                                user.flag === "oldbill" ?
                                  (user.cthevitr3 ? parseFloat(user.cthevitr3).toFixed(2) : 0) :
                                  localStorage.getItem("itr3type") === "liter" ?
                                    parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value"))).toFixed(2)
                                    : localStorage.getItem("itr3type") === "per" ?
                                      parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr3value"))) / 100).toFixed(2)
                                      :
                                      parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value"))).toFixed(2)
                              }</td>
                              <td className={'thsmallhide'}>
                                {
                                  user.flag === "oldbill" ?
                                    parseFloat(user.newthevitr3) ? parseFloat(user.newthevitr3).toFixed(2) : 0
                                    :
                                    localStorage.getItem("itr3type") === "liter" ?
                                      parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value"))) + parseFloat(user.newthevitr3)).toFixed(2)
                                      : localStorage.getItem("itr3type") === "per" ?
                                        parseFloat(parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr3value"))) / 100) + parseFloat(user.newthevitr3)).toFixed(2)
                                        :
                                        parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value"))) + parseFloat(user.newthevitr3)).toFixed(2)
                                }</td>
                            </>
                            :
                            <>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                            </>
                        }

                        <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>
                          {
                            user.flag === "oldbill" ?
                              (user.newadv ? user.newadv : 0) :
                              parseFloat(user.bcount) > 0 ? parseFloat(user.newadv).toFixed(2) : parseFloat(user.obal).toFixed(2)
                          }</td>
                        <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.cuchal ? user.cuchal : 0}</td>
                        <td className='thsmall2'>
                          {
                            user.flag === "oldbill" ?
                              (user.tadv ? parseFloat(user.tadv).toFixed(2) : 0) :
                              parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)
                          }</td>
                        <td className='thsmall2edit'
                          contentEditable={
                            user.flag === "oldbill" ?
                              user.lastbill === "Yes" ?
                                'true'
                                : 'false'
                              : 'true'
                          }
                          onKeyDown={(e) => handleCellKeyPress(e, index)}
                          onBlur={(e) => handleCellBlur(e, index)}
                          onFocus={(e) => handleCellfocus(e, index)}
                          ref={(td) => {
                            if (!cellRefs.current[index]) {
                              cellRefs.current[index] = [];
                            }
                            cellRefs.current[index][0] = td; // Save the ref for the cell
                          }}
                          onInput={(e) => handleCellChange(e, index, user.kno)}>
                          {
                            parseFloat(advedit).toFixed(2)
                          }
                        </td>

                        <td className={showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen'} >
                          {user.flag === "oldbill" ? (
                            user.result != null && !isNaN(user.result) ? parseFloat(user.result).toFixed(2) : user.newadvcurrent != null && !isNaN(user.newadvcurrent) ? parseFloat(user.newadvcurrent).toFixed(2) : 0
                          )
                            :
                            tadvance > 0
                              ?
                              (
                                user.result != null && !isNaN(user.result)
                                  ?
                                  parseFloat(user.result).toFixed(2)
                                  :
                                  parseFloat(parseFloat(tadvance) - parseFloat(advedit)).toFixed(2)
                              )
                              :
                              tadvance}
                        </td>

                        <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{
                          user.flag === "oldbill" ?
                            (user.mkhadya ? parseFloat(user.mkhadya).toFixed(2) : 0) :
                            user.newkhadya ? parseFloat(user.newkhadya).toFixed(2) : 0

                        }</td>
                        <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.ckhadya ? parseFloat(user.ckhadya).toFixed(2) : 0}</td>
                        <td className='thsmall2'>
                          {
                            user.flag === "oldbill" ?
                              parseFloat(user.ckhadya) + parseFloat(user.mkhadya) ? parseFloat(parseFloat(user.ckhadya) + parseFloat(user.mkhadya)).toFixed(2) : 0
                              :
                              parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0

                          }
                        </td>

                        <td
                          key={25}
                          className='thsmall2edit'
                          contentEditable={
                            user.flag === "oldbill"
                              ? user.lastbill === "Yes"
                                ? 'true'
                                : 'false'
                              : 'true'
                          }
                          onKeyDown={(e) => handleCellKeyPress12(e, index, 25)}  // ✅ Pass colIndex here
                          onBlur={(e) => handleCellBlurkh(e, index)}
                          ref={(td) => {
                            if (!cellRefs.current[index]) {
                              cellRefs.current[index] = {}; // Store by column index
                            }
                            cellRefs.current[index][25] = td; // ✅ Store reference properly
                          }}
                          onInput={(e) => handleCellChangekh(e, index, user.kno)}
                        >
                          {parseFloat(khedit).toFixed(2)}
                        </td>


                        <td className={showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen'}>
                          {
                            user.flag === "oldbill" ?
                              (user.result2 != null && !isNaN(user.result2) ? parseFloat(user.result2).toFixed(2) : user.newkhadyacurrent != null && !isNaN(user.newkhadyacurrent) ? parseFloat(user.newkhadyacurrent).toFixed(2) : 0) :
                              user.result2 != null && !isNaN(user.result2) ? parseFloat(user.result2).toFixed(2) : (parseFloat(user.ckhadya) + parseFloat(user.newkhadya) -
                                (parseFloat(
                                  // billminusthev
                                  totalkhadya <= billminusthev ?
                                    user.khadyahpta && user.khadyahpta !== null && user.khadyahpta !== '0' ? parseFloat(user.khadyahpta).toFixed(2)
                                      :
                                      user.advhpta && user.advhpta !== null && user.advhpta !== '0' ?
                                        parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0 > 0 ?
                                          parseFloat(billminusthev < totalkhadya ?
                                            billminusthev :
                                            totalkhadya)
                                          - parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)
                                          : 0
                                        :
                                        billminusthev < totalkhadya ?
                                          billminusthev :
                                          totalkhadya

                                    :
                                    //parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)
                                    parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                                    ) -
                                      parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                                    ) > 0 && parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                                    ) -
                                      parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                                    ) < totalkhadya ?

                                      parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                                      ) -
                                      parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                                      + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                                      :
                                      parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                                      ) -
                                        billminusthev > 0 ?
                                        parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)))
                                        : 0
                                        + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0)
                                        + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                                      )

                                ).toFixed(2)
                                )).toFixed(2)
                          }
                        </td>
                        <td className={'thsmallhide'}>
                          {
                            user.flag === "oldbill" ?
                              (user.ikapatliter ? parseFloat(user.ikapatliter) : 0) :
                              (user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter).toFixed(2) : 0)
                          }
                        </td>

                        <td
                          key={27}
                          className='thsmall2edit'
                          contentEditable={
                            user.flag === "oldbill"
                              ? user.lastbill === "Yes"
                                ? 'true'
                                : 'false'
                              : 'true'
                          }
                          onKeyDown={(e) => handleCellKeyPress12(e, index, 27)}  // ✅ Pass colIndex here
                          onBlur={(e) => handleCellBlurikapat(e, index)}
                          ref={(td) => {
                            if (!cellRefs.current[index]) {
                              cellRefs.current[index] = {}; // Store by column index
                            }
                            cellRefs.current[index][27] = td; // ✅ Store reference properly
                          }}
                          onInput={(e) => handleCellChangeikapat(e, index, user.kno)}
                        >
                          {
                            user.flag === "oldbill" ?
                              (user.ikapatbill ? parseFloat(user.ikapatbill) : 0) :
                              (user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)
                          }
                        </td>

                        {
                          localStorage.getItem("retan") == "On" ?
                            <>
                              <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{
                                user.flag === "oldbill" ?
                                  (user.mkhadya ? parseFloat(user.magilretanmedi).toFixed(2) : 0) :
                                  user.newkhadya ? parseFloat(user.newretanmedi).toFixed(2) : 0
                              }</td>

                              <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.cretanmedi ? user.cretanmedi : 0}</td>

                              <td className='thsmall2'>
                                {
                                  user.flag === "oldbill" ?
                                    (user.tretanmedi ? parseFloat(user.tretanmedi).toFixed(2) : 0) :
                                    parseFloat(parseFloat(user.cretanmedi) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newretanmedi) : parseFloat(user.oretanmedi))).toFixed(2)
                                }</td>

                              <td
                                key={28}
                                className='thsmall2edit'
                                contentEditable={
                                  user.flag === "oldbill"
                                    ? user.lastbill === "Yes"
                                      ? 'true'
                                      : 'false'
                                    : 'true'
                                }
                                onKeyDown={(e) => handleCellKeyPress12(e, index, 28)}  // ✅ Pass colIndex here
                                onBlur={(e) => handleCellBlurikapat(e, index)}
                                ref={(td) => {
                                  if (!cellRefs.current[index]) {
                                    cellRefs.current[index] = {}; // Store by column index
                                  }
                                  cellRefs.current[index][28] = td; // ✅ Store reference properly
                                }}
                                onInput={(e) => handleCellChangeretan(e, index, user.kno)}
                              >
                                {
                                  user.flag === "oldbill" ?
                                    (user.retan ? parseFloat(user.retan) : 0) :
                                    (user.retan ? parseFloat(user.retan) : 0)
                                }
                              </td>

                              <td
                                key={29}
                                className='thsmall2edit'
                                contentEditable={
                                  user.flag === "oldbill"
                                    ? user.lastbill === "Yes"
                                      ? 'true'
                                      : 'false'
                                    : 'true'
                                }
                                onKeyDown={(e) => handleCellKeyPress12(e, index, 29)}  // ✅ Pass colIndex here
                                onBlur={(e) => handleCellBlurikapat(e, index)}
                                ref={(td) => {
                                  if (!cellRefs.current[index]) {
                                    cellRefs.current[index] = {}; // Store by column index
                                  }
                                  cellRefs.current[index][29] = td; // ✅ Store reference properly
                                }}
                                onInput={(e) => handleCellChangemedi(e, index, user.kno)}
                              >
                                {
                                  user.flag === "oldbill" ?
                                    (user.medi ? parseFloat(user.medi) : 0) :
                                    (user.medi ? parseFloat(user.medi) : 0)
                                }
                              </td>


                              <td className={showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen'}>
                                {
                                  user.flag === "oldbill" ?
                                    (user.resultretanmedi != null && !isNaN(user.resultretanmedi) ? parseFloat(user.resultretanmedi).toFixed(2) : user.newretanmedi != null && !isNaN(user.newretanmedi) ? parseFloat(user.newretanmedi).toFixed(2) : 0) :
                                    user.resultretanmedi != null && !isNaN(user.resultretanmedi) ? parseFloat(user.resultretanmedi).toFixed(2)
                                      :
                                      user.flag === "oldbill" ?
                                        (user.resultretanmedi ? parseFloat(user.resultretanmedi).toFixed(2) : 0) :
                                        parseFloat(parseFloat(user.cretanmedi) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newretanmedi) : parseFloat(user.oretanmedi))).toFixed(2)
                                }
                              </td>
                            </>
                            :
                            <>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                              <td className={'thsmallhide'}>{0}</td>
                            </>
                        }

                        {
                          localStorage.getItem("itr4name") != "-" ?
                            <>
                              <td className='thsmall2'>{
                                user.flag === "oldbill" ?
                                  (user.itrkapat1 ? parseFloat(user.itrkapat1).toFixed(2) : 0) :
                                  localStorage.getItem("itr4type") === "liter" ?
                                    parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value"))).toFixed(2)
                                    : localStorage.getItem("itr4type") === "per" ?
                                      parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr4value"))) / 100).toFixed(2)
                                      : localStorage.getItem("itr4type") === "bill" ?
                                        extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr4value"))
                                        :
                                        parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value"))).toFixed(2)
                              }</td>
                            </>
                            :
                            <td className={'thsmallhide'}>{0}</td>
                        }

                        {
                          localStorage.getItem("itr5name") != "-" ?
                            <>
                              <td className='thsmall2'>{
                                user.flag === "oldbill" ?
                                  (user.itrkapat2 ? parseFloat(user.itrkapat2).toFixed(2) : 0) :
                                  localStorage.getItem("itr5type") === "liter" ?
                                    parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value"))).toFixed(2)
                                    : localStorage.getItem("itr5type") === "per" ?
                                      parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr5value"))) / 100).toFixed(2)
                                      : localStorage.getItem("itr5type") === "bill" ?
                                        extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr5value"))
                                        :
                                        parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value"))).toFixed(2)
                              }</td>

                            </>
                            :
                            <td className={'thsmallhide'}>{0}</td>
                        }


                        {
                          localStorage.getItem("itr6name") != "-" ?
                            <>
                              <td className='thsmall2'>{
                                user.flag === "oldbill" ?
                                  (user.itrkapat3 ? parseFloat(user.itrkapat3).toFixed(2) : 0) :
                                  localStorage.getItem("itr6type") === "liter" ?
                                    parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value"))).toFixed(2)
                                    : localStorage.getItem("itr6type") === "per" ?
                                      parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr6value"))) / 100).toFixed(2)
                                      : localStorage.getItem("itr6type") === "bill" ?
                                        extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr6value"))
                                        :
                                        parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value"))).toFixed(2)
                              }</td>

                            </>
                            :
                            <td className={'thsmallhide'}>{0}</td>
                        }

                        <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>
                          {
                            user.flag === "oldbill" ?
                              (user.vah ? parseFloat(user.vah) : 0) :
                              parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter).toFixed(2) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter).toFixed(2) : 0)
                          }
                        </td>
                        <td className='thsmall2'>
                          {
                            user.flag === "oldbill" ?
                              (user.adacalculated != null && !isNaN(user.adacalculated)) ? parseFloat(user.adacalculated).toFixed(2) : (user.ada ? parseFloat(user.ada).toFixed(2) : 0) :
                              (user.adacalculated != null && !isNaN(user.adacalculated)) ? parseFloat(user.adacalculated).toFixed(2) : user.bill
                                ?
                                parseFloat(parseFloat(user.bill)
                                  -
                                  allthevtofixedall +
                                  + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0)
                                  + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                                  - khedit
                                  - advedit
                                  - parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)))
                                ).toFixed(2) : 0
                          }
                        </td>
                        {DataSource && DataSource.length === 0 ?
                          '' :
                          DataSource[0].flag === "oldbill" ?
                            input.knofrom === input.knoto ?
                              DataSource && DataSource.length === 1 ?
                                <td><UilRefresh onClick={() => { handleDeletesingle() }} className="ic2" /></td>
                                : ''
                              : ''
                            : ''
                        }

                      </tr>
                    );
                  }
                  )
                    :
                    DataSource && DataSource.map((user, index) => {

                      let extrakaapt = 0;
                      if (localStorage.getItem("itr1name") != "-") {
                        localStorage.getItem("itr1type") === "liter" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value")))
                          : localStorage.getItem("itr1type") === "per" ?
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr1value"))) / 100)
                            :
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value")))
                      }

                      if (localStorage.getItem("itr2name") != "-") {
                        localStorage.getItem("itr2type") === "liter" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value")))
                          : localStorage.getItem("itr2type") === "per" ?
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr2value"))) / 100)
                            :
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value")))
                      }

                      if (localStorage.getItem("itr3name") != "-") {
                        localStorage.getItem("itr3type") === "liter" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value")))
                          : localStorage.getItem("itr3type") === "per" ?
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr3value"))) / 100)
                            :
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value")))
                      }

                      if (localStorage.getItem("itr4name") != "-") {
                        localStorage.getItem("itr4type") === "liter" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value")))
                          : localStorage.getItem("itr4type") === "per" ?
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr4value"))) / 100)
                            : localStorage.getItem("itr4type") === "bill" ?
                              extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr4value"))
                              :
                              extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value")))
                      }

                      if (localStorage.getItem("itr5name") != "-") {
                        localStorage.getItem("itr5type") === "liter" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value")))
                          : localStorage.getItem("itr5type") === "per" ?
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr5value"))) / 100)
                            : localStorage.getItem("itr5type") === "bill" ?
                              extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr5value"))
                              :
                              extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value")))
                      }

                      if (localStorage.getItem("itr6name") != "-") {
                        localStorage.getItem("itr6type") === "liter" ?
                          extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value")))
                          : localStorage.getItem("itr6type") === "per" ?
                            extrakaapt = parseFloat(extrakaapt) + parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr6value"))) / 100)
                            : localStorage.getItem("itr6type") === "bill" ?
                              extrakaapt = parseFloat(extrakaapt) + parseFloat(localStorage.getItem("itr6value"))
                              :
                              extrakaapt = parseFloat(extrakaapt) + parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value")))
                      }

                      let allthevtofixed = 0;

                      localStorage.getItem("thevper") === "No" ?
                        allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)
                        : localStorage.getItem("thevper") === "Yes" ?
                          allthevtofixed = parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2)
                          : localStorage.getItem("thevper") === "Bill" ?
                            parseFloat(user.bill) > parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0)) ?
                              allthevtofixed = parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0))
                              :
                              allthevtofixed = parseFloat(user.bill)
                            // allthevtofixed = parseFloat(parseFloat(user.mhthev ? parseFloat(user.mhthev) : 0) + parseFloat(user.gaythev ? parseFloat(user.gaythev) : 0))
                            :
                            allthevtofixed = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)).toFixed(2)

                      let allthevtofixedall = parseFloat(allthevtofixed) + parseFloat(extrakaapt);

                      let tvahtuk = parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) +
                        parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0) +
                        parseFloat(user.mhcomm && user.mhliter ? parseFloat(user.mhcomm * user.mhliter) : 0) +
                        parseFloat(user.gaycomm && user.gayliter ? parseFloat(user.gaycomm * user.gayliter) : 0)

                      let allthev = parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev));
                      let billminusthev = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall)).toFixed(2);
                      let billminusthevplusvahtuk = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall) + parseFloat(tvahtuk)).toFixed(2);
                      let billminusthevplusvahtukminusikapat = parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall) + parseFloat(tvahtuk) - parseFloat(user.ikapatbill2)).toFixed(2);
                      let billminusthevplusvahtukminusikapatminusbhishi = parseFloat(parseFloat(billminusthevplusvahtukminusikapat).toFixed(2) - parseFloat(localStorage.getItem("itrvalue"))).toFixed(2);
                      let totalkhadya = parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0)
                      let totalratib = parseFloat(parseFloat(user.cratib) + parseFloat(user.newratib) ? (parseFloat(user.cratib) + parseFloat(user.newratib)).toFixed(2) : 0)
                      let totalkarj = parseFloat(parseFloat(user.ckarj) + parseFloat(user.newkarj) ? (parseFloat(user.ckarj) + parseFloat(user.newkarj)).toFixed(2) : 0)

                      let totalsangh = parseFloat(parseFloat(user.csangh) + parseFloat(user.newsangh) ? (parseFloat(user.csangh) + parseFloat(user.newsangh)).toFixed(2) : 0)

                      let bhishiedit = user.flag === "oldbill" ?
                        (user.cbhishi && user.cbhishi !== '0' ? user.cbhishi : 0) :
                        parseFloat(billminusthevplusvahtuk) > 0 ?
                          parseFloat(localStorage.getItem("itrvalue"))
                          : 0

                      let sanghedit = user.flag === "oldbill" ?
                        (user.sanghkapat && user.sanghkapat !== '0' ? user.sanghkapat : 0) :
                        parseFloat(
                          totalsangh <= billminusthevplusvahtukminusikapatminusbhishi ?
                            totalsangh > 0 ?
                              parseFloat(totalsangh)
                              :
                              0
                            :
                            parseFloat(user.bill) > 0 ?
                              parseFloat(billminusthevplusvahtukminusikapatminusbhishi)
                              : 0
                        ).toFixed(2);

                      let currentintr = parseFloat(parseFloat(parseFloat(parseFloat(parseFloat(totalkarj) * parseFloat(user.karjintr)) / 100) / 365) * 10).toFixed(2);
                      let karjintrtemp = user.flag === "oldbill" ?
                        (user.ratibkapat && user.ratibkapat !== '0' ? user.ratibkapat : 0) :
                        parseFloat(
                          parseFloat(parseFloat(parseFloat(parseFloat(parseFloat(totalkarj) * parseFloat(user.karjintr)) / 100) / 365) * 10).toFixed(2)
                        ).toFixed(2);

                      let kapattillsangh = parseFloat(parseFloat(parseFloat(user.bill) + parseFloat(tvahtuk)) - parseFloat(parseFloat(allthevtofixedall) + parseFloat(user.ikapatbill2) + parseFloat(sanghedit) + parseFloat(bhishiedit))).toFixed(2);
                      parseFloat(karjintrtemp) <= parseFloat(kapattillsangh) ?
                        karjintrtemp = karjintrtemp
                        :
                        karjintrtemp = parseFloat(kapattillsangh)


                      let kapattillkarjintr = parseFloat(parseFloat(parseFloat(user.bill) + parseFloat(tvahtuk)) - parseFloat(parseFloat(allthevtofixedall) + parseFloat(user.ikapatbill2) + parseFloat(sanghedit) + parseFloat(bhishiedit) + parseFloat(karjintrtemp))).toFixed(2);

                      let karjedit = user.flag === "oldbill" ?
                        (user.karjhpta && user.karjhpta !== '0' ? user.karjhpta : 0) :
                        parseFloat(
                          totalkarj <= kapattillkarjintr ?
                            parseFloat(totalkarj)
                            :
                            parseFloat(user.karjhpta) <= kapattillkarjintr
                              ?
                              parseFloat(user.karjhpta)
                              :
                              parseFloat(kapattillkarjintr)
                        ).toFixed(2);

                      let karjintr = user.flag === "oldbill" ?
                        (user.karjintr && user.karjintr !== '0' ? user.karjintr : 0) :
                        parseFloat(
                          karjedit > 0 ?
                            currentintr
                            :
                            totalkarj <= kapattillsangh
                              ?
                              totalkarj
                              :
                              kapattillsangh
                        ).toFixed(2);

                      parseFloat(karjintr) <= parseFloat(kapattillsangh) ?
                        karjintr = karjintr
                        :
                        karjintr = parseFloat(kapattillsangh)

                      let tillkarj = (parseFloat(billminusthevplusvahtuk) - (parseFloat(user.ikapatbill2) + parseFloat(karjedit) + parseFloat(karjintr) + parseFloat(sanghedit) + parseFloat(bhishiedit)));

                      let ratibedit = user.flag === "oldbill" ?
                        (user.ratibkapat && user.ratibkapat !== '0' ? user.ratibkapat : 0) :
                        parseFloat(
                          totalratib <= tillkarj ?
                            billminusthev > 0 ?
                              totalratib
                              : 0
                            :
                            tillkarj
                        ).toFixed(2);

                      let khedit = user.flag === "oldbill" ?
                        (user.khadyakapat && user.khadyakapat !== '0' ? user.khadyakapat : 0) :
                        parseFloat(parseFloat(
                          // billminusthev
                          totalkhadya <= billminusthev ?
                            user.khadyahpta && user.khadyahpta !== null && user.khadyahpta !== '0' ? parseFloat(user.khadyahpta).toFixed(2)
                              :
                              user.advhpta && user.advhpta !== null && user.advhpta !== '0' ?
                                parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? (parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0 > 0 ?
                                  parseFloat(billminusthev < totalkhadya ?
                                    billminusthev :
                                    totalkhadya)
                                  - parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)
                                  : 0
                                :

                                billminusthev < totalkhadya ?
                                  billminusthev :
                                  totalkhadya

                            :
                            // parseFloat(user.advhpta && user.advhpta !== null && user.advhpta !== '0' ? user.advhpta : 0)
                            parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                            ) -
                              parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                            ) > 0 && parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                            ) -
                              parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)).toFixed(2)
                            ) < totalkhadya ?

                              parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                              ) -
                              parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                              + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)

                              :
                              parseFloat(parseFloat(parseFloat(parseFloat(user.bill).toFixed(2) - parseFloat(allthevtofixedall))
                              ) -
                                billminusthev > 0 ?
                                parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)))
                                : 0

                              )
                              + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                        )).toFixed(2)

                      let tillratib = parseFloat(tillkarj) - parseFloat(ratibedit);

                      khedit = user.flag === "oldbill" ?
                        (user.khadyakapat && user.khadyakapat !== '0' ? user.khadyakapat : 0) :
                        parseFloat(
                          totalkhadya <= tillratib ?
                            totalkhadya > 0 ?
                              totalkhadya
                              :
                              0
                            :
                            tillratib
                        ).toFixed(2);

                      //-------------------------------

                      let tadvance = parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2);
                      let advancehfta = user.advhpta && user.advhpta !== null && user.advhpta !== '0' && parseFloat(user.advhpta);

                      let advedit = user.flag === "oldbill" ?
                        (user.advkapat ? user.advkapat : 0) :
                        parseFloat(tadvance > 0 ?
                          parseFloat(advancehfta != 0 && advancehfta <= (billminusthev - khedit) ?
                            advancehfta <= tadvance ?
                              user.advhpta <= parseFloat(billminusthev - totalkhadya) ?
                                parseFloat(user.advhpta)
                                :
                                parseFloat(billminusthev - totalkhadya) + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0) + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                              :
                              tadvance
                            :
                            billminusthev
                              >
                              parseFloat(
                                billminusthev < totalkhadya ?
                                  billminusthev :
                                  totalkhadya)
                              ?
                              parseFloat(
                                billminusthev
                                -
                                parseFloat(
                                  billminusthev < totalkhadya ?
                                    billminusthev :
                                    totalkhadya))
                                <=
                                parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)

                                ?
                                parseFloat(parseFloat(
                                  billminusthev -
                                  parseFloat(
                                    billminusthev < totalkhadya ?
                                      billminusthev :
                                      totalkhadya)
                                )
                                  -
                                  parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0))).toFixed(2)
                                  +
                                  parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0)
                                  +
                                  parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                                ).toFixed(2)
                                :

                                parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)
                              :
                              0)
                          :
                          0);

                      let tillkhadya = parseFloat(tillratib) - parseFloat(khedit);

                      advedit = user.flag === "oldbill" ?
                        (user.advkapat && user.advkapat !== '0' ? user.advkapat : 0) :
                        parseFloat(
                          tadvance <= tillkhadya ?
                            parseFloat(advancehfta) > 0
                              ?
                              parseFloat(advancehfta) < parseFloat(tadvance)
                                ?
                                parseFloat(advancehfta)
                                :
                                tadvance
                              :
                              billminusthev > tadvance ?
                                tadvance > 0 ?
                                  tadvance
                                  : 0
                                :
                                tadvance//  billminusthev
                            :
                            parseFloat(advancehfta) > 0
                              ?
                              (parseFloat(advancehfta) <= parseFloat(tillkhadya))
                                ?
                                parseFloat(user.advhpta)
                                :
                                parseFloat(tillkhadya)
                              :
                              parseFloat(tillkhadya)
                        ).toFixed(2);

                      // updatedDataSource = [...DataSource];

                      const cuchalValue = parseFloat(user.cuchal);
                      const newadvValue = parseFloat(user.newadv);
                      const obalValue = parseFloat(user.obal);
                      const bcountValue = parseFloat(user.bcount);
                      const advhptaValue = parseFloat(user.advhpta);
                      const billValue = parseFloat(user.bill).toFixed(2);
                      const mhliterValue = parseFloat(user.mhliter);
                      const mhthevValue = parseFloat(user.mhthev);
                      const gayliterValue = parseFloat(user.gayliter);
                      const gaythevValue = parseFloat(user.gaythev);
                      const ckhadyaValue = parseFloat(user.ckhadya);
                      const newkhadyaValue = parseFloat(user.newkhadya);
                      const ikapatliter2Value = parseFloat(user.ikapatliter2);
                      const tliterValue = parseFloat(user.tliter);
                      const ikapatbill2Value = parseFloat(user.ikapatbill2);
                      const vah2Value = parseFloat(user.vah2);
                      const gayvahValue = parseFloat(user.gayvah);

                      const calculatedValue = parseFloat(
                        cuchalValue + (bcountValue > 0 ? newadvValue : obalValue)
                      ).toFixed(2);

                      const mhthevCalculation = (mhliterValue * mhthevValue).toFixed(2);
                      const gaythevCalculation = (gayliterValue * gaythevValue).toFixed(2);
                      const totalBillMinusThev = (billValue - parseFloat(mhthevCalculation) - parseFloat(gaythevCalculation)).toFixed(2);

                      const advhptaCheck = advhptaValue <= totalBillMinusThev ? advhptaValue : totalBillMinusThev;

                      const ckhadyaPlusNewKhadya = (ckhadyaValue + newkhadyaValue).toFixed(2);
                      const khadyaCheck = parseFloat(totalBillMinusThev) < parseFloat(ckhadyaPlusNewKhadya) ? totalBillMinusThev : ckhadyaPlusNewKhadya;

                      const finalCalculation = (
                        parseFloat(
                          totalBillMinusThev -
                          parseFloat(ikapatliter2Value * tliterValue || 0) -
                          parseFloat(ikapatbill2Value || 0) +
                          parseFloat(vah2Value * mhliterValue || 0) +
                          parseFloat(gayvahValue * gayliterValue || 0)
                        ).toFixed(2)
                      );

                      const resultValue = user.result && !isNaN(user.result)
                        ? parseFloat(user.result).toFixed(2)
                        : finalCalculation <= calculatedValue ? finalCalculation : calculatedValue;


                      if (updatedDataSource[index]) {
                        addOrUpdateCkhadya(user.kno, khedit);
                        addOrUpdateCuchal(user.kno, advedit);
                        addOrUpdateCratib(user.kno, ratibedit);
                        addOrUpdateCkarj(user.kno, karjedit);
                        addOrUpdateCkarjintr(user.kno, karjintr);
                        addOrUpdatesangh(user.kno, sanghedit);
                        addOrUpdatebhishi(user.kno, bhishiedit);

                        updatedDataSource[index].action = khedit;

                        if (!khedit) {
                          khedit = 0;
                        }
                        updatedDataSource[index].khedit = khedit;
                        updatedDataSource[index].advedit = advedit;
                        updatedDataSource[index].ratibedit = ratibedit;
                        updatedDataSource[index].karjedit = karjedit;
                        updatedDataSource[index].karjintr = karjintr;
                        updatedDataSource[index].sanghedit = sanghedit;
                        updatedDataSource[index].bhishiedit = bhishiedit;

                        if (first === "false") {
                          // console.log("in first time");
                          updatedDataSource[index].khedit = khedit;
                          updatedDataSource[index].advedit = advedit;
                          updatedDataSource[index].ratibedit = ratibedit;
                          updatedDataSource[index].karjedit = karjedit;
                          updatedDataSource[index].karjintr = karjintr;
                          updatedDataSource[index].sanghedit = sanghedit;
                          updatedDataSource[index].bhishiedit = bhishiedit;
                          setfirst("true")
                        }
                      }

                      return (
                        <tr key={index}>
                          <td className='thsmall'>{user.kno}</td>
                          <td className='thsmall'>{user.name}</td>
                          <td className='thsmall2'>{parseFloat(user.bill).toFixed(2)}</td>
                          <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.tliter ? parseFloat(user.tliter).toFixed(2) : 0}</td>
                          <td className={'thsmallhide'}>
                            {
                              user.flag === "oldbill" ?
                                (user.magilthev ? parseFloat(user.magilthev).toFixed(2) : 0) :
                                parseFloat(user.bcount) > 0 ? parseFloat(user.newthev).toFixed(2) : parseFloat(user.othev).toFixed(2)
                            }</td>
                          <td className='thsmall2'>{
                            user.flag === "oldbill" ?
                              (user.cthev ? parseFloat(user.cthev).toFixed(2) : 0) :
                              localStorage.getItem("thevper") === "No" ?
                                allthevtofixed
                                : localStorage.getItem("thevper") === "Bill" ?
                                  allthevtofixed
                                  :
                                  parseFloat(parseFloat(user.bill * 10) / 100).toFixed(2)
                          }</td>
                          <td className={'thsmallhide '}>
                            {
                              user.flag === "oldbill" ?
                                parseFloat(user.newthev) ? parseFloat(user.newthev).toFixed(2) : 0
                                :
                                localStorage.getItem("thevper") === "No" ?
                                  parseFloat(parseFloat(parseFloat(user.mhliter * user.mhthev) + parseFloat(user.gayliter * user.gaythev)) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newthev) : parseFloat(user.othev))).toFixed(2)
                                  : localStorage.getItem("thevper") === "Bill" ?
                                    parseFloat(parseFloat(allthevtofixed) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newthev) : parseFloat(user.othev)))
                                    :
                                    (parseFloat(parseFloat(user.bill * 10) / 100) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newthev) : parseFloat(user.othev))).toFixed(2)
                            }</td>
                          {

                            localStorage.getItem("itr1name") != "-" ?
                              <>
                                <td className={'thsmallhide'}>
                                  {
                                    user.flag === "oldbill" ?
                                      (user.magilthevitr1 ? parseFloat(user.magilthevitr1).toFixed(2) : 0) :
                                      (user.newthevitr1 ? parseFloat(user.newthevitr1).toFixed(2) : 0)
                                  }</td>
                                <td className='thsmall2'>{
                                  user.flag === "oldbill" ?
                                    (user.cthevitr1 ? parseFloat(user.cthevitr1).toFixed(2) : 0) :
                                    localStorage.getItem("itr1type") === "liter" ?
                                      parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value"))).toFixed(2)
                                      : localStorage.getItem("itr1type") === "per" ?
                                        parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr1value"))) / 100).toFixed(2)
                                        :
                                        parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value"))).toFixed(2)
                                }</td>
                                <td className={'thsmallhide'}>
                                  {
                                    user.flag === "oldbill" ?
                                      parseFloat(user.newthevitr1) ? parseFloat(user.newthevitr1).toFixed(2) : 0
                                      :
                                      localStorage.getItem("itr1type") === "liter" ?
                                        parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value"))) + parseFloat(user.newthevitr1)).toFixed(2)
                                        : localStorage.getItem("itr1type") === "per" ?
                                          parseFloat(parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr1value"))) / 100) + parseFloat(user.newthevitr1)).toFixed(2)
                                          :
                                          parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr1value"))) + parseFloat(user.newthevitr1)).toFixed(2)
                                  }</td>
                              </>
                              :
                              <>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                              </>
                          }

                          {
                            localStorage.getItem("itr2name") != "-" ?
                              <>
                                <td className={'thsmallhide'}>
                                  {
                                    user.flag === "oldbill" ?
                                      (user.magilthevitr2 ? parseFloat(user.magilthevitr2).toFixed(2) : 0) :
                                      (user.newthevitr2 ? parseFloat(user.newthevitr2).toFixed(2) : 0)
                                  }</td>
                                <td className='thsmall2'>{
                                  user.flag === "oldbill" ?
                                    (user.cthevitr2 ? parseFloat(user.cthevitr2).toFixed(2) : 0) :
                                    localStorage.getItem("itr2type") === "liter" ?
                                      parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value"))).toFixed(2)
                                      : localStorage.getItem("itr2type") === "per" ?
                                        parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr2value"))) / 100).toFixed(2)
                                        :
                                        parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value"))).toFixed(2)
                                }</td>
                                <td className={'thsmallhide'}>
                                  {
                                    user.flag === "oldbill" ?
                                      parseFloat(user.newthevitr2) ? parseFloat(user.newthevitr2).toFixed(2) : 0
                                      :
                                      localStorage.getItem("itr2type") === "liter" ?
                                        parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value"))) + parseFloat(user.newthevitr2)).toFixed(2)
                                        : localStorage.getItem("itr2type") === "per" ?
                                          parseFloat(parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr2value"))) / 100) + parseFloat(user.newthevitr2)).toFixed(2)
                                          :
                                          parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr2value"))) + parseFloat(user.newthevitr2)).toFixed(2)
                                  }</td>
                              </>
                              :
                              <>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                              </>
                          }

                          {
                            localStorage.getItem("itr3name") != "-" ?
                              <>
                                <td className={'thsmallhide'}>
                                  {
                                    user.flag === "oldbill" ?
                                      (user.magilthevitr3 ? parseFloat(user.magilthevitr3).toFixed(2) : 0) :
                                      (user.newthevitr3 ? parseFloat(user.newthevitr3).toFixed(2) : 0)
                                  }</td>
                                <td className='thsmall2'>{
                                  user.flag === "oldbill" ?
                                    (user.cthevitr3 ? parseFloat(user.cthevitr3).toFixed(2) : 0) :
                                    localStorage.getItem("itr3type") === "liter" ?
                                      parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value"))).toFixed(2)
                                      : localStorage.getItem("itr3type") === "per" ?
                                        parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr3value"))) / 100).toFixed(2)
                                        :
                                        parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value"))).toFixed(2)
                                }</td>
                                <td className={'thsmallhide'}>
                                  {
                                    user.flag === "oldbill" ?
                                      parseFloat(user.newthevitr3) ? parseFloat(user.newthevitr3).toFixed(2) : 0
                                      :
                                      localStorage.getItem("itr3type") === "liter" ?
                                        parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value"))) + parseFloat(user.newthevitr3)).toFixed(2)
                                        : localStorage.getItem("itr3type") === "per" ?
                                          parseFloat(parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr3value"))) / 100) + parseFloat(user.newthevitr3)).toFixed(2)
                                          :
                                          parseFloat(parseFloat(user.tliter * parseFloat(localStorage.getItem("itr3value"))) + parseFloat(user.newthevitr3)).toFixed(2)
                                  }</td>
                              </>
                              :
                              <>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                              </>
                          }

                          <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>
                            {
                              user.flag === "oldbill" ?
                                (user.newadv ? user.newadv : 0) :
                                parseFloat(user.bcount) > 0 ? parseFloat(user.newadv).toFixed(2) : parseFloat(user.obal).toFixed(2)
                            }</td>
                          <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.cuchal ? user.cuchal : 0}</td>
                          <td className='thsmall2'>
                            {
                              user.flag === "oldbill" ?
                                (user.tadv ? parseFloat(user.tadv).toFixed(2) : 0) :
                                parseFloat(parseFloat(user.cuchal) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newadv) : parseFloat(user.obal))).toFixed(2)
                            }</td>
                          <td className='thsmall2edit'
                            contentEditable={
                              user.flag === "oldbill" ?
                                user.lastbill === "Yes" ?
                                  'true'
                                  : 'false'
                                :
                                user.bill > 0 ?
                                  'true'
                                  :
                                  'false'
                            }
                            onKeyDown={(e) => handleCellKeyPress(e, index)}
                            onBlur={(e) => handleCellBlur(e, index)}
                            onFocus={(e) => handleCellfocus(e, index)}
                            ref={(td) => {
                              if (!cellRefs.current[index]) {
                                cellRefs.current[index] = [];
                              }
                              cellRefs.current[index][0] = td; // Save the ref for the cell
                            }}
                            onInput={(e) => handleCellChange(e, index, user.kno)}>
                            {
                              localStorage.getItem("autocutting") === "on" ?
                                parseFloat(advedit).toFixed(2)
                                :
                                user.flag === "oldbill" ?
                                  parseFloat(advedit).toFixed(2)
                                  :
                                  0
                            }
                          </td>

                          <td className={showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen'} >
                            {user.flag === "oldbill" ? (
                              user.result != null && !isNaN(user.result) ? parseFloat(user.result).toFixed(2) : user.newadvcurrent != null && !isNaN(user.newadvcurrent) ? parseFloat(user.newadvcurrent).toFixed(2) : 0
                            )
                              :
                              tadvance > 0
                                ?
                                (
                                  user.result != null && !isNaN(user.result)
                                    ?
                                    parseFloat(user.result).toFixed(2)
                                    :
                                    parseFloat(parseFloat(tadvance) - parseFloat(localStorage.getItem("autocutting") === "on" ? advedit : 0)).toFixed(2)
                                )
                                :
                                tadvance}
                          </td>

                          {/* uchal end */}

                          {/* Khayda started  */}

                          <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{
                            user.flag === "oldbill" ?
                              (user.mkhadya ? parseFloat(user.mkhadya).toFixed(2) : 0) :
                              parseFloat(user.bcount) > 0 ? parseFloat(user.newkhadya).toFixed(2) : parseFloat(user.okhadya).toFixed(2)
                          }</td>
                          <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.ckhadya ? parseFloat(user.ckhadya).toFixed(2) : 0}</td>
                          <td className='thsmall2'>
                            {
                              user.flag === "oldbill" ?
                                parseFloat(user.ckhadya) + parseFloat(user.mkhadya) ? parseFloat(parseFloat(user.ckhadya) + parseFloat(user.mkhadya)).toFixed(2) : 0
                                :
                                parseFloat(user.ckhadya) + parseFloat(user.newkhadya) ? parseFloat(parseFloat(user.ckhadya) + parseFloat(user.newkhadya)).toFixed(2) : 0
                            }
                          </td>

                          <td
                            key={25}
                            className='thsmall2edit'
                            contentEditable={
                              user.flag === "oldbill"
                                ? user.lastbill === "Yes"
                                  ? 'true'
                                  : 'false'
                                :
                                user.bill > 0 ?
                                  'true'
                                  :
                                  'false'
                            }
                            onKeyDown={(e) => handleCellKeyPress12(e, index, 25)}  // ✅ Pass colIndex here
                            onBlur={(e) => handleCellBlurkh(e, index)}
                            ref={(td) => {
                              if (!cellRefs.current[index]) {
                                cellRefs.current[index] = {}; // Store by column index
                              }
                              cellRefs.current[index][25] = td; // ✅ Store reference properly
                            }}
                            onInput={(e) => handleCellChangekh(e, index, user.kno)}
                          >
                            {
                              localStorage.getItem("autocutting") === "on" ?
                                parseFloat(khedit).toFixed(2)
                                :
                                user.flag === "oldbill" ?
                                  parseFloat(khedit).toFixed(2)
                                  :
                                  0

                            }
                          </td>


                          <td className={showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen'}>
                            {
                              user.flag === "oldbill" ?
                                (user.result2 != null && !isNaN(user.result2) ? parseFloat(user.result2).toFixed(2) : user.newkhadyacurrent != null && !isNaN(user.newkhadyacurrent) ? parseFloat(user.newkhadyacurrent).toFixed(2) : 0) :
                                user.result2 != null && !isNaN(user.result2) ? parseFloat(user.result2).toFixed(2) : (parseFloat(user.ckhadya) + parseFloat(user.newkhadya) -
                                  (localStorage.getItem("autocutting") === "on" ? khedit : 0)
                                ).toFixed(2)
                            }
                          </td>
                          {/* Khadya end */}

                          {/* Ratib started  */}

                          <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{
                            user.flag === "oldbill" ?
                              (user.mratib ? parseFloat(user.mratib).toFixed(2) : 0) :
                              user.newratib ? parseFloat(user.newratib).toFixed(2) : 0
                          }</td>

                          <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.cratib ? parseFloat(user.cratib).toFixed(2) : 0}</td>
                          <td className='thsmall2'>
                            {
                              user.flag === "oldbill" ?
                                parseFloat(user.cratib) + parseFloat(user.mratib) ? parseFloat(parseFloat(user.cratib) + parseFloat(user.mratib)).toFixed(2) : 0
                                :
                                parseFloat(user.cratib) + parseFloat(user.newratib) ? parseFloat(parseFloat(user.cratib) + parseFloat(user.newratib)).toFixed(2) : 0
                            }
                          </td>

                          <td
                            key={25}
                            className='thsmall2edit'
                            contentEditable={
                              user.flag === "oldbill"
                                ? user.lastbill === "Yes"
                                  ? 'true'
                                  : 'false'
                                :
                                user.bill > 0 ?
                                  'true'
                                  :
                                  'false'
                            }
                            onKeyDown={(e) => handleCellKeyPress12(e, index, 25)}  // ✅ Pass colIndex here
                            onBlur={(e) => handleCellBlurkh(e, index)}
                            ref={(td) => {
                              if (!cellRefs.current[index]) {
                                cellRefs.current[index] = {}; // Store by column index
                              }
                              cellRefs.current[index][25] = td; // ✅ Store reference properly
                            }}
                            onInput={(e) => handleCellChangeratib(e, index, user.kno)}
                          >
                            {
                              localStorage.getItem("autocutting") === "on" ?
                                parseFloat(ratibedit).toFixed(2)
                                :
                                user.flag === "oldbill" ?
                                  parseFloat(ratibedit).toFixed(2)
                                  :
                                  0
                            }
                          </td>

                          <td className={showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen'}>
                            {
                              user.flag === "oldbill" ?
                                (user.result3 != null && !isNaN(user.result3) ? parseFloat(user.result3).toFixed(2) : user.newratib != null && !isNaN(user.newratib) ? parseFloat(user.newratib).toFixed(2) : 0) :
                                user.result3 != null && !isNaN(user.result3) ? parseFloat(user.result3).toFixed(2) : (parseFloat(user.cratib) + parseFloat(user.newratib) -
                                  (localStorage.getItem("autocutting") === "on" ? ratibedit : 0)
                                ).toFixed(2)
                            }
                          </td>

                          {/* ratib end */}

                          {/* karj started  */}
                          {
                            localStorage.getItem("karj") == "On" ?
                              <>
                                <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{
                                  user.flag === "oldbill" ?
                                    (user.mkarj ? parseFloat(user.mkarj).toFixed(2) : 0) :
                                    user.newkarj ? parseFloat(user.newkarj).toFixed(2) : 0
                                }</td>

                                <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.ckarj ? parseFloat(user.ckarj).toFixed(2) : 0}</td>
                                <td className='thsmall2'>
                                  {
                                    user.flag === "oldbill" ?
                                      parseFloat(user.ckarj) + parseFloat(user.mkarj) ? parseFloat(parseFloat(user.ckarj) + parseFloat(user.mkarj)).toFixed(2) : 0
                                      :
                                      parseFloat(user.ckarj) + parseFloat(user.newkarj) ? parseFloat(parseFloat(user.ckarj) + parseFloat(user.newkarj)).toFixed(2) : 0
                                  }
                                </td>
                                <td
                                  key={25}
                                  className='thsmall2edit'
                                  contentEditable={
                                    user.flag === "oldbill"
                                      ? user.lastbill === "Yes"
                                        ? 'true'
                                        : 'false'
                                      :
                                      user.bill > 0 ?
                                        'true'
                                        :
                                        'false'
                                  }
                                  onKeyDown={(e) => handleCellKeyPress12(e, index, 25)}  // ✅ Pass colIndex here
                                  onBlur={(e) => handleCellBlurkh(e, index)}
                                  ref={(td) => {
                                    if (!cellRefs.current[index]) {
                                      cellRefs.current[index] = {}; // Store by column index
                                    }
                                    cellRefs.current[index][25] = td; // ✅ Store reference properly
                                  }}
                                  onInput={(e) => handleCellChangekarj(e, index, user.kno, karjintr)}
                                >
                                  {parseFloat(karjedit).toFixed(2)}
                                </td>


                                <td className={'thsmall'}>
                                  {
                                    user.flag === "oldbill" ?
                                      parseFloat(user.karjintr).toFixed(2)
                                      :
                                      karjintr ? parseFloat(karjintr).toFixed(2) : 0
                                  }
                                </td>

                                <td className={showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen'}>
                                  {
                                    user.flag === "oldbill" ?
                                      (user.result4 != null && !isNaN(user.result4) ? parseFloat(user.result4).toFixed(2) : user.newkarj != null && !isNaN(user.newkarj) ? parseFloat(user.newkarj).toFixed(2) : 0) :
                                      user.result4 != null && !isNaN(user.result4) ? parseFloat(user.result4).toFixed(2) : (parseFloat(user.ckarj) + parseFloat(user.newkarj) -
                                        (parseFloat(karjedit))
                                      ).toFixed(2)
                                  }
                                </td>

                              </>
                              :
                              <>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                              </>
                          }
                          {/* karj end */}

                          {/* sangh kharedi started  */}
                          {
                            localStorage.getItem("sanghk") == "On" ?
                              <>
                                <td className={localStorage.getItem("sanghkname") === "संघ खरेदी" ? showthevcol === "Yes" ? 'thsmall' : 'thsmallhide' : 'thsmallhide'}>{
                                  user.flag === "oldbill" ?
                                    (user.magilsangh ? parseFloat(user.magilsangh).toFixed(2) : 0) :
                                    user.newsangh ? parseFloat(user.newsangh).toFixed(2) : 0
                                }</td>

                                <td className={localStorage.getItem("sanghkname") === "संघ खरेदी" ? showthevcol === "Yes" ? 'thsmall' : 'thsmallhide' : 'thsmallhide'}>{user.csangh ? parseFloat(user.csangh).toFixed(2) : 0}</td>
                                <td className={localStorage.getItem("sanghkname") === "संघ खरेदी" ? 'thsmall2' : 'thsmallhide'}>
                                  {
                                    user.flag === "oldbill" ?
                                      parseFloat(user.csangh) + parseFloat(user.magilsangh) ? parseFloat(parseFloat(user.csangh) + parseFloat(user.magilsangh)).toFixed(2) : 0
                                      :
                                      parseFloat(user.csangh) + parseFloat(user.newsangh) ? parseFloat(parseFloat(user.csangh) + parseFloat(user.newsangh)).toFixed(2) : 0
                                  }
                                </td>
                                <td
                                  key={25}
                                  className='thsmall2edit'
                                  contentEditable={
                                    user.flag === "oldbill"
                                      ? user.lastbill === "Yes"
                                        ? 'true'
                                        : 'false'
                                      :
                                      user.bill > 0 ?
                                        'true'
                                        :
                                        'false'
                                  }
                                  onKeyDown={(e) => handleCellKeyPress12(e, index, 25)}  // ✅ Pass colIndex here
                                  onBlur={(e) => handleCellBlurkh(e, index)}
                                  ref={(td) => {
                                    if (!cellRefs.current[index]) {
                                      cellRefs.current[index] = {}; // Store by column index
                                    }
                                    cellRefs.current[index][25] = td; // ✅ Store reference properly
                                  }}
                                  onInput={(e) => handleCellChangesangh(e, index, user.kno)}
                                >
                                  {
                                    localStorage.getItem("autocutting") === "on" ?
                                      parseFloat(sanghedit).toFixed(2)
                                      :
                                      user.flag === "oldbill" ?
                                        parseFloat(sanghedit).toFixed(2)
                                        :
                                        0
                                  }
                                </td>

                                <td className={localStorage.getItem("sanghkname") === "संघ खरेदी" ? showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen' : 'thsmallhide'}>
                                  {
                                    user.flag === "oldbill" ?
                                      (user.resultsangh != null && !isNaN(user.resultsangh) ? parseFloat(user.resultsangh).toFixed(2) : user.newsangh != null && !isNaN(user.newsangh) ? parseFloat(user.newsangh).toFixed(2) : 0) :
                                      user.resultsangh != null && !isNaN(user.resultsangh) ? parseFloat(user.resultsangh).toFixed(2) : (parseFloat(user.csangh) + parseFloat(user.newsangh) -
                                        (localStorage.getItem("autocutting") === "on" ? parseFloat(sanghedit) : 0)
                                      ).toFixed(2)
                                  }
                                </td>

                              </>
                              :
                              <>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                              </>
                          }
                          {/* sangh kharedi end */}


                          {/* bhishi started */}

                          {
                            localStorage.getItem("itrname") != "-" ?
                              <>
                                <td className={'thsmall'}>
                                  {
                                    user.flag === "oldbill" ?
                                      (user.magilbhishi ? parseFloat(user.magilbhishi).toFixed(2) : 0) :
                                      parseFloat(user.bcount) > 0 ? parseFloat(user.newbhishi).toFixed(2) : parseFloat(user.obhishi).toFixed(2)
                                  }</td>
                                <td
                                  key={28}
                                  className='thsmall2edit'
                                  contentEditable={
                                    user.flag === "oldbill"
                                      ? user.lastbill === "Yes"
                                        ? 'true'
                                        : 'false'
                                      :
                                      user.bill > 0 ?
                                        'true'
                                        :
                                        'false'
                                  }
                                  onKeyDown={(e) => handleCellKeyPress12(e, index, 28)}  // ✅ Pass colIndex here
                                  onBlur={(e) => handleCellBlurikapat(e, index)}
                                  ref={(td) => {
                                    if (!cellRefs.current[index]) {
                                      cellRefs.current[index] = {}; // Store by column index
                                    }
                                    cellRefs.current[index][28] = td; // ✅ Store reference properly
                                  }}
                                  onInput={(e) => handleCellChangebhishi(e, index, user.kno)}
                                >
                                  {
                                    user.flag === "oldbill" ?
                                      (user.cbhishi ? parseFloat(user.cbhishi) : 0)
                                      :
                                      parseFloat(billminusthevplusvahtuk) > 0
                                        ?
                                        (localStorage.getItem("itrvalue") ? parseFloat(localStorage.getItem("itrvalue")) : 0)
                                        : 0
                                  }
                                </td>

                                <td className={showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen'}>
                                  {
                                    user.flag === "oldbill" ?
                                      (user.resultbhishi != null && !isNaN(user.resultbhishi) ? parseFloat(user.resultbhishi).toFixed(2) : user.newbhishi != null && !isNaN(user.newbhishi) ? parseFloat(user.newbhishi).toFixed(2) : 0) :
                                      user.resultbhishi != null && !isNaN(user.resultbhishi) ? parseFloat(user.resultbhishi).toFixed(2) : ((parseFloat(billminusthevplusvahtuk) > 0 ? (parseFloat(localStorage.getItem("itrvalue"))) : 0) + parseFloat(user.newbhishi)
                                      ).toFixed(2)
                                  }
                                </td>
                              </>
                              :
                              <>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                              </>
                          }

                          {/* bhishi end  */}


                          {/* itr started  */}
                          <td className={'thsmallhide'}>
                            {
                              user.flag === "oldbill" ?
                                (user.ikapatliter ? parseFloat(user.ikapatliter) : 0) :
                                (user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter).toFixed(2) : 0)
                            }
                          </td>

                          <td
                            key={27}
                            className='thsmall2edit'
                            contentEditable={
                              user.flag === "oldbill"
                                ? user.lastbill === "Yes"
                                  ? 'true'
                                  : 'false'
                                :
                                user.bill > 0 ?
                                  'true'
                                  :
                                  'false'
                            }
                            onKeyDown={(e) => handleCellKeyPress12(e, index, 27)}  // ✅ Pass colIndex here
                            onBlur={(e) => handleCellBlurikapat(e, index)}
                            ref={(td) => {
                              if (!cellRefs.current[index]) {
                                cellRefs.current[index] = {}; // Store by column index
                              }
                              cellRefs.current[index][27] = td; // ✅ Store reference properly
                            }}
                            onInput={(e) => handleCellChangeikapat(e, index, user.kno)}
                          >
                            {
                              user.flag === "oldbill" ?
                                (user.ikapatbill ? parseFloat(user.ikapatbill) : 0) :
                                (user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)
                            }
                          </td>

                          {
                            localStorage.getItem("retan") == "On" ?
                              <>
                                <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{
                                  user.flag === "oldbill" ?
                                    (user.magilretanmedi ? parseFloat(user.magilretanmedi).toFixed(2) : 0) :
                                    user.newretanmedi ? parseFloat(user.newretanmedi).toFixed(2) : 0
                                }</td>

                                <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>{user.cretanmedi ? user.cretanmedi : 0}</td>

                                <td className='thsmall2'>
                                  {
                                    user.flag === "oldbill" ?
                                      (user.tretanmedi ? parseFloat(user.tretanmedi).toFixed(2) : 0) :
                                      parseFloat(parseFloat(user.cretanmedi) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newretanmedi) : parseFloat(user.oretanmedi))).toFixed(2)
                                  }</td>

                                <td
                                  key={28}
                                  className='thsmall2edit'
                                  contentEditable={
                                    user.flag === "oldbill"
                                      ? user.lastbill === "Yes"
                                        ? 'true'
                                        : 'false'
                                      :
                                      user.bill > 0 ?
                                        'true'
                                        :
                                        'false'
                                  }
                                  onKeyDown={(e) => handleCellKeyPress12(e, index, 28)}  // ✅ Pass colIndex here
                                  onBlur={(e) => handleCellBlurikapat(e, index)}
                                  ref={(td) => {
                                    if (!cellRefs.current[index]) {
                                      cellRefs.current[index] = {}; // Store by column index
                                    }
                                    cellRefs.current[index][28] = td; // ✅ Store reference properly
                                  }}
                                  onInput={(e) => handleCellChangeretan(e, index, user.kno)}
                                >
                                  {
                                    user.flag === "oldbill" ?
                                      (user.retan ? parseFloat(user.retan) : 0) :
                                      (user.retan ? parseFloat(user.retan) : 0)
                                  }
                                </td>

                                <td
                                  key={29}
                                  className='thsmall2edit'
                                  contentEditable={
                                    user.flag === "oldbill"
                                      ? user.lastbill === "Yes"
                                        ? 'true'
                                        : 'false'
                                      :
                                      user.bill > 0 ?
                                        'true'
                                        :
                                        'false'
                                  }
                                  onKeyDown={(e) => handleCellKeyPress12(e, index, 29)}  // ✅ Pass colIndex here
                                  onBlur={(e) => handleCellBlurikapat(e, index)}
                                  ref={(td) => {
                                    if (!cellRefs.current[index]) {
                                      cellRefs.current[index] = {}; // Store by column index
                                    }
                                    cellRefs.current[index][29] = td; // ✅ Store reference properly
                                  }}
                                  onInput={(e) => handleCellChangemedi(e, index, user.kno)}
                                >
                                  {
                                    user.flag === "oldbill" ?
                                      (user.medi ? parseFloat(user.medi) : 0) :
                                      (user.medi ? parseFloat(user.medi) : 0)
                                  }
                                </td>

                                <td className={showthevcol === "Yes" ? 'thsmallgreen' : 'thsmallgreen'}>
                                  {
                                    user.flag === "oldbill" ?
                                      (user.resultretanmedi != null && !isNaN(user.resultretanmedi) ? parseFloat(user.resultretanmedi).toFixed(2) : user.newretanmedi != null && !isNaN(user.newretanmedi) ? parseFloat(user.newretanmedi).toFixed(2) : 0) :
                                      user.resultretanmedi != null && !isNaN(user.resultretanmedi) ? parseFloat(user.resultretanmedi).toFixed(2)
                                        :
                                        user.flag === "oldbill" ?
                                          (user.resultretanmedi ? parseFloat(user.resultretanmedi).toFixed(2) : 0) :
                                          parseFloat(parseFloat(user.cretanmedi) + (parseFloat(user.bcount) > 0 ? parseFloat(user.newretanmedi) : parseFloat(user.oretanmedi))).toFixed(2)
                                  }
                                </td>
                              </>
                              :
                              <>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                                <td className={'thsmallhide'}>{0}</td>
                              </>
                          }

                          {/* {
                            localStorage.getItem("itr4name") != "-" ?
                              <>
                                <td className='thsmall2edit'>{
                                  user.flag === "oldbill" ?
                                    (user.itrkapat1 ? parseFloat(user.itrkapat1).toFixed(2) : 0) :
                                    localStorage.getItem("itr4type") === "liter" ?
                                      parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value"))).toFixed(2)
                                      : localStorage.getItem("itr4type") === "per" ?
                                        parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr4value"))) / 100).toFixed(2)
                                        :
                                        localStorage.getItem("itr4type") === "bill" ?
                                          parseFloat(localStorage.getItem("itr4value")).toFixed(2)
                                          :
                                          parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value"))).toFixed(2)
                                }</td>
                              </>
                              :
                              <td className={'thsmallhide'}>{0}</td>
                          } */}

                          {
                            localStorage.getItem("itr4name") != "-" ?
                              <>
                                <td
                                  key={30}
                                  className='thsmall2edit'
                                  contentEditable={
                                    user.flag === "oldbill"
                                      ? user.lastbill === "Yes"
                                        ? 'true'
                                        : 'false'
                                      :
                                      user.bill > 0 ?
                                        'true'
                                        :
                                        'false'
                                  }
                                  onKeyDown={(e) => handleCellKeyPress12(e, index, 30)}  // ✅ Pass colIndex here
                                  onBlur={(e) => handleCellBlurikapat1(e, index)}
                                  ref={(td) => {
                                    if (!cellRefs.current[index]) {
                                      cellRefs.current[index] = {}; // Store by column index
                                    }
                                    cellRefs.current[index][30] = td; // ✅ Store reference properly
                                  }}
                                  onInput={(e) => handleCellChangeikapat1(e, index, user.kno)}
                                >
                                  {
                                    user.flag === "oldbill" ?
                                      (user.itrkapat1 ? parseFloat(user.itrkapat1).toFixed(2) : 0) :
                                      localStorage.getItem("itr4type") === "liter" ?
                                        parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value"))).toFixed(2)
                                        : localStorage.getItem("itr4type") === "per" ?
                                          parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr4value"))) / 100).toFixed(2)
                                          :
                                          localStorage.getItem("itr4type") === "bill" ?
                                            parseFloat(localStorage.getItem("itr4value")).toFixed(2)
                                            :
                                            parseFloat(user.tliter * parseFloat(localStorage.getItem("itr4value"))).toFixed(2)
                                  }
                                </td>
                              </>
                              :
                              <td className={'thsmallhide'}>{0}</td>
                          }

                          {/* {
                            localStorage.getItem("itr5name") != "-" ?
                              <>
                                <td className='thsmall2edit'>{
                                  user.flag === "oldbill" ?
                                    (user.itrkapat2 ? parseFloat(user.itrkapat2).toFixed(2) : 0) :
                                    localStorage.getItem("itr5type") === "liter" ?
                                      parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value"))).toFixed(2)
                                      : localStorage.getItem("itr5type") === "per" ?
                                        parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr5value"))) / 100).toFixed(2)
                                        :
                                        localStorage.getItem("itr5type") === "bill" ?
                                          parseFloat(localStorage.getItem("itr5value")).toFixed(2)
                                          :
                                          parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value"))).toFixed(2)
                                }</td>

                              </>
                              :
                              <td className={'thsmallhide'}>{0}</td>
                          } */}

                          {
                            localStorage.getItem("itr5name") != "-" ?
                              <>
                                <td
                                  key={31}
                                  className='thsmall2edit'
                                  contentEditable={
                                    user.flag === "oldbill"
                                      ? user.lastbill === "Yes"
                                        ? 'true'
                                        : 'false'
                                      :
                                      user.bill > 0 ?
                                        'true'
                                        :
                                        'false'
                                  }
                                  onKeyDown={(e) => handleCellKeyPress12(e, index, 31)}  // ✅ Pass colIndex here
                                  onBlur={(e) => handleCellBlurikapat(e, index)}
                                  ref={(td) => {
                                    if (!cellRefs.current[index]) {
                                      cellRefs.current[index] = {}; // Store by column index
                                    }
                                    cellRefs.current[index][31] = td; // ✅ Store reference properly
                                  }}
                                  onInput={(e) => handleCellChangeikapat2(e, index, user.kno)}
                                >
                                  {
                                    user.flag === "oldbill" ?
                                      (user.itrkapat2 ? parseFloat(user.itrkapat2).toFixed(2) : 0) :
                                      localStorage.getItem("itr5type") === "liter" ?
                                        parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value"))).toFixed(2)
                                        : localStorage.getItem("itr5type") === "per" ?
                                          parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr5value"))) / 100).toFixed(2)
                                          :
                                          localStorage.getItem("itr5type") === "bill" ?
                                            parseFloat(localStorage.getItem("itr5value")).toFixed(2)
                                            :
                                            parseFloat(user.tliter * parseFloat(localStorage.getItem("itr5value"))).toFixed(2)
                                  }
                                </td>
                              </>
                              :
                              <td className={'thsmallhide'}>{0}</td>
                          }

                          {/* {
                            localStorage.getItem("itr6name") != "-" ?
                              <>
                                <td className='thsmall2edit'>{
                                  user.flag === "oldbill" ?
                                    (user.itrkapat3 ? parseFloat(user.itrkapat3).toFixed(2) : 0) :
                                    localStorage.getItem("itr6type") === "liter" ?
                                      parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value"))).toFixed(2)
                                      : localStorage.getItem("itr6type") === "per" ?
                                        parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr6value"))) / 100).toFixed(2)
                                        :
                                        localStorage.getItem("itr6type") === "bill" ?
                                          parseFloat(localStorage.getItem("itr6value")).toFixed(2)
                                          :
                                          parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value"))).toFixed(2)
                                }</td>

                              </>
                              :
                              <td className={'thsmallhide'}>{0}</td>
                          } */}

                          {
                            localStorage.getItem("itr6name") != "-" ?
                              <>
                                <td
                                  key={32}
                                  className='thsmall2edit'
                                  contentEditable={
                                    user.flag === "oldbill"
                                      ? user.lastbill === "Yes"
                                        ? 'true'
                                        : 'false'
                                      :
                                      user.bill > 0 ?
                                        'true'
                                        :
                                        'false'
                                  }
                                  onKeyDown={(e) => handleCellKeyPress12(e, index, 32)}  // ✅ Pass colIndex here
                                  onBlur={(e) => handleCellBlurikapat(e, index)}
                                  ref={(td) => {
                                    if (!cellRefs.current[index]) {
                                      cellRefs.current[index] = {}; // Store by column index
                                    }
                                    cellRefs.current[index][32] = td; // ✅ Store reference properly
                                  }}
                                  onInput={(e) => handleCellChangeikapat3(e, index, user.kno)}
                                >
                                  {
                                    user.flag === "oldbill" ?
                                      (user.itrkapat3 ? parseFloat(user.itrkapat3).toFixed(2) : 0) :
                                      localStorage.getItem("itr6type") === "liter" ?
                                        parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value"))).toFixed(2)
                                        : localStorage.getItem("itr6type") === "per" ?
                                          parseFloat(parseFloat(user.bill * parseFloat(localStorage.getItem("itr6value"))) / 100).toFixed(2)
                                          :
                                          localStorage.getItem("itr6type") === "bill" ?
                                            parseFloat(localStorage.getItem("itr6value")).toFixed(2)
                                            :
                                            parseFloat(user.tliter * parseFloat(localStorage.getItem("itr6value"))).toFixed(2)
                                  }
                                </td>
                              </>
                              :
                              <td className={'thsmallhide'}>{0}</td>
                          }

                          <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>
                            {
                              user.flag === "oldbill" ?
                                (user.vah ? parseFloat(user.vah).toFixed(2) : 0) :
                                parseFloat(
                                  (
                                    (user.vah2 && user.mhliter ? user.vah2 * user.mhliter : 0) +
                                    (user.gayvah && user.gayliter ? user.gayvah * user.gayliter : 0)
                                  ).toFixed(2)
                                )
                            }
                          </td>
                          <td className={showthevcol === "Yes" ? 'thsmall' : 'thsmallhide'}>
                            {
                              user.flag === "oldbill" ?
                                (user.comm ? parseFloat(user.comm).toFixed(2) : 0) :
                                parseFloat(
                                  (
                                    (user.mhcomm && user.mhliter ? user.mhcomm * user.mhliter : 0) +
                                    (user.gaycomm && user.gayliter ? user.gaycomm * user.gayliter : 0)
                                  ).toFixed(2)
                                )
                            }
                          </td>
                          <td className='thsmall2'>
                            {
                              user.flag === "oldbill" ?
                                (user.adacalculated != null && !isNaN(user.adacalculated)) ? parseFloat(user.adacalculated).toFixed(localStorage.getItem("round") === "on" ? 0 : 2) : (user.ada ? parseFloat(user.ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2) : 0) :
                                (user.adacalculated != null && !isNaN(user.adacalculated)) ? parseFloat(user.adacalculated).toFixed(localStorage.getItem("round") === "on" ? 0 : 2) : user.bill
                                  ?
                                  parseFloat(parseFloat(user.bill)
                                    -
                                    allthevtofixedall
                                    + parseFloat(user.vah2 && user.mhliter ? parseFloat(user.vah2 * user.mhliter) : 0)
                                    + parseFloat(user.gayvah && user.gayliter ? parseFloat(user.gayvah * user.gayliter) : 0)
                                    + parseFloat(user.mhcomm && user.mhliter ? parseFloat(user.mhcomm * user.mhliter) : 0)
                                    + parseFloat(user.gaycomm && user.gayliter ? parseFloat(user.gaycomm * user.gayliter) : 0)
                                    - parseFloat(localStorage.getItem("autocutting") === "on" ? khedit : 0)
                                    - parseFloat(localStorage.getItem("autocutting") === "on" ? advedit : 0)
                                    - parseFloat(localStorage.getItem("autocutting") === "on" ? ratibedit : 0)
                                    - parseFloat(karjedit)
                                    - parseFloat(karjintr)
                                    - parseFloat(localStorage.getItem("autocutting") === "on" ? sanghedit : 0)
                                    - parseFloat(bhishiedit)
                                    - parseFloat((user.ikapatliter2 && user.tliter ? parseFloat(user.ikapatliter2 * user.tliter) : 0) + parseFloat((user.ikapatbill2 ? parseFloat(user.ikapatbill2) : 0)))
                                  ).toFixed(localStorage.getItem("round") === "on" ? 0 : 2) : 0
                            }
                          </td>
                          {DataSource && DataSource.length === 0 ?
                            '' :
                            DataSource[0].flag === "oldbill" ?
                              input.knofrom === input.knoto ?
                                DataSource && DataSource.length === 1 ?
                                  <td><UilRefresh onClick={() => { handleDeletesingle() }} className="ic2" /></td>
                                  : ''
                                : ''
                              : ''
                          }

                        </tr>
                      );
                    }
                    )
                }


              </tbody>

            </table>
          </div>
        </div>
      </div>

    </>
  )
}

export default Bill
